<template>
  <div class="reservation-page">
  <simple-tahsilat-odeme-dialog
    ref="simpleTahsilatOdemeDialog"
    @saved="onSimplePaymentSaved"
  ></simple-tahsilat-odeme-dialog>
  <v-dialog v-model="loadingvmodel" persistent width="300">
  <v-card color="primary" dark>
    <v-card-text>
      {{ $t('Please-Wait') }}
      <v-progress-linear
        indeterminate
        color="white"
        class="mb-0"
      ></v-progress-linear>
    </v-card-text>
  </v-card>
</v-dialog>
    <!-- LIST PAGE -->
    <div v-if="!detailMode">
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar dark color="info" class="reservation-toolbar">
            <v-toolbar-title>{{ $t('Reservation-List') }}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              class="add-pnr-btn"
              @click="addPnr"
            >
              <v-icon left>add</v-icon>
              {{ $t('Add-New-Reservation') }}
            </v-btn>
          </v-toolbar>
        </v-flex>

        <v-flex xs12>
          <v-card flat class="reservation-card">
            <v-card-text class="filter-wrapper">
              <v-layout row wrap align-center>
                <v-flex xs12 sm6 md2>
                  <tarihim
                    :etiket="$t('Start-Date')"
                    v-model="startDateFilter"
                    :detaygizle="false"
                    :defaultvalue="'ok'"
                    class="date-filter"
                  ></tarihim>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <tarihim
                    :etiket="$t('End-Date')"
                    v-model="endDateFilter"
                    :detaygizle="false"
                    :defaultvalue="'ok'"
                    class="date-filter"
                  ></tarihim>
                </v-flex>

                <v-flex xs12 sm2 md1 class="pl-2">
                  <v-btn color="info" fab small  dark :loading="loadingvmodel" :disabled="loadingvmodel" @click="applyDateFilter">
                <v-icon>search</v-icon>
                  </v-btn>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <v-text-field
                    v-model="search"
                    solo
                    hide-details
                    :label="$t('Search-PNR-or-customer')"
                    class="search-field"
                  />
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-select
  v-model="statusFilter"
  :items="translatedStatusList"
  item-text="text"
  item-value="value"
  solo
  hide-details
  :label="$t('All-Statuses')"
  class="status-field"
/>
                </v-flex>
                <v-flex xs12 class="reservation-count-wrap">
  <v-chip small label class="reservation-count-chip">
    {{ reservationCountText }}
  </v-chip>
</v-flex>
              </v-layout>
            </v-card-text>

            <v-data-table
              :headers="headers"
              :items="filteredReservations"
              hide-actions
              class="reservation-table"
            >
              <template slot="items" slot-scope="props">
                <tr :class="{ 'closed-reservation-row': props.item.isClosed }">
                 <td class="pnr-code-cell">
  <div class="pnr-list-cell-wrap">
    <a href="javascript:void(0)" class="pnr-link">
      {{ props.item.displayPnr || props.item.takipNo || props.item.pnr || '-' }}
    </a>

    <v-tooltip top v-if="props.item.isInvoiced">
      <v-icon
        slot="activator"
        small
        class="list-invoice-icon"
      >
        receipt
      </v-icon>

      <span>
        {{ $t('Invoiced') }}
        <span v-if="props.item.invoiceText">
          - {{ props.item.invoiceText }}
        </span>
      </span>
    </v-tooltip>
  </div>
</td>

                  <td>{{ props.item.customer }}</td>

                  <td>{{ props.item.travelDate || '-' }}</td>

                  <td>
                    <v-chip
                      small
                      label
                      :class="getStatusClass(props.item.status)"
                    >
                      {{ $t(props.item.status) }}
                    </v-chip>
                  </td>

                  <td>
                    <v-chip
                      small
                      label
                      :class="getPaymentClass(props.item.payment)"
                    >
                      {{ $t(props.item.payment) }}
                    </v-chip>
                  </td>

                  <td class="gross-cell money-cell">
  <v-chip small label class="money-chip">
    {{ props.item.currency }} {{ formatPrice(props.item.total) }}
  </v-chip>
</td>

                  <td class="text-xs-center">
                   <v-btn
  icon
  small
  :disabled="props.item.isClosed || loadingvmodel"
  @click="openReservationDetailSafe(props.item)"
>
  <v-icon :color="props.item.isClosed ? 'grey lighten-1' : 'blue-grey lighten-1'">
    edit
  </v-icon>
</v-btn>

<v-btn
  icon
  small
  :disabled="props.item.isClosed || loadingvmodel"
  @click="duplicateReservation(props.item)"
>
  <v-icon :color="props.item.isClosed ? 'grey lighten-1' : 'indigo lighten-1'">
    content_copy
  </v-icon>
</v-btn>

<v-btn
  icon
  small
  :disabled="props.item.isClosed || loadingvmodel"
  @click="closePnrFromList(props.item)"
>
  <v-icon :color="props.item.isClosed ? 'grey lighten-1' : 'red lighten-1'">
    lock
  </v-icon>
</v-btn>
                  </td>
                </tr>
              </template>

              <template slot="no-data">
                <div class="text-xs-center pa-4 grey--text">
                  {{ $t('No-records-found-yet') }}
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </div>

    <!-- DETAIL PAGE -->
    <div v-else-if="selectedReservation">
      <div class="detail-page">
        <div class="detail-hero">
  <div class="detail-hero-left">
    <v-btn icon flat class="detail-hero-back" @click="closeReservationDetail">
      <v-icon>arrow_back</v-icon>
    </v-btn>

    <div class="detail-hero-main">
      <div class="detail-hero-eyebrow">
        {{ $t('Reservation-Detail') }}
      </div>

      <div class="detail-hero-title-row">
        <div class="detail-hero-pnr">
          #{{ selectedReservation.pnr }}
        </div>

        <v-chip
          small
          label
          :class="getStatusClass(selectedReservation.status)"
          class="detail-hero-chip"
        >
          {{ $t(selectedReservation.status) }}
        </v-chip>

        <v-chip
          small
          label
          :class="getPaymentClass(selectedReservation.payment)"
          class="detail-hero-chip"
        >
          {{ $t(selectedReservation.payment) }}
        </v-chip>

        <v-chip
  v-if="selectedReservation.isInvoiced"
  small
  label
  class="detail-hero-chip invoice-status-chip"
  :title="$t('This-reservation-has-been-invoiced')"
>
  <v-icon small left>receipt</v-icon>
  {{ $t('Invoiced') }}
  <span v-if="selectedReservation.invoiceText">
    - {{ selectedReservation.invoiceText }}
  </span>
</v-chip>
      </div>

      <div class="detail-hero-customer">
        <v-icon small>business</v-icon>
        <span>{{ selectedReservation.customer || '-' }}</span>
      </div>
    </div>
  </div>

  <div class="detail-hero-actions">
    <v-menu offset-y left>
      <v-btn
        slot="activator"
        icon
        outline
        class="detail-hero-more-btn"
        :disabled="loadingvmodel"
        :title="simpleInvoiceDeleteTexts.moreActions"
      >
        <v-icon>more_vert</v-icon>
      </v-btn>

      <v-list class="detail-hero-menu-list">
        <v-list-tile
          :disabled="loadingvmodel"
          @click="goToInvoicePage"
        >
          <v-list-tile-action>
            <v-icon>description</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('Invoice') }}</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          :disabled="simpleInvoiceDraftDeleteLoading || loadingvmodel"
          @click="deleteSimpleInvoiceDraft"
        >
          <v-list-tile-action>
            <v-icon color="error">delete_outline</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="error--text">
            {{ simpleInvoiceDeleteTexts.label }}
          </v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          :disabled="generalVoucherLoading || loadingvmodel"
          @click="openGeneralVoucherDialog"
        >
          <v-list-tile-action>
            <v-icon>description</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('General-Voucher') }}</v-list-tile-title>
        </v-list-tile>

        <v-list-tile
          :disabled="loadingvmodel"
          @click="editSelectedPnr"
        >
          <v-list-tile-action>
            <v-icon>edit</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('Edit-Reservation') }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-btn
      color="success"
      class="detail-hero-action-btn"
      :loading="loadingvmodel"
      :disabled="loadingvmodel"
      @click="saveSelectedReservationToBackend"
    >
      <v-icon left small>save</v-icon>
      {{ $t('Save-Reservation') }}
    </v-btn>
  </div>
</div>

        <v-layout row wrap class="summary-cards">
          <v-flex xs12 md7 class="summary-col">
            <v-card flat class="summary-card grouped-summary-card summary-card-colored summary-card--financial">
              <div class="group-card-title">
  <v-icon small class="mr-1">account_balance_wallet</v-icon>
  {{ $t('Financial-Summary') }}
</div>

              <div class="summary-grid-5">
                <div class="summary-mini-box">
                  <div class="summary-label">{{ $t('Net-Total') }}</div>
                  <div class="summary-value">
                    {{ activeCurrency }} {{ formatPrice(reservationNetTotal) }}
                  </div>
                </div>

                <div class="summary-mini-box">
                  <div class="summary-label">{{ $t('VAT') }}</div>
                  <div class="summary-value">
                    {{ activeCurrency }} {{ formatPrice(reservationVatTotal) }}
                  </div>
                </div>

                <div class="summary-mini-box">
                  <div class="summary-label">{{ $t('Gross-Total') }}</div>
                  <div class="summary-value gross-green">
                    {{ activeCurrency }} {{ formatPrice(reservationGrossTotal) }}
                  </div>
                </div>

                <div class="summary-mini-box">
                  <div class="summary-label">{{ $t('Remaining-Balance') }}</div>
                  <div class="summary-value">
                    {{ activeCurrency }} {{ formatPrice(simpleRemainingBalance) }}
                  </div>
                </div>

                <div class="summary-mini-box">
                  <div class="summary-label">{{ $t('Payment') }}</div>
                  <div class="summary-value summary-payment-status">
                    <v-chip
                      small
                      label
                      :class="getPaymentClass(simplePaymentStatus)"
                    >
                      {{ $t(simplePaymentStatus) }}
                    </v-chip>
                  </div>
                </div>
              </div>
            </v-card>
          </v-flex>

          <v-flex xs12 md5 class="summary-col">
            <v-card flat class="summary-card grouped-summary-card summary-card-colored summary-card--travel">
              <div class="group-card-title">
  <v-icon small class="mr-1">date_range</v-icon>
  {{ $t('Travel-Dates') }}
</div>

              <div class="summary-grid-2">
                <div class="summary-mini-box">
                  <div class="summary-label">{{ $t('Travel-Dates') }}</div>
                  <div class="summary-date">
                    {{ displayDateLong(selectedReservation.travelFrom) }}
                  </div>
                </div>

                <div class="summary-mini-box">
                  <div class="summary-label">{{ $t('Travel-Dates') }}</div>
                  <div class="summary-date">
                    {{ displayDateLong(selectedReservation.travelTo) }}
                  </div>
                </div>
              </div>
            </v-card>
          </v-flex>
        </v-layout>

        <!-- PASSENGERS -->
        <v-card flat class="service-block passenger-block service-block-colored service-block--passengers">
          <div class="service-block-header">
            <div class="service-block-title-wrap">
              <v-icon class="service-block-icon">people</v-icon>
              <span class="service-block-title">{{ $t('Passengers') }}</span>
              <span class="service-count">{{ passengerCount }}</span>
            </div>

            <v-menu offset-y>
  <v-btn
    slot="activator"
    color="primary"
    class="service-add-btn"
  >
    <v-icon left>add</v-icon>
    {{ $t('Add-Passenger') }}
  </v-btn>

  <v-list>
    <v-list-tile @click="openMainPassengerDialog">
      <v-list-tile-action>
        <v-icon>person_add</v-icon>
      </v-list-tile-action>
      <v-list-tile-title>{{ $t('Add-New-Person') }}</v-list-tile-title>
    </v-list-tile>

    <v-list-tile @click="openAdresDefteriSec">
      <v-list-tile-action>
        <v-icon>contacts</v-icon>
      </v-list-tile-action>
      <v-list-tile-title>{{ $t('Select-From-Address-Book') }}</v-list-tile-title>
    </v-list-tile>
  </v-list>
</v-menu>
          </div>

          <div
            v-if="
              selectedReservation.passengers &&
              selectedReservation.passengers.length
            "
          >
            <table class="detail-table">
              <thead>
                <tr>
                  <th>{{ $t('Type') }}</th>
                  <th>{{ $t('Name') }}</th>
                  <th>{{ $t('Birth-Date') }}</th>
                  <th>{{ $t('Phone') }}</th>
                  <th>{{ $t('Email') }}</th>
                  <th>{{ $t('Actions') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(passenger, index) in selectedReservation.passengers"
                  :key="'main-passenger-' + index"
                >
                  <td>{{ getPassengerTypeText(passenger.kisiTipi) }}</td>
                  <td>{{ passenger.firstName }} {{ passenger.lastName }}</td>
                  <td>{{ displayBirthDateWithAge(passenger.birthDate) }}</td>
                  <td>{{ passenger.phone || '-' }}</td>
                  <td>{{ passenger.email || '-' }}</td>
                  <td class="detail-action-cell">
                    <v-btn icon small @click="editMainPassenger(index)">
                      <v-icon color="blue-grey lighten-1">edit</v-icon>
                    </v-btn>

                    <v-btn icon small @click="removeMainPassenger(index)">
                      <v-icon color="red lighten-1">delete_outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else class="service-empty">
            {{ $t('Please-add-passenger-information-before-adding-services') }}
          </div>
        </v-card>

        <!-- REORDERABLE / COLLAPSIBLE SERVICE BLOCKS -->
        <draggable
  v-model="serviceSectionOrder"
  tag="div"
  class="service-sections-wrap"
  handle=".drag-handle"
  :animation="200"
>
  <div
    v-for="section in serviceSectionOrder"
    :key="'wrap-' + section"
  >
    <!-- FLIGHTS -->
    <v-card
      flat
      class="service-block service-block-colored service-block--flights"
      v-if="section === 'flights'"
    >
      <div class="service-block-header">
        <div
          class="service-block-title-wrap"
          style="cursor:pointer"
          @click="toggleServiceSection(section)"
        >
          <v-icon small class="mr-2 drag-handle" style="cursor:grab">drag_indicator</v-icon>
          <v-icon class="service-block-icon">flight</v-icon>
          <span class="service-block-title">{{ $t('Flights') }}</span>
          <span class="service-count">{{ selectedReservation.flights.length }}</span>
          <v-icon small class="ml-2">
            {{ serviceSectionOpen[section] ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </v-icon>
        </div>

        <div class="d-flex align-center">
          <v-btn
            outlined
            small
            class="mr-2"
            :loading="flightVoucherLoading"
            :disabled="flightVoucherLoading"
            @click.stop="openServiceVoucherDialog('flights')"
          >
            <v-icon left small>description</v-icon>
            {{ $t('Voucher-PDF') }}
          </v-btn>

          <v-btn
            color="primary"
            class="service-add-btn"
            :disabled="!canAddServiceItems"
            @click.stop="openFlightDialog(selectedReservation)"
          >
            <v-icon left>add</v-icon>
            {{ $t('Add') }}
          </v-btn>
        </div>
      </div>

      <div v-show="serviceSectionOpen[section]">
        <div v-if="selectedReservation.flights.length">
          <table class="detail-table">
            <thead>
              <tr>
                <th>{{ $t('Route') }}</th>
                <th>{{ $t('Date') }}</th>
                <th>{{ $t('Airline') }}</th>
                <th>{{ $t('Passengers') }}</th>
                <th class="gross-header">{{ $t('Gross') }}</th>
                <th>{{ $t('Actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(flight, index) in selectedReservation.flights" :key="'flight-' + index">
                <td>{{ flight.from }} → {{ flight.to }}</td>
                <td>{{ displayDateShort(flight.departureDate) }}</td>
                <td>
                  {{ flight.satici.kod }} {{ flight.flightNumber }}
                  <div v-if="flight.airlinePnr" class="sub-info-text">
                    {{ $t('PNR') }}: {{ flight.airlinePnr }}
                  </div>
                </td>
                <td>
  <div v-if="flight.passengers && flight.passengers.length">
    <div
      v-for="(p, i) in flight.passengers"
      :key="'flight-passenger-' + i"
      class="service-passenger-line"
    >
      {{ getPassengerTypeText(p.kisiTipi) }} - {{ p.firstName }} {{ p.lastName }}
    </div>
  </div>
  <div v-else>-</div>
</td>
                <td class="money-cell gross-cell">
  <v-chip small label class="money-chip">
    {{ selectedReservation.currency }} {{ formatPrice(flight.grossPrice) }}
  </v-chip>
</td>
                <td class="detail-action-cell">
                  <v-btn icon small @click="editFlight(index)">
                    <v-icon color="blue-grey lighten-1">edit</v-icon>
                  </v-btn>
                  <v-btn icon small @click.stop="duplicateServiceItem('flights', index)">
  <v-icon color="indigo lighten-1">content_copy</v-icon>
</v-btn>
                  <v-btn icon small @click="removeFlight(index)">
                    <v-icon color="red lighten-1">delete_outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else class="service-empty">
          {{ $t('No-flights-added-yet') }}
        </div>
      </div>
    </v-card>

    <!-- HOTELS -->
    <v-card
      flat
      class="service-block service-block-colored service-block--hotels"
      v-else-if="section === 'hotels'"
    >
      <div class="service-block-header">
        <div
          class="service-block-title-wrap"
          style="cursor:pointer"
          @click="toggleServiceSection(section)"
        >
          <v-icon small class="mr-2 drag-handle" style="cursor:grab">drag_indicator</v-icon>
          <v-icon class="service-block-icon">hotel</v-icon>
          <span class="service-block-title">{{ $t('Hotels') }}</span>
          <span class="service-count">{{ selectedReservation.hotels.length }}</span>
          <v-icon small class="ml-2">
            {{ serviceSectionOpen[section] ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </v-icon>
        </div>

        <div class="d-flex align-center">
          <v-btn
  outlined
  small
  class="mr-2"
  :loading="serviceVoucherLoading && serviceVoucherSection === 'hotels'"
  :disabled="serviceVoucherLoading"
  @click.stop="openServiceVoucherDialog('hotels')"
>
            <v-icon left small>description</v-icon>
            {{ $t('Voucher-PDF') }}
          </v-btn>

          <v-btn
            color="primary"
            class="service-add-btn"
            :disabled="!canAddServiceItems"
            @click.stop="openHotelDialog(selectedReservation)"
          >
            <v-icon left>add</v-icon>
            {{ $t('Add') }}
          </v-btn>
        </div>
      </div>

      <div v-show="serviceSectionOpen[section]">
        <div v-if="selectedReservation.hotels.length">
          <table class="detail-table">
            <thead>
              <tr>
                <th>{{ $t('Hotel') }}</th>
                <th>{{ $t('City') }}</th>
                <th>{{ $t('Room-Type') }}</th>
                <th>{{ $t('Board-Type') }}</th>
                <th>{{ $t('Dates') }}</th>
                <th>{{ $t('Guest') }}</th>
                <th class="gross-header">{{ $t('Gross') }}</th>
                <th>{{ $t('Actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(hotel, index) in selectedReservation.hotels" :key="'hotel-' + index">
                <td>{{ hotel.satici.kod }}</td>
                <td>{{ hotel.city }}</td>
                <td>{{ getHotelRoomTypeName(hotel.roomType) || '-' }}</td>
                <td>{{ hotel.boardType || '-' }}</td>
                <td>{{ displayDateShort(hotel.checkIn) }} - {{ displayDateShort(hotel.checkOut) }}</td>
                <td>
  <div v-if="hotel.passengers && hotel.passengers.length">
    <div
      v-for="(p, i) in hotel.passengers"
      :key="'hotel-passenger-' + i"
      class="service-passenger-line"
    >
      {{ getPassengerTypeText(p.kisiTipi) }} - {{ p.firstName }} {{ p.lastName }}
    </div>
  </div>
  <div v-else>-</div>
</td>
                <td class="money-cell gross-cell">
  <v-chip small label class="money-chip">
    {{ selectedReservation.currency }} {{ formatPrice(hotel.grossPrice) }}
  </v-chip>
</td>
                <td class="detail-action-cell">
                  <v-btn icon small @click="editHotel(index)">
                    <v-icon color="blue-grey lighten-1">edit</v-icon>
                  </v-btn>
                  <v-btn icon small @click.stop="duplicateServiceItem('hotels', index)">
  <v-icon color="indigo lighten-1">content_copy</v-icon>
</v-btn>
                  <v-btn icon small @click="removeHotel(index)">
                    <v-icon color="red lighten-1">delete_outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else class="service-empty">
          {{ $t('No-hotels-added-yet') }}
        </div>
      </div>
    </v-card>

    <!-- CRUISES -->
    <v-card
      flat
    class="service-block service-block-colored service-block--cruises"
      v-else-if="section === 'cruises'"
    >
      <div class="service-block-header">
        <div
          class="service-block-title-wrap"
          style="cursor:pointer"
          @click="toggleServiceSection(section)"
        >
          <v-icon small class="mr-2 drag-handle" style="cursor:grab">drag_indicator</v-icon>
          <v-icon class="service-block-icon">directions_boat</v-icon>
          <span class="service-block-title">{{ $t('Cruises') }}</span>
          <span class="service-count">{{ (selectedReservation.cruises || []).length }}</span>
          <v-icon small class="ml-2">
            {{ serviceSectionOpen[section] ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </v-icon>
        </div>

        <div class="d-flex align-center">
          <v-btn
  outlined
  small
  class="mr-2"
  :loading="serviceVoucherLoading && serviceVoucherSection === 'cruises'"
  :disabled="serviceVoucherLoading"
  @click.stop="openServiceVoucherDialog('cruises')"
>
  <v-icon left small>description</v-icon>
  {{ $t('Voucher-PDF') }}
</v-btn>

          <v-btn
            color="primary"
            class="service-add-btn"
            :disabled="!canAddServiceItems"
            @click.stop="openCruiseDialog(selectedReservation)"
          >
            <v-icon left>add</v-icon>
            {{ $t('Add') }}
          </v-btn>
        </div>
      </div>

      <div v-show="serviceSectionOpen[section]">
        <div v-if="selectedReservation.cruises && selectedReservation.cruises.length">
          <table class="detail-table">
            <thead>
              <tr>
                <th>{{ $t('Supplier') }}</th>
                <th>{{ $t('Tour-Operator') }}</th>
                <th>{{ $t('Ship-Cruise') }}</th>
                <th>{{ $t('Dates') }}</th>
                <th>{{ $t('Guest') }}</th>
                <th class="gross-header">{{ $t('Gross') }}</th>
                <th>{{ $t('Actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cruise, index) in selectedReservation.cruises" :key="'cruise-' + index">
                <td>{{ cruise.satici.kod }}</td>
                <td>{{ cruise.tourOperator.kod }} - {{ cruise.tourOperator.isim }}</td>
                <td>{{ cruise.hotelName || '-' }}</td>
                <td>{{ displayDateShort(cruise.checkIn) }} - {{ displayDateShort(cruise.checkOut) }}</td>
                <td>
                  <span v-if="cruise.guestFirstName || cruise.guestLastName">
                    {{ cruise.guestFirstName }} {{ cruise.guestLastName }}
                  </span>
                  <span v-else>
  <div v-if="cruise.passengers && cruise.passengers.length">
    <div
      v-for="(p, i) in cruise.passengers"
      :key="'cruise-passenger-' + i"
      class="service-passenger-line"
    >
      {{ getPassengerTypeText(p.kisiTipi) }} - {{ p.firstName }} {{ p.lastName }}
    </div>
  </div>
  <div v-else>-</div>
</span>
                </td>
                <td class="money-cell gross-cell">
  <v-chip small label class="money-chip">
    {{ selectedReservation.currency }} {{ formatPrice(cruise.grossPrice) }}
  </v-chip>
</td>
                <td class="detail-action-cell">
                  <v-btn icon small @click="editCruise(index)">
                    <v-icon color="blue-grey lighten-1">edit</v-icon>
                  </v-btn>
                  <v-btn icon small @click.stop="duplicateServiceItem('cruises', index)">
  <v-icon color="indigo lighten-1">content_copy</v-icon>
</v-btn>
                  <v-btn icon small @click="removeCruise(index)">
                    <v-icon color="red lighten-1">delete_outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else class="service-empty">
          {{ $t('No-cruises-added-yet') }}
        </div>
      </div>
    </v-card>

    <!-- CARS -->
    <v-card
      flat
      class="service-block service-block-colored service-block--cars"
      v-else-if="section === 'cars'"
    >
      <div class="service-block-header">
        <div
          class="service-block-title-wrap"
          style="cursor:pointer"
          @click="toggleServiceSection(section)"
        >
          <v-icon small class="mr-2 drag-handle" style="cursor:grab">drag_indicator</v-icon>
          <v-icon class="service-block-icon">directions_car</v-icon>
          <span class="service-block-title">{{ $t('Car-Rentals') }}</span>
          <span class="service-count">{{ selectedReservation.cars.length }}</span>
          <v-icon small class="ml-2">
            {{ serviceSectionOpen[section] ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </v-icon>
        </div>

        <div class="d-flex align-center">
          <v-btn
  outlined
  small
  class="mr-2"
  :loading="serviceVoucherLoading && serviceVoucherSection === 'cars'"
  :disabled="serviceVoucherLoading"
  @click.stop="openServiceVoucherDialog('cars')"
>
  <v-icon left small>description</v-icon>
  {{ $t('Voucher-PDF') }}
</v-btn>

          <v-btn
            color="primary"
            class="service-add-btn"
            :disabled="!canAddServiceItems"
            @click.stop="openCarDialog(selectedReservation)"
          >
            <v-icon left>add</v-icon>
            {{ $t('Add') }}
          </v-btn>
        </div>
      </div>

      <div v-show="serviceSectionOpen[section]">
        <div v-if="selectedReservation.cars.length">
          <table class="detail-table">
            <thead>
              <tr>
                <th>{{ $t('Company') }}</th>
                <th>{{ $t('Pickup') }}</th>
                <th>{{ $t('Dropoff') }}</th>
                <th>{{ $t('Passenger-Name') }}</th>
                <th class="gross-header">{{ $t('Gross') }}</th>
                <th>{{ $t('Actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(car, index) in selectedReservation.cars" :key="'car-' + index">
                <td>{{ car.satici.kod }}</td>
                <td>{{ car.pickupLocation }}</td>
                <td>{{ car.dropoffLocation || '-' }}</td>
                <td>
  <div v-if="car.passengers && car.passengers.length">
    <div
      v-for="(p, i) in car.passengers"
      :key="'car-passenger-' + i"
      class="service-passenger-line"
    >
      {{ getPassengerTypeText(p.kisiTipi) }} - {{ p.firstName }} {{ p.lastName }}
    </div>
  </div>
  <div v-else>-</div>
</td>
                <td class="money-cell gross-cell">
  <v-chip small label class="money-chip">
    {{ selectedReservation.currency }} {{ formatPrice(car.grossPrice) }}
  </v-chip>
</td>
                <td class="detail-action-cell">
                  <v-btn icon small @click="editCar(index)">
                    <v-icon color="blue-grey lighten-1">edit</v-icon>
                  </v-btn>
                  <v-btn icon small @click.stop="duplicateServiceItem('cars', index)">
  <v-icon color="indigo lighten-1">content_copy</v-icon>
</v-btn>
                  <v-btn icon small @click="removeCar(index)">
                    <v-icon color="red lighten-1">delete_outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else class="service-empty">
         {{ $t('No-car-rentals-added-yet') }}
        </div>
      </div>
    </v-card>

    <!-- TRANSFERS -->
    <v-card
      flat
      class="service-block service-block-colored service-block--transfers"
      v-else-if="section === 'transfers'"
    >
      <div class="service-block-header">
        <div
          class="service-block-title-wrap"
          style="cursor:pointer"
          @click="toggleServiceSection(section)"
        >
          <v-icon small class="mr-2 drag-handle" style="cursor:grab">drag_indicator</v-icon>
          <v-icon class="service-block-icon">swap_horiz</v-icon>
          <span class="service-block-title">{{ $t('Transfers2') }}</span>
          <span class="service-count">{{ selectedReservation.transfers.length }}</span>
          <v-icon small class="ml-2">
            {{ serviceSectionOpen[section] ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </v-icon>
        </div>

        <div class="d-flex align-center">
          <v-btn
  outlined
  small
  class="mr-2"
  :loading="serviceVoucherLoading && serviceVoucherSection === 'transfers'"
  :disabled="serviceVoucherLoading"
  @click.stop="openServiceVoucherDialog('transfers')"
>
  <v-icon left small>description</v-icon>
  {{ $t('Voucher-PDF') }}
</v-btn>

          <v-btn
            color="primary"
            class="service-add-btn"
            :disabled="!canAddServiceItems"
            @click.stop="openTransferDialog(selectedReservation)"
          >
            <v-icon left>add</v-icon>
            {{ $t('Add') }}
          </v-btn>
        </div>
      </div>

      <div v-show="serviceSectionOpen[section]">
        <div v-if="selectedReservation.transfers.length">
          <table class="detail-table">
            <thead>
              <tr>
                <th>{{ $t('Route') }}</th>
                <th>{{ $t('Transfer-Company') }}</th>
                <th>{{ $t('Date') }}</th>
                <th>{{ $t('Type') }}</th>
                <th>{{ $t('Driver') }}</th>
                <th class="gross-header">{{ $t('Gross') }}</th>
                <th>{{ $t('Actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(transfer, index) in selectedReservation.transfers" :key="'transfer-' + index">
                <td>{{ transfer.from }} → {{ transfer.to }}</td>
                <td>
                  {{ transfer.satici.kod || '-' }}
                  <div v-if="transfer.tourOperator" class="sub-info-text">
                    {{ $t('Tour-Operator') }}: {{ transfer.tourOperator.kod }}
                  </div>
                </td>
                <td>{{ displayDateShort(transfer.date) }}</td>
                <td>{{ transfer.type }}</td>
                <td>
                  {{ transfer.driverName || '-' }}
                  <div v-if="transfer.plateNumber" class="sub-info-text">
                    {{ $t('Plate') }}: {{ transfer.plateNumber }}
                  </div>
                </td>
                <td class="money-cell gross-cell">
  <v-chip small label class="money-chip">
    {{ selectedReservation.currency }} {{ formatPrice(transfer.grossPrice) }}
  </v-chip>
</td>
                <td class="detail-action-cell">
                  <v-btn icon small @click="editTransfer(index)">
                    <v-icon color="blue-grey lighten-1">edit</v-icon>
                  </v-btn>
                  <v-btn icon small @click.stop="duplicateServiceItem('transfers', index)">
  <v-icon color="indigo lighten-1">content_copy</v-icon>
</v-btn>
                  <v-btn icon small @click="removeTransfer(index)">
                    <v-icon color="red lighten-1">delete_outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else class="service-empty">
          {{ $t('No-transfers-added-yet') }}
        </div>
      </div>
    </v-card>

    <!-- DAILY TOURS -->
    <v-card
      flat
       class="service-block service-block-colored service-block--dailyTours"
      v-else-if="section === 'dailyTours'"
    >
      <div class="service-block-header">
        <div
          class="service-block-title-wrap"
          style="cursor:pointer"
          @click="toggleServiceSection(section)"
        >
          <v-icon small class="mr-2 drag-handle" style="cursor:grab">drag_indicator</v-icon>
          <v-icon class="service-block-icon">event</v-icon>
          <span class="service-block-title">{{ $t('Daily-Tours') }}</span>
          <span class="service-count">{{ selectedReservation.dailyTours.length }}</span>
          <v-icon small class="ml-2">
            {{ serviceSectionOpen[section] ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </v-icon>
        </div>

        <div class="d-flex align-center">
          <v-btn
  outlined
  small
  class="mr-2"
  :loading="serviceVoucherLoading && serviceVoucherSection === 'dailyTours'"
  :disabled="serviceVoucherLoading"
  @click.stop="openServiceVoucherDialog('dailyTours')"
>
  <v-icon left small>description</v-icon>
  {{ $t('Voucher-PDF') }}
</v-btn>

          <v-btn
            color="primary"
            class="service-add-btn"
            :disabled="!canAddServiceItems"
            @click.stop="openDailyTourDialog(selectedReservation)"
          >
            <v-icon left>add</v-icon>
            {{ $t('Add') }}
          </v-btn>
        </div>
      </div>

      <div v-show="serviceSectionOpen[section]">
        <div v-if="selectedReservation.dailyTours.length">
          <table class="detail-table">
            <thead>
              <tr>
                <th>{{ $t('Supplier') }}</th>
                <th>{{ $t('Tour-Code') }}</th>
                <th>{{ $t('Tour-Name') }}</th>
                <th>{{ $t('Date') }}</th>
                <th>{{ $t('Time') }}</th>
                <th class="gross-header">{{ $t('Gross') }}</th>
                <th>{{ $t('Actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tour, index) in selectedReservation.dailyTours" :key="'tour-' + index">
                <td>{{ tour.satici.kod }}</td>
                <td>{{ tour.tourCode }}</td>
                <td>{{ tour.tourName }}</td>
                <td>{{ displayDateShort(tour.date) }}</td>
                <td>{{ tour.time || '-' }}</td>
                <td class="money-cell gross-cell">
  <v-chip small label class="money-chip">
    {{ selectedReservation.currency }} {{ formatPrice(tour.grossPrice) }}
  </v-chip>
</td>
                <td class="detail-action-cell">
                  <v-btn icon small @click="editDailyTour(index)">
                    <v-icon color="blue-grey lighten-1">edit</v-icon>
                  </v-btn>
                  <v-btn icon small @click.stop="duplicateServiceItem('dailyTours', index)">
  <v-icon color="indigo lighten-1">content_copy</v-icon>
</v-btn>
                  <v-btn icon small @click="removeDailyTour(index)">
                    <v-icon color="red lighten-1">delete_outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else class="service-empty">
          {{ $t('No-daily-tours-added-yet') }}
        </div>
      </div>
    </v-card>

    <!-- OTHERS -->
    <v-card
      flat
      class="service-block service-block-colored service-block--others"
      v-else-if="section === 'others'"
    >
      <div class="service-block-header">
        <div
          class="service-block-title-wrap"
          style="cursor:pointer"
          @click="toggleServiceSection(section)"
        >
          <v-icon small class="mr-2 drag-handle" style="cursor:grab">drag_indicator</v-icon>
          <v-icon class="service-block-icon">widgets</v-icon>
          <span class="service-block-title">{{ $t('Others') }}</span>
          <span class="service-count">{{ (selectedReservation.others || []).length }}</span>
          <v-icon small class="ml-2">
            {{ serviceSectionOpen[section] ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </v-icon>
        </div>

        <div class="d-flex align-center">
          <v-btn
  outlined
  small
  class="mr-2"
  :loading="serviceVoucherLoading && serviceVoucherSection === 'others'"
  :disabled="serviceVoucherLoading"
  @click.stop="openServiceVoucherDialog('others')"
>
  <v-icon left small>description</v-icon>
  {{ $t('Voucher-PDF') }}
</v-btn>

          <v-btn
            color="primary"
            class="service-add-btn"
            :disabled="!canAddServiceItems"
            @click.stop="openOtherDialog(selectedReservation)"
          >
            <v-icon left>add</v-icon>
            {{ $t('Add') }}
          </v-btn>
        </div>
      </div>

      <div v-show="serviceSectionOpen[section]">
        <div v-if="selectedReservation.others && selectedReservation.others.length">
          <table class="detail-table">
            <thead>
              <tr>
                <th>{{ $t('Supplier') }}</th>
                <th>{{ $t('Tour-Operator') }}</th>
                <th>{{ $t('Title') }}</th>
                <th>{{ $t('Dates') }}</th>
                <th>{{ $t('Description') }}</th>
                <th class="gross-header">{{ $t('Gross') }}</th>
                <th>{{ $t('Actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(other, index) in selectedReservation.others" :key="'other-' + index">
                <td>{{ other.satici.kod }}</td>
                <td>{{ other.tourOperator.kod || '-' }}</td>
                <td>{{ other.title || '-' }}</td>
                <td>{{ displayDateShort(other.startDate) }} - {{ displayDateShort(other.endDate) }}</td>
                <td>{{ other.description || '-' }}</td>
                <td class="money-cell gross-cell">
  <v-chip small label class="money-chip">
    {{ selectedReservation.currency }} {{ formatPrice(other.grossPrice) }}
  </v-chip>
</td>
                <td class="detail-action-cell">
                  <v-btn icon small @click="editOther(index)">
                    <v-icon color="blue-grey lighten-1">edit</v-icon>
                  </v-btn>
                  <v-btn icon small @click.stop="duplicateServiceItem('others', index)">
  <v-icon color="indigo lighten-1">content_copy</v-icon>
</v-btn>
                  <v-btn icon small @click="removeOther(index)">
                    <v-icon color="red lighten-1">delete_outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else class="service-empty">
          {{ $t('No-other-services-added-yet') }}
        </div>
      </div>
    </v-card>
  </div>
</draggable>

        <!-- TAHSILAT -->
        <v-card
          flat
          class="service-block service-block-colored service-block--payments"
        >
          <div class="service-block-header">
            <div
              class="service-block-title-wrap"
              style="cursor:pointer"
              @click="simplePaymentSectionOpen = !simplePaymentSectionOpen"
            >
              <v-icon class="service-block-icon">payment</v-icon>
              <span class="service-block-title">{{ $t('Collection') }}</span>
              <span class="service-count">{{ simplePayments.length }}</span>
              <v-icon small class="ml-2">
                {{ simplePaymentSectionOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              </v-icon>
            </div>

            <v-btn
              color="primary"
              class="service-add-btn"
              :disabled="!getSimplePaymentPnrNo() || simplePaymentLoading || simpleRemainingBalance <= 0.01"
              :loading="simplePaymentLoading"
              @click.stop="openSimplePaymentDialog"
            >
              <v-icon left>add</v-icon>
              {{ $t('Add') }}
            </v-btn>
          </div>

          <div v-show="simplePaymentSectionOpen">
            <div v-if="simplePayments.length">
              <table class="detail-table">
                <thead>
                  <tr>
                    <th>{{ $t('Document-No') }}</th>
                    <th>{{ $t('Document-Type') }}</th>
                    <th>{{ $t('Date') }}</th>
                    <th>{{ $t('Currency-Unit') }}</th>
                    <th class="gross-header">{{ $t('Amount') }}</th>
                    <th>{{ $t('Actions') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(payment, paymentIndex) in simplePayments"
                    :key="'simple-payment-' + paymentIndex"
                  >
                    <td>{{ payment.evrakNo || '-' }}</td>
                    <td>{{ payment.evrakTipi || '-' }}</td>
                    <td>{{ displayDateShort(payment.tarih) }}</td>
                    <td>{{ getSimplePaymentCurrency(payment) }}</td>
                    <td class="money-cell gross-cell">
                      <v-chip small label class="money-chip">
                        {{ getSimplePaymentCurrency(payment) }} {{ formatPrice(payment.dovizTutar) }}
                      </v-chip>
                    </td>
                    <td class="detail-action-cell">
                      <v-btn
                        icon
                        small
                        :disabled="simplePaymentLoading"
                        @click.stop="deleteSimplePayment(payment)"
                      >
                        <v-icon color="red lighten-1">delete_outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-else class="service-empty">
              {{ $t('No-records-found-yet') }}
            </div>
          </div>
        </v-card>
      </div>
    </div>

    <!-- PNR DIALOG -->
    <v-dialog v-model="dialog" max-width="1140" persistent>
      <v-card class="dialog-card">
        <v-card-title class="headline dialog-title">
          {{ isEditMode ? $t('Edit-Reservation') : $t('Add-New-Reservation') }}
        </v-card-title>

        <v-card-text>
  <v-layout row wrap class="pnr-form-layout">
    <!-- PNR -->
    <v-flex xs2 class="pnr-row-single">
      <v-text-field
  v-model="form.pnr"
  :label="$t('PNR')"
  disabled
  :placeholder="$t('Will-be-created-automatically')"
/>
    </v-flex>

    <!-- CUSTOMER / CARI -->
    <v-flex xs12 class="pnr-row-single customer-row">
      <caricomp
  :autofocuss="false"
  :Coper="true"
  :statecariyedek="statecari"
  :zorunlumu="true"
  @sendCurrentInfo="getCurrentInfo($event)"
  v-model="form.customerCode"
/>
    </v-flex>

    <!-- DATES -->
    <v-flex xs12 sm6 class="pr-sm-2">
      <div class="field-label-custom">{{ $t('Travel-Dates') }}</div>
      <v-menu
        v-model="fromDateMenu"
        :close-on-content-click="false"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <v-text-field
  slot="activator"
  :value="dateInputValue(form.travelFrom)"
  solo
  flat
  hide-details
  class="date-box-field"
  placeholder="dd.mm.yyyy"
  append-icon="event"
  maxlength="10"
  inputmode="numeric"
  @input="onDateInput('form', 'travelFrom', $event)"
  @blur="onDateBlur('form', 'travelFrom')"
/>
        <v-date-picker
          v-model="form.travelFrom"
          locale="en"
          no-title
          @input="fromDateMenu = false"
        />
      </v-menu>
    </v-flex>

    <v-flex xs12 sm6 class="pl-sm-2">
      <div class="field-label-custom">{{ $t('Travel-Dates') }}</div>
      <v-menu
        v-model="toDateMenu"
        :close-on-content-click="false"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <v-text-field
  slot="activator"
  :value="dateInputValue(form.travelTo)"
  solo
  flat
  hide-details
  class="date-box-field"
  placeholder="dd.mm.yyyy"
  append-icon="event"
  maxlength="10"
  inputmode="numeric"
  @input="onDateInput('form', 'travelTo', $event)"
  @blur="onDateBlur('form', 'travelTo')"
/>
        <v-date-picker
          v-model="form.travelTo"
          locale="en"
          no-title
          @input="toDateMenu = false"
        />
      </v-menu>
    </v-flex>

    <!-- STATUS / PAYMENT -->
    <v-flex xs12 sm6 class="pr-sm-2 mt-3">
      <v-select
  v-model="form.status"
  :items="translatedFormStatusList"
  item-text="text"
  item-value="value"
  :label="$t('Status')"
/>
    </v-flex>

    <v-flex xs12 sm6 class="pl-sm-2 mt-3">
      <v-select
  v-model="form.payment"
  :items="translatedFormPaymentList"
  item-text="text"
  item-value="value"
  :label="$t('Payment')"
  disabled
/>
    </v-flex>

    <!-- TOTAL / CURRENCY hidden for now -->
    <!--
    <v-flex xs12 sm6 class="pr-sm-2">
      <v-text-field
        v-model.number="form.total"
        label="Total"
        type="number"
        min="0"
      />
    </v-flex>

    <v-flex xs12 sm6 class="pl-sm-2">
      <v-select
        v-model="form.currency"
        :items="currencyList"
        label="Currency"
      />
    </v-flex>
    -->
  </v-layout>
</v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>

          <v-btn flat @click="closeDialog">
            {{ $t('Cancel') }}
          </v-btn>

          <v-btn
            color="primary"
            @click="saveReservationDialog"
          >
            {{ $t('Save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <adresdefterisec
  ref="adresdefterisec"
  @selected="onAdresDefteriPassengerSelected"
  @create-new="openMainPassengerDialog"
/>

    <!-- PASSENGER DETAIL DIALOG -->
    <v-dialog v-model="passengerDialog" max-width="820" persistent>
      <v-card class="dialog-card">
        <v-card-title class="headline service-dialog-title">
          {{ $t('Person-Information') }}
          <v-spacer></v-spacer>
          <v-btn icon flat small @click="closePassengerDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6 class="pr-sm-2">
              <v-select
                v-model="passengerForm.kisiTipi"
                :items="translatedPassengerTypeItems"
                item-text="text"
                item-value="value"
                :label="$t('Type')"
              />
            </v-flex>

            <v-flex xs12 sm6 class="pl-sm-2">
              <div class="field-label-custom">{{ $t('Birth-Date') }} *</div>
              <v-menu
                v-model="passengerBirthDateMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <v-text-field
  slot="activator"
  v-model="passengerBirthDateText"
  solo
  flat
  hide-details
  class="date-box-field"
  placeholder="dd.mm.yyyy"
  append-icon="event"
  maxlength="10"
  inputmode="numeric"
  @input="onPassengerBirthDateTextInput"
  @blur="setPassengerBirthDateFromText"
/>
                <v-date-picker
  v-model="passengerForm.birthDate"
  locale="tr"
  no-title
  @input="onPassengerBirthDatePicked"
/>
              </v-menu>
            </v-flex>

       <v-flex xs12 sm6 class="pr-sm-2">
  <v-text-field
    v-model="passengerForm.idNumber"
    :label="$t('Identitynumber_label')"
  />
</v-flex>

            <v-flex xs12 sm6 class="pl-sm-2">
              <v-select
                v-model="passengerForm.gender"
                :items="translatedGenderItems"
                item-text="text"
                item-value="value"
                :label="$t('Sex-v2')"
              />
            </v-flex>

            <v-flex xs12 sm6 class="pr-sm-2">
              <v-text-field
                v-model="passengerForm.firstName"
                :label="$t('Name')"
              />
            </v-flex>

            <v-flex xs12 sm6 class="pl-sm-2">
              <v-text-field
                v-model="passengerForm.lastName"
                :label="$t('Surname_label')"
              />
            </v-flex>

            <v-flex xs12 sm6 class="pr-sm-2">
              <phoneinput
    v-model="passengerForm.phone"
    :etiket="$t('Phone')"
    :label="$t('Phone')"
    :zorunlumu="false"
  />
            </v-flex>

            <v-flex xs12 sm6 class="pl-sm-2">
              <v-autocomplete
    v-model="passengerForm.nationality"
    :items="translatedCountryItems"
    item-text="text"
    item-value="value"
    :filter="countrySearchFilter"
    :label="$t('Nationality')"
    clearable
    hide-no-data
  />
            </v-flex>

            <v-flex xs12 sm6 class="pr-sm-2">
              <v-text-field
                v-model="passengerForm.email"
                :label="$t('Email')"
              />
            </v-flex>

            <v-flex xs12 sm6 class="pl-sm-2">
              <v-text-field
                v-model="passengerForm.passportNumber"
                :label="$t('Passport-Number')"
              />
            </v-flex>

            <v-flex xs12>
              <v-textarea
                v-model="passengerForm.address"
                :label="$t('Address_label')"
                rows="2"
                auto-grow
              />
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="closePassengerDialog">{{ $t('Cancel') }}</v-btn>
          <v-btn color="primary" @click="savePassengerDetails">{{ $t('Add-To-Passengers') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    
    <!-- FLIGHT DIALOG -->
<v-dialog v-model="flightDialog" max-width="1180" persistent>
  <v-card class="dialog-card">
    <v-card-title class="headline service-dialog-title">
      {{ $t('Add-Flight') }}
      <v-spacer></v-spacer>
      <v-btn icon flat small @click="closeFlightDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-layout row wrap>
        <!-- LEFT FORM -->
        <v-flex xs12 md9 class="service-form-main">
          <v-layout row wrap>
            <!-- Seller Code -->
            <v-flex xs12 sm4 class="pr-sm-2">
              <div class="seller-inline">
                <div class="seller-inline-input">
                  <genelarama
                    apiname="SaticiAra"
                    :tip="8"
                    :label="$t('Seller-Code') + ' *'"
                    v-model="flightForm.satici"
                  />
                </div>

                <div class="seller-inline-add">
                  <minisaticieklecomp
                    v-model="flightForm.satici"
                    :label="$t('Add-Airline-Seller')"
                    :saticiKod="8"
                  />
                </div>
              </div>
            </v-flex>

            <!-- Tour Operator -->
            <v-flex xs12 sm4 class="px-sm-2">
              <genelarama
                apiname="SaticiAra"
                :tip="12"
                :label="$t('Tour-Operator')"
                v-model="flightForm.tourOperator"
              />
            </v-flex>

            <!-- Flight Type -->
            <v-flex xs12 sm4 class="pl-sm-2">
              <v-select
                v-model="flightForm.flightType"
                :items="flightTypeList"
                :label="$t('Flight-Type')"
              />
            </v-flex>

            <!-- Booking Type -->
            <v-flex xs12 sm4 class="pr-sm-2">
              <v-select
                v-model="flightForm.bookingType"
                :items="flightBookingTypeList"
                :label="$t('Booking-Type')"
              />
            </v-flex>

            <!-- Class -->
            <v-flex xs12 sm4 class="px-sm-2">
              <v-select
                v-model="flightForm.classType"
                :items="flightClassList"
                :label="$t('Class')"
              />
            </v-flex>

            <!-- Airline PNR -->
            <v-flex xs12 sm4 class="pl-sm-2">
              <v-text-field
                v-model="flightForm.airlinePnr"
                :label="$t('Airline-PNR')"
              />
            </v-flex>

            <!-- Ticket Number -->
            <v-flex xs12 sm4 class="pr-sm-2">
              <v-text-field
                v-model="flightForm.ticketNumber"
                :label="$t('Ticket-Number')"
              />
            </v-flex>

            <!-- Flight Number -->
            <v-flex xs12 sm4 class="px-sm-2">
              <v-text-field
                v-model="flightForm.flightNumber"
                :label="$t('Flight-Number')"
              />
            </v-flex>

            <!-- From -->
<v-flex xs12 sm4 class="pl-sm-2">
  <v-autocomplete
    v-model="flightForm.from"
    :search-input.sync="flightFromSearch"
    :items="airportFromSelectItems"
    item-text="text"
    item-value="value"
    :label="$t('From') + ' *'"
    clearable
    hide-no-data
  />
</v-flex>

           <!-- To -->
<v-flex xs12 sm4 class="pr-sm-2">
  <v-autocomplete
    v-model="flightForm.to"
    :search-input.sync="flightToSearch"
    :items="airportToSelectItems"
    item-text="text"
    item-value="value"
    :label="$t('To') + ' *'"
    clearable
    hide-no-data
  />
</v-flex>

            <v-flex xs12 sm8></v-flex>

            <!-- Departure Date -->
<v-flex xs12 sm3 class="pr-sm-2">
  <div class="field-label-custom">{{ $t('Departure-Date') }} *</div>
  <v-menu
    v-model="flightDepartureDateMenu"
    :close-on-content-click="false"
    lazy
    transition="scale-transition"
    offset-y
    full-width
  >
    <v-text-field
      slot="activator"
      :value="dateInputValue(flightForm.departureDate)"
      solo
      flat
      hide-details
      class="date-box-field"
      placeholder="dd.mm.yyyy"
      append-icon="event"
      maxlength="10"
      inputmode="numeric"
      @input="onDateInput('flightForm', 'departureDate', $event)"
      @blur="onDateBlur('flightForm', 'departureDate')"
    />
    <v-date-picker
      v-model="flightForm.departureDate"
      locale="en"
      no-title
      @input="flightDepartureDateMenu = false"
    />
  </v-menu>
</v-flex>

            <!-- Departure Time -->
<v-flex xs12 sm3 class="px-sm-2">
  <v-text-field
    v-model="flightForm.departureTime"
    :label="$t('Departure-Time')"
    placeholder="--:--"
    maxlength="5"
    inputmode="numeric"
    @input="onFlightTimeInput('departureTime', $event)"
  />
</v-flex>

            <!-- Arrival Date -->
<v-flex xs12 sm3 class="px-sm-2">
  <div class="field-label-custom">{{ $t('Arrival-Date') }}</div>
  <v-menu
    v-model="flightArrivalDateMenu"
    :close-on-content-click="false"
    lazy
    transition="scale-transition"
    offset-y
    full-width
  >
    <v-text-field
      slot="activator"
      :value="dateInputValue(flightForm.arrivalDate)"
      solo
      flat
      hide-details
      class="date-box-field"
      placeholder="dd.mm.yyyy"
      append-icon="event"
      maxlength="10"
      inputmode="numeric"
      @input="onDateInput('flightForm', 'arrivalDate', $event)"
      @blur="onDateBlur('flightForm', 'arrivalDate')"
    />
    <v-date-picker
      v-model="flightForm.arrivalDate"
      locale="en"
      no-title
      @input="flightArrivalDateMenu = false"
    />
  </v-menu>
</v-flex>

           <!-- Arrival Time -->
<v-flex xs12 sm3 class="pl-sm-2">
  <v-text-field
    v-model="flightForm.arrivalTime"
    :label="$t('Arrival-Time')"
    placeholder="--:--"
    maxlength="5"
    inputmode="numeric"
    @input="onFlightTimeInput('arrivalTime', $event)"
  />
</v-flex>

            <!-- Flight option fields -->
            <v-flex xs12>
              <v-checkbox
                v-model="flightForm.opsiyonluMusteri"
                :label="$t('Optional-Client')"
                color="primary"
                hide-details
              />
            </v-flex>

            <v-flex xs12 sm6 class="pr-sm-2" v-if="flightForm.opsiyonluMusteri">
              <div class="field-label-custom">{{ $t('Optional-Date') }}</div>
              <v-menu
                v-model="flightOptionDateMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  :value="dateInputValue(flightForm.opsiyonTarihi)"
                  solo
                  flat
                  hide-details
                  class="date-box-field"
                  placeholder="dd.mm.yyyy"
                  append-icon="event"
                  maxlength="10"
                  inputmode="numeric"
                  @input="onDateInput('flightForm', 'opsiyonTarihi', $event)"
                  @blur="onDateBlur('flightForm', 'opsiyonTarihi')"
                />
                <v-date-picker
                  v-model="flightForm.opsiyonTarihi"
                  locale="en"
                  no-title
                  @input="flightOptionDateMenu = false"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm6 class="pl-sm-2" v-if="flightForm.opsiyonluMusteri">
              <v-text-field
                v-model="flightForm.opsiyonSaati"
                label="Opsiyon Saati"
                placeholder="--:--"
                maxlength="5"
                inputmode="numeric"
                @input="onFlightOptionTimeInput($event)"
              />
            </v-flex>

            <!-- Notes -->
            <v-flex xs12>
              <v-textarea
                v-model="flightForm.notes"
                :label="$t('Notes')"
                rows="3"
                auto-grow
              />
            </v-flex>

            <v-flex xs12>
              <div class="pricing-title">{{ $t('Pricing') }}</div>
            </v-flex>

            <v-flex xs12 sm3 class="pr-sm-2">
              <v-text-field
                v-model.number="flightForm.netPrice"
                :label="$t('Net-Price') + ' (' + activeCurrency + ')'"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2" v-if="flightForm.flightType === 'International'">
              <v-text-field
                v-model.number="flightForm.vatRate"
                :label="$t('VAT-Rate') + ' (%)'"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2" v-if="flightForm.flightType === 'International'">
              <v-text-field
                :value="formatPrice(flightVatAmount)"
                :label="$t('VAT-Amount')"
                readonly
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
  <v-text-field
    v-model.number="flightForm.taxAmount"
    :label="$t('Tax')"
    type="number"
    min="0"
  />
</v-flex>

            <v-flex xs12 sm3 class="px-sm-2" v-if="flightForm.flightType === 'Domestic'">
              <v-text-field
                v-model.number="flightForm.airportTax"
                label="Alan Vergisi"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="pl-sm-2">
              <v-text-field
                :value="formatPrice(flightGrossAmount)"
                :label="$t('Gross-Price')"
                readonly
              />
            </v-flex>

            <v-flex xs12 sm3 class="pr-sm-2">
              <v-text-field
                v-model.number="flightForm.commissionAmount"
                :label="$t('Commission-Amount')"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                v-model.number="flightForm.supplierCost"
                :label="$t('Supplier-Cost')"
                type="number"
                min="0"
              />
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- RIGHT PASSENGER LIST -->
        <v-flex xs12 md3 class="service-passenger-side">
          <div class="side-passenger-panel">
            <div class="side-passenger-title">
              <span>{{ $t('Passengers') }}</span>
              <span>{{ passengerCount }}</span>
            </div>

            <div
              v-for="(passenger, index) in serviceDialogPassengers"
              :key="'flight-dialog-passenger-' + index"
              class="side-passenger-item"
            >
              <div class="side-passenger-name">
                {{ passenger.firstName }} {{ passenger.lastName }}
              </div>

              <div class="side-passenger-type">
                {{ getPassengerTypeText(passenger.kisiTipi) }}
              </div>
            </div>

            <div
              v-if="!serviceDialogPassengers.length"
              class="side-passenger-empty"
            >
              {{ $t('No-passenger-added') }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="dialog-actions">
      <v-spacer></v-spacer>
      <v-btn flat @click="closeFlightDialog">{{ $t('Cancel') }}</v-btn>
      <v-btn color="primary" @click="saveFlight">{{ $t('Add-Flight') }}</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <!-- HOTEL DIALOG -->
<v-dialog v-model="hotelDialog" max-width="1180" persistent>
  <v-card class="dialog-card">
    <v-card-title class="headline service-dialog-title">
      {{ $t('Add-Hotel') }}
      <v-spacer></v-spacer>
      <v-btn icon flat small @click="closeHotelDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-layout row wrap>
        <!-- LEFT FORM -->
        <v-flex xs12 md9 class="service-form-main">
          <v-layout row wrap>
            <v-flex xs12 sm4 class="pr-sm-2">
              <div class="seller-inline">
                <div class="seller-inline-input">
                  <genelarama
                    apiname="SaticiAra"
                    :tip="1"
                    :label="$t('Seller-Code') + ' *'"
                    v-model="hotelForm.satici"
                  />
                </div>

                <div class="seller-inline-add">
                  <minisaticieklecomp
                    v-model="hotelForm.satici"
                    :label="$t('Add-Hotel-Seller')"
                    :saticiKod="1"
                  />
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <genelarama
                apiname="SaticiAra"
                :tip="12"
                :label="$t('Tour-Operator')"
                v-model="hotelForm.tourOperator"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2">
              <v-text-field
                v-model="hotelForm.city"
                :label="$t('City') + ' *'"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pr-sm-2">
              <v-text-field
                v-model="hotelForm.country"
                :label="$t('Country_label')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <v-select
                v-model="hotelForm.roomType"
                :items="hotelRoomTypeList"
                item-text="text"
                item-value="value"
                :label="$t('Room-Type')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2">
              <v-select
                v-model="hotelForm.boardType"
                :items="boardTypeList"
                :label="$t('Board-Type')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pr-sm-2">
              <v-text-field
                v-model="hotelForm.confirmationNo"
                :label="$t('Confirmation-Number')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <v-text-field
                v-model.number="hotelForm.rooms"
                :label="$t('Rooms')"
                type="number"
                min="1"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2">
              <v-text-field
                v-model.number="hotelForm.guests"
                :label="$t('Guests')"
                type="number"
                min="1"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pr-sm-2">
              <div class="field-label-custom">{{ $t('Check-in') }} *</div>
              <v-menu
                v-model="hotelCheckInMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  :value="dateInputValue(hotelForm.checkIn)"
                  solo
                  flat
                  hide-details
                  class="date-box-field"
                  placeholder="dd.mm.yyyy"
                  append-icon="event"
                  maxlength="10"
                  inputmode="numeric"
                  @input="onDateInput('hotelForm', 'checkIn', $event)"
                  @blur="onDateBlur('hotelForm', 'checkIn')"
                />
                <v-date-picker
                  v-model="hotelForm.checkIn"
                  locale="en"
                  no-title
                  @input="hotelCheckInMenu = false"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <div class="field-label-custom">{{ $t('Check-out') }} *</div>
              <v-menu
                v-model="hotelCheckOutMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  :value="dateInputValue(hotelForm.checkOut)"
                  solo
                  flat
                  hide-details
                  class="date-box-field"
                  placeholder="dd.mm.yyyy"
                  append-icon="event"
                  maxlength="10"
                  inputmode="numeric"
                  @input="onDateInput('hotelForm', 'checkOut', $event)"
                  @blur="onDateBlur('hotelForm', 'checkOut')"
                />
                <v-date-picker
                  v-model="hotelForm.checkOut"
                  locale="en"
                  no-title
                  @input="hotelCheckOutMenu = false"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2"></v-flex>

            <!-- Notes -->
            <v-flex xs12>
              <v-textarea
                v-model="hotelForm.notes"
                :label="$t('Notes')"
                rows="3"
                auto-grow
              />
            </v-flex>

            <v-flex xs12>
              <div class="pricing-title">{{ $t('Pricing') }}</div>
            </v-flex>

            <v-flex xs12 sm3 class="pr-sm-2">
              <v-text-field
                v-model.number="hotelForm.netPrice"
                :label="$t('Net-Price') + ' (' + activeCurrency + ')'"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                v-model.number="hotelForm.vatRate"
                :label="$t('VAT-Rate') + ' (%)'"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                :value="formatPrice(hotelVatAmount)"
                :label="$t('VAT-Amount')"
                readonly
              />
            </v-flex>

            <v-flex xs12 sm3 class="pl-sm-2">
              <v-text-field
                :value="formatPrice(hotelGrossAmount)"
                :label="$t('Gross-Price')"
                readonly
              />
            </v-flex>

            <v-flex xs12 sm3 class="pr-sm-2">
              <v-text-field
                v-model.number="hotelForm.commissionAmount"
                :label="$t('Commission-Amount')"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                v-model.number="hotelForm.supplierCost"
                :label="$t('Supplier-Cost')"
                type="number"
                min="0"
              />
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- RIGHT PASSENGER LIST -->
        <v-flex xs12 md3 class="service-passenger-side">
          <div class="side-passenger-panel">
            <div class="side-passenger-title">
              <span>{{ $t('Passengers') }}</span>
              <span>{{ serviceDialogPassengers.length }}</span>
            </div>

            <div
              v-for="(passenger, index) in serviceDialogPassengers"
              :key="'hotel-dialog-passenger-' + index"
              class="side-passenger-item"
            >
              <div class="side-passenger-name">
                {{ passenger.firstName }} {{ passenger.lastName }}
              </div>

              <div class="side-passenger-type">
                {{ getPassengerTypeText(passenger.kisiTipi) }}
              </div>
            </div>

            <div
              v-if="!serviceDialogPassengers.length"
              class="side-passenger-empty"
            >
              {{ $t('No-passenger-added') }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="dialog-actions">
      <v-spacer></v-spacer>
      <v-btn flat @click="closeHotelDialog">
        {{ $t('Cancel') }}
      </v-btn>

      <v-btn color="primary" @click="saveHotel">
        {{ $t('Add-Hotel') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <!-- CRUISE DIALOG -->
<v-dialog v-model="cruiseDialog" max-width="1180" persistent>
  <v-card class="dialog-card">
    <v-card-title class="headline service-dialog-title">
      {{ $t('Add-Cruise') }}
      <v-spacer></v-spacer>
      <v-btn icon flat small @click="closeCruiseDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-layout row wrap>
        <!-- LEFT FORM -->
        <v-flex xs12 md9 class="service-form-main">
          <v-layout row wrap>
            <v-flex xs12 sm4 class="pr-sm-2">
              <div class="seller-inline">
                <div class="seller-inline-input">
                  <genelarama
                    apiname="SaticiAra"
                    :tip="9"
                    :label="$t('Seller-Code') + ' *'"
                    v-model="cruiseForm.satici"
                  />
                </div>

                <div class="seller-inline-add">
                  <minisaticieklecomp
                    v-model="cruiseForm.satici"
                    :label="$t('Add-Cruise-Seller')"
                    :saticiKod="9"
                  />
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <genelarama
                apiname="SaticiAra"
                :tip="12"
                :label="$t('Tour-Operator')"
                v-model="cruiseForm.tourOperator"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2">
              <v-text-field
                v-model="cruiseForm.hotelName"
                :label="$t('Ship-Cruise-Name')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pr-sm-2">
              <v-text-field
                v-model="cruiseForm.city"
                :label="$t('City')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <v-text-field
                v-model="cruiseForm.country"
                :label="$t('Country_label')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2">
              <v-text-field
                v-model="cruiseForm.confirmationNo"
                :label="$t('Confirmation-Number')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pr-sm-2">
              <v-text-field
                v-model="cruiseForm.roomType"
                :label="$t('Cabin-Type')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <v-text-field
                v-model.number="cruiseForm.rooms"
                :label="$t('Cabins')"
                type="number"
                min="1"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2">
              <v-text-field
                v-model.number="cruiseForm.guests"
                :label="$t('Guests')"
                type="number"
                min="1"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pr-sm-2">
              <div class="field-label-custom">{{ $t('Start-Date') }} *</div>
              <v-menu
                v-model="cruiseCheckInMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  :value="dateInputValue(cruiseForm.checkIn)"
                  solo
                  flat
                  hide-details
                  class="date-box-field"
                  placeholder="dd.mm.yyyy"
                  append-icon="event"
                  maxlength="10"
                  inputmode="numeric"
                  @input="onDateInput('cruiseForm', 'checkIn', $event)"
                  @blur="onDateBlur('cruiseForm', 'checkIn')"
                />
                <v-date-picker
                  v-model="cruiseForm.checkIn"
                  locale="en"
                  no-title
                  @input="cruiseCheckInMenu = false"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <div class="field-label-custom">{{ $t('End-Date') }} *</div>
              <v-menu
                v-model="cruiseCheckOutMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  :value="dateInputValue(cruiseForm.checkOut)"
                  solo
                  flat
                  hide-details
                  class="date-box-field"
                  placeholder="dd.mm.yyyy"
                  append-icon="event"
                  maxlength="10"
                  inputmode="numeric"
                  @input="onDateInput('cruiseForm', 'checkOut', $event)"
                  @blur="onDateBlur('cruiseForm', 'checkOut')"
                />
                <v-date-picker
                  v-model="cruiseForm.checkOut"
                  locale="en"
                  no-title
                  @input="cruiseCheckOutMenu = false"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2"></v-flex>

            <!-- Notes -->
            <v-flex xs12>
              <v-textarea
                v-model="cruiseForm.notes"
                :label="$t('Notes')"
                rows="3"
                auto-grow
              />
            </v-flex>

            <v-flex xs12>
              <div class="pricing-title">{{ $t('Pricing') }}</div>
            </v-flex>

            <v-flex xs12 sm3 class="pr-sm-2">
              <v-text-field
                v-model.number="cruiseForm.netPrice"
                :label="$t('Net-Price') + ' (' + activeCurrency + ')'"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                v-model.number="cruiseForm.vatRate"
                :label="$t('VAT-Rate') + ' (%)'"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                :value="formatPrice(cruiseVatAmount)"
                :label="$t('VAT-Amount')"
                readonly
              />
            </v-flex>

            <v-flex xs12 sm3 class="pl-sm-2">
              <v-text-field
                :value="formatPrice(cruiseGrossAmount)"
                :label="$t('Gross-Price')"
                readonly
              />
            </v-flex>

            <v-flex xs12 sm3 class="pr-sm-2">
              <v-text-field
                v-model.number="cruiseForm.commissionAmount"
                :label="$t('Commission-Amount')"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                v-model.number="cruiseForm.supplierCost"
                :label="$t('Supplier-Cost')"
                type="number"
                min="0"
              />
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- RIGHT PASSENGER LIST -->
        <v-flex xs12 md3 class="service-passenger-side">
          <div class="side-passenger-panel">
            <div class="side-passenger-title">
              <span>{{ $t('Passengers') }}</span>
              <span>{{ serviceDialogPassengers.length }}</span>
            </div>

            <div
              v-for="(passenger, index) in serviceDialogPassengers"
              :key="'cruise-dialog-passenger-' + index"
              class="side-passenger-item"
            >
              <div class="side-passenger-name">
                {{ passenger.firstName }} {{ passenger.lastName }}
              </div>

              <div class="side-passenger-type">
                {{ getPassengerTypeText(passenger.kisiTipi) }}
              </div>
            </div>

            <div
              v-if="!serviceDialogPassengers.length"
              class="side-passenger-empty"
            >
              {{ $t('No-passenger-added') }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="dialog-actions">
      <v-spacer></v-spacer>

      <v-btn flat @click="closeCruiseDialog">
        {{ $t('Cancel') }}
      </v-btn>

      <v-btn color="primary" @click="saveCruise">
        {{ $t('Add-Cruise') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <!-- CAR DIALOG -->
<v-dialog v-model="carDialog" max-width="1180" persistent>
  <v-card class="dialog-card">
    <v-card-title class="headline service-dialog-title">
      {{ $t('Add-Car-Rental') }}
      <v-spacer></v-spacer>
      <v-btn icon flat small @click="closeCarDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 md9 class="service-form-main">
          <v-layout row wrap>
            <v-flex xs12 sm4 class="pr-sm-2">
              <div class="seller-inline">
                <div class="seller-inline-input">
                  <genelarama
                    apiname="SaticiAra"
                    :tip="5"
                    :label="$t('Tour-Operator') + ' *'"
                    v-model="carForm.satici"
                  />
                </div>

                <div class="seller-inline-add">
                  <minisaticieklecomp
                    v-model="carForm.satici"
                    :label="$t('Add-Car-Seller')"
                    :saticiKod="5"
                  />
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <div class="seller-inline">
                <div class="seller-inline-input">
                  <genelarama
                    apiname="SaticiAra"
                    :tip="12"
                    :label="$t('Seller-Code')"
                    v-model="carForm.tourOperator"
                  />
                </div>

                <div class="seller-inline-add">
                  <minisaticieklecomp
                    v-model="carForm.tourOperator"
                    :label="$t('Add-v2', { value: $t('Tour-Operator') })"
                    :saticiKod="12"
                  />
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2">
              <v-text-field
                v-model="carForm.carType"
                :label="$t('Car-Type')"
                :placeholder="$t('Example-VW-Golf')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pr-sm-2">
              <v-select
                v-model="carForm.category"
                :items="carCategoryList"
                :label="$t('Category')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <v-text-field
                v-model="carForm.pickupLocation"
                :label="$t('Pickup-Location') + ' *'"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2">
              <v-text-field
                v-model="carForm.dropoffLocation"
                :label="$t('Dropoff-Location')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pr-sm-2">
              <div class="field-label-custom">{{ $t('Pickup-Date') }} *</div>
              <v-menu
                v-model="carPickupDateMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  :value="dateInputValue(carForm.pickupDate)"
                  solo
                  flat
                  hide-details
                  class="date-box-field"
                  placeholder="dd.mm.yyyy"
                  append-icon="event"
                  maxlength="10"
                  inputmode="numeric"
                  @input="onDateInput('carForm', 'pickupDate', $event)"
                  @blur="onDateBlur('carForm', 'pickupDate')"
                />
                <v-date-picker
                  v-model="carForm.pickupDate"
                  locale="en"
                  no-title
                  @input="carPickupDateMenu = false"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <v-text-field
                v-model="carForm.pickupTime"
                :label="$t('Pickup-Time')"
                placeholder="--:--"
                maxlength="5"
                inputmode="numeric"
                @input="onServiceTimeInput('carForm', 'pickupTime', $event)"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2">
              <div class="field-label-custom">{{ $t('Dropoff-Date') }} *</div>
              <v-menu
                v-model="carDropoffDateMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  :value="dateInputValue(carForm.dropoffDate)"
                  solo
                  flat
                  hide-details
                  class="date-box-field"
                  placeholder="dd.mm.yyyy"
                  append-icon="event"
                  maxlength="10"
                  inputmode="numeric"
                  @input="onDateInput('carForm', 'dropoffDate', $event)"
                  @blur="onDateBlur('carForm', 'dropoffDate')"
                />
                <v-date-picker
                  v-model="carForm.dropoffDate"
                  locale="en"
                  no-title
                  @input="carDropoffDateMenu = false"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4 class="pr-sm-2">
              <v-text-field
                v-model="carForm.dropoffTime"
                :label="$t('Dropoff-Time')"
                placeholder="--:--"
                maxlength="5"
                inputmode="numeric"
                @input="onServiceTimeInput('carForm', 'dropoffTime', $event)"
              />
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <v-text-field
                v-model="carForm.confirmationNo"
                :label="$t('Confirmation-Number')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2"></v-flex>

            <!-- Notes -->
            <v-flex xs12>
              <v-textarea
                v-model="carForm.notes"
                :label="$t('Notes')"
                rows="3"
                auto-grow
              />
            </v-flex>

            <v-flex xs12>
              <div class="pricing-title">{{ $t('Pricing') }}</div>
            </v-flex>

            <v-flex xs12 sm3 class="pr-sm-2">
              <v-text-field
                v-model.number="carForm.netPrice"
                :label="$t('Net-Price') + ' (' + activeCurrency + ')'"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                v-model.number="carForm.vatRate"
                :label="$t('VAT-Rate') + ' (%)'"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                :value="formatPrice(carVatAmount)"
                :label="$t('VAT-Amount')"
                readonly
              />
            </v-flex>

            <v-flex xs12 sm3 class="pl-sm-2">
              <v-text-field
                :value="formatPrice(carGrossAmount)"
                :label="$t('Gross-Price')"
                readonly
              />
            </v-flex>

            <v-flex xs12 sm3 class="pr-sm-2">
              <v-text-field
                v-model.number="carForm.commissionAmount"
                :label="$t('Commission-Amount')"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                v-model.number="carForm.supplierCost"
                :label="$t('Supplier-Cost')"
                type="number"
                min="0"
              />
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 md3 class="service-passenger-side">
          <div class="side-passenger-panel">
            <div class="side-passenger-title">
              <span>{{ $t('Passengers') }}</span>
              <span>{{ serviceDialogPassengers.length }}</span>
            </div>

            <div
              v-for="(passenger, index) in serviceDialogPassengers"
              :key="'car-dialog-passenger-' + index"
              class="side-passenger-item"
            >
              <div class="side-passenger-name">
                {{ passenger.firstName }} {{ passenger.lastName }}
              </div>

              <div class="side-passenger-type">
                {{ getPassengerTypeText(passenger.kisiTipi) }}
              </div>
            </div>

            <div
              v-if="!serviceDialogPassengers.length"
              class="side-passenger-empty"
            >
              {{ $t('No-passenger-added') }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="dialog-actions">
      <v-spacer></v-spacer>

      <v-btn flat @click="closeCarDialog">
        {{ $t('Cancel') }}
      </v-btn>

      <v-btn color="primary" @click="saveCar">
        {{ $t('Add-Car-Rental') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <!-- TRANSFER DIALOG -->
<v-dialog v-model="transferDialog" max-width="1180" persistent>
  <v-card class="dialog-card">
    <v-card-title class="headline service-dialog-title">
      {{ $t('Add-Transfer') }}
      <v-spacer></v-spacer>
      <v-btn icon flat small @click="closeTransferDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-layout row wrap>
        <!-- LEFT FORM -->
        <v-flex xs12 md9 class="service-form-main">
          <v-layout row wrap>
            <v-flex xs12 sm4 class="pr-sm-2">
              <div class="seller-inline">
                <div class="seller-inline-input">
                  <genelarama
                    apiname="SaticiAra"
                    :tip="2"
                    :label="$t('Seller-Code') + ' *'"
                    v-model="transferForm.satici"
                  />
                </div>

                <div class="seller-inline-add">
                  <minisaticieklecomp
                    v-model="transferForm.satici"
                    :label="$t('Add-Transfer-Seller')"
                    :saticiKod="2"
                  />
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <genelarama
                apiname="SaticiAra"
                :tip="12"
                :label="$t('Tour-Operator')"
                v-model="transferForm.tourOperator"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2">
              <v-select
                v-model="transferForm.type"
                :items="transferTypeList"
                :label="$t('Type')"
              />
            </v-flex>

<v-flex xs12 sm4 class="pr-sm-2">
  <v-select
    v-model="transferForm.serviceType"
    :items="translatedTransferServiceTypeList"
    item-text="text"
    item-value="value"
    :label="$t('Transfer-Service-Type')"
  />
</v-flex>

            <v-flex xs12 sm4 class="pr-sm-2">
              <v-text-field
                v-model="transferForm.vehicleType"
                :label="$t('Vehicle-Type')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <v-text-field
                v-model="transferForm.plateNumber"
                :label="$t('Plate-Number')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2">
              <v-text-field
                v-model="transferForm.driverName"
                :label="$t('Driver-Name')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pr-sm-2">
              <phoneinput
                v-model="transferForm.driverPhone"
                :etiket="$t('Driver-GSM')"
                :label="$t('Driver-GSM')"
                :zorunlumu="false"
              />
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <v-text-field
                v-model="transferForm.from"
                :label="$t('From') + ' *'"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2">
              <v-text-field
                v-model="transferForm.to"
                :label="$t('To') + ' *'"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pr-sm-2">
              <div class="field-label-custom">{{ $t('Date') }} *</div>
              <v-menu
                v-model="transferDateMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  :value="dateInputValue(transferForm.date)"
                  solo
                  flat
                  hide-details
                  class="date-box-field"
                  placeholder="dd.mm.yyyy"
                  append-icon="event"
                  maxlength="10"
                  inputmode="numeric"
                  @input="onDateInput('transferForm', 'date', $event)"
                  @blur="onDateBlur('transferForm', 'date')"
                />
                <v-date-picker
                  v-model="transferForm.date"
                  locale="en"
                  no-title
                  @input="transferDateMenu = false"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <v-text-field
                v-model="transferForm.time"
                :label="$t('Time')"
                placeholder="--:--"
                maxlength="5"
                inputmode="numeric"
                @input="onServiceTimeInput('transferForm', 'time', $event)"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2">
              <v-text-field
                v-model="transferForm.confirmationNo"
                :label="$t('Confirmation-Number')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pr-sm-2">
  <v-text-field
    v-model="transferForm.flightNumber"
    :label="$t('Flight-Number')"
  />
</v-flex>

<v-flex xs12 sm4 class="px-sm-2">
  <v-text-field
    v-model="transferForm.flightTime"
    :label="$t('Flight-Time')"
    placeholder="--:--"
    maxlength="5"
    inputmode="numeric"
    @input="onServiceTimeInput('transferForm', 'flightTime', $event)"
  />
</v-flex>

           <v-flex xs12 sm4 class="pr-sm-2">
  <v-text-field
    v-model.number="transferForm.passengerCount"
    :label="$t('Passenger-Count')"
    type="number"
    min="1"
  />
</v-flex>

<v-flex xs12 sm8></v-flex>

<!-- EK SAAT -->
<v-flex xs12 class="transfer-extra-hour-section">
  <div class="transfer-extra-hour-header">
    <v-switch
      v-model="transferForm.hasExtraHour"
      :label="$t('Extra-Hour')"
      color="primary"
      hide-details
      class="transfer-extra-hour-switch"
      @change="onTransferExtraHourChange"
    />

    <v-btn
  v-if="transferForm.hasExtraHour"
  color="primary"
  small
  outline
  class="transfer-extra-hour-add"
  :disabled="
    transferForm.extraHours.length >= maxTransferExtraHourCount
  "
  @click="addTransferExtraHour"
>
  <v-icon left small>add</v-icon>
  {{ $t('Add-Extra-Hour') }}

  <span class="ml-1">
    ({{ transferForm.extraHours.length }}/{{ maxTransferExtraHourCount }})
  </span>
</v-btn>
  </div>

  <div
    v-if="transferForm.hasExtraHour"
    class="transfer-extra-hour-content"
  >
    <v-layout
      v-for="(extraHour, index) in transferForm.extraHours"
      :key="'transfer-extra-hour-' + index"
      row
      wrap
      align-center
      class="transfer-extra-hour-row"
    >
      <v-flex xs12 sm4 class="pr-sm-2">
        <v-text-field
          :value="extraHour"
          :label="$t('Extra-Hour') + ' ' + (index + 1)"
          placeholder="00:00"
          maxlength="5"
          inputmode="numeric"
          append-icon="access_time"
          hide-details
          @input="onTransferExtraHourInput(index, $event)"
          @blur="normalizeTransferExtraHour(index)"
        />
      </v-flex>

      <v-flex xs10 sm4 class="px-sm-2">
        <v-text-field
          :value="transferForm.extraHourAmounts[index]"
          :label="$t('Extra-Hour-Amount') + ' ' + (index + 1) + ' (' + activeCurrency + ')'"
          type="number"
          min="0"
          step="0.01"
          hide-details
          @input="onTransferExtraHourAmountInput(index, $event)"
        />
      </v-flex>

      <v-flex xs2 sm1 class="text-xs-center">
        <v-btn
          icon
          small
          color="error"
          @click="removeTransferExtraHour(index)"
        >
          <v-icon small>delete_outline</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

  </div>
</v-flex>





            <v-flex xs12 sm8></v-flex>

            <!-- Notes -->
            <v-flex xs12>
              <v-textarea
                v-model="transferForm.notes"
                :label="$t('Notes')"
                rows="3"
                auto-grow
              />
            </v-flex>

            <v-flex xs12>
              <div class="pricing-title">{{ $t('Pricing') }}</div>
            </v-flex>

            <v-flex xs12 sm3 class="pr-sm-2">
              <v-text-field
                v-model.number="transferForm.netPrice"
                :label="$t('Net-Price') + ' (' + activeCurrency + ')'"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                v-model.number="transferForm.vatRate"
                :label="$t('VAT-Rate') + ' (%)'"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                :value="formatPrice(transferVatAmount)"
                :label="$t('VAT-Amount')"
                readonly
              />
            </v-flex>

            <v-flex xs12 sm3 class="pl-sm-2">
              <v-text-field
                :value="formatPrice(transferGrossAmount)"
                :label="$t('Gross-Price')"
                readonly
              />
            </v-flex>

            <v-flex xs12 sm3 class="pr-sm-2">
              <v-text-field
                v-model.number="transferForm.commissionAmount"
                :label="$t('Commission-Amount')"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                v-model.number="transferForm.supplierCost"
                :label="$t('Supplier-Cost')"
                type="number"
                min="0"
              />
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- RIGHT PASSENGER LIST -->
        <v-flex xs12 md3 class="service-passenger-side">
          <div class="side-passenger-panel">
            <div class="side-passenger-title">
              <span>{{ $t('Passengers') }}</span>
              <span>{{ serviceDialogPassengers.length }}</span>
            </div>

            <div
              v-for="(passenger, index) in serviceDialogPassengers"
              :key="'transfer-dialog-passenger-' + index"
              class="side-passenger-item"
            >
              <div class="side-passenger-name">
                {{ passenger.firstName }} {{ passenger.lastName }}
              </div>

              <div class="side-passenger-type">
                {{ getPassengerTypeText(passenger.kisiTipi) }}
              </div>
            </div>

            <div
              v-if="!serviceDialogPassengers.length"
              class="side-passenger-empty"
            >
              {{ $t('No-passenger-added') }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="dialog-actions">
      <v-spacer></v-spacer>

      <v-btn flat @click="closeTransferDialog">
        {{ $t('Cancel') }}
      </v-btn>

      <v-btn color="primary" @click="saveTransfer">
        {{ $t('Add-Transfer') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <!-- DAILY TOUR DIALOG -->
<v-dialog v-model="dailyTourDialog" max-width="1180" persistent>
  <v-card class="dialog-card">
    <v-card-title class="headline service-dialog-title">
      {{ $t('Add-Daily-Tour') }}
      <v-spacer></v-spacer>
      <v-btn icon flat small @click="closeDailyTourDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-layout row wrap>
        <!-- LEFT FORM -->
        <v-flex xs12 md9 class="service-form-main">
          <v-layout row wrap>
            <v-flex xs12 sm4 class="pr-sm-2">
              <div class="seller-inline">
                <div class="seller-inline-input">
                  <genelarama
                    apiname="SaticiAra"
                    :tip="4"
                    :label="$t('Seller-Code') + ' *'"
                    v-model="dailyTourForm.satici"
                  />
                </div>

                <div class="seller-inline-add">
                  <minisaticieklecomp
                    v-model="dailyTourForm.satici"
                    :label="$t('Add-Tour-Seller')"
                    :saticiKod="4"
                  />
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <genelarama
                apiname="SaticiAra"
                :tip="12"
                :label="$t('Tour-Operator')"
                v-model="dailyTourForm.tourOperator"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2">
              <v-text-field
                v-model="dailyTourForm.tourCode"
                :label="$t('Tour-Code') + ' *'"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pr-sm-2">
              <v-text-field
                v-model="dailyTourForm.tourName"
                :label="$t('Tour-Name') + ' *'"
              />
            </v-flex>

            <v-flex xs12 sm4 class="px-sm-2">
              <div class="field-label-custom">{{ $t('Date') }} *</div>
              <v-menu
                v-model="dailyTourDateMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  :value="dateInputValue(dailyTourForm.date)"
                  solo
                  flat
                  hide-details
                  class="date-box-field"
                  placeholder="dd.mm.yyyy"
                  append-icon="event"
                  maxlength="10"
                  inputmode="numeric"
                  @input="onDateInput('dailyTourForm', 'date', $event)"
                  @blur="onDateBlur('dailyTourForm', 'date')"
                />
                <v-date-picker
                  v-model="dailyTourForm.date"
                  locale="en"
                  no-title
                  @input="dailyTourDateMenu = false"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4 class="pl-sm-2">
              <v-text-field
                v-model="dailyTourForm.time"
                :label="$t('Time')"
                placeholder="--:--"
                maxlength="5"
                inputmode="numeric"
                @input="onServiceTimeInput('dailyTourForm', 'time', $event)"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pr-sm-2">
              <v-text-field
                v-model="dailyTourForm.meetingPoint"
                :label="$t('Meeting-Point')"
              />
            </v-flex>

            <v-flex xs12 sm5></v-flex>

            <v-flex xs12>
  <v-textarea
    v-model="dailyTourForm.program"
    :label="$t('Program')"
    rows="4"
    auto-grow
    outline
  />
</v-flex>

            <!-- Notes -->
            <v-flex xs12>
              <v-textarea
                v-model="dailyTourForm.notes"
                :label="$t('Notes')"
                rows="3"
                auto-grow
              />
            </v-flex>

            <v-flex xs12>
              <div class="pricing-title">{{ $t('Pricing') }}</div>
            </v-flex>

            <v-flex xs12 sm3 class="pr-sm-2">
              <v-text-field
                v-model.number="dailyTourForm.netPrice"
                :label="$t('Net-Price') + ' (' + activeCurrency + ')'"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                v-model.number="dailyTourForm.vatRate"
                :label="$t('VAT-Rate') + ' (%)'"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                :value="formatPrice(dailyTourVatAmount)"
                :label="$t('VAT-Amount')"
                readonly
              />
            </v-flex>

            <v-flex xs12 sm3 class="pl-sm-2">
              <v-text-field
                :value="formatPrice(dailyTourGrossAmount)"
                :label="$t('Gross-Price')"
                readonly
              />
            </v-flex>

            <v-flex xs12 sm3 class="pr-sm-2">
              <v-text-field
                v-model.number="dailyTourForm.commissionAmount"
                :label="$t('Commission-Amount')"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                v-model.number="dailyTourForm.supplierCost"
                :label="$t('Supplier-Cost')"
                type="number"
                min="0"
              />
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- RIGHT PASSENGER LIST -->
        <v-flex xs12 md3 class="service-passenger-side">
          <div class="side-passenger-panel">
            <div class="side-passenger-title">
              <span>{{ $t('Passengers') }}</span>
              <span>{{ serviceDialogPassengers.length }}</span>
            </div>

            <div
              v-for="(passenger, index) in serviceDialogPassengers"
              :key="'daily-tour-passenger-' + index"
              class="side-passenger-item"
            >
              <div class="side-passenger-name">
                {{ passenger.firstName }} {{ passenger.lastName }}
              </div>

              <div class="side-passenger-type">
                {{ getPassengerTypeText(passenger.kisiTipi) }}
              </div>
            </div>

            <div
              v-if="!serviceDialogPassengers.length"
              class="side-passenger-empty"
            >
              {{ $t('No-passenger-added') }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="dialog-actions">
      <v-spacer></v-spacer>

      <v-btn flat @click="closeDailyTourDialog">
        {{ $t('Cancel') }}
      </v-btn>

      <v-btn color="primary" @click="saveDailyTour">
        {{ $t('Add-Daily-Tour') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <!-- OTHER DIALOG -->
<v-dialog v-model="otherDialog" max-width="1180" persistent>
  <v-card class="dialog-card">
    <v-card-title class="headline service-dialog-title">
      {{ $t('Add-Other') }}
      <v-spacer></v-spacer>
      <v-btn icon flat small @click="closeOtherDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-layout row wrap>
        <!-- LEFT FORM -->
        <v-flex xs12 md9 class="service-form-main">
          <v-layout row wrap>
            <!-- Seller Code -->
            <v-flex xs12 sm4 class="pr-sm-2">
              <div class="seller-inline">
                <div class="seller-inline-input">
                  <genelarama
                    apiname="SaticiAra"
                    :tip="10"
                    :label="$t('Seller-Code') + ' *'"
                    v-model="otherForm.satici"
                  />
                </div>

                <div class="seller-inline-add">
                  <minisaticieklecomp
                    v-model="otherForm.satici"
                    :label="$t('Add-Other-Seller')"
                    :saticiKod="10"
                  />
                </div>
              </div>
            </v-flex>

            <!-- Tour Operator -->
            <v-flex xs12 sm4 class="px-sm-2">
              <genelarama
                apiname="SaticiAra"
                :tip="12"
                :label="$t('Tour-Operator')"
                v-model="otherForm.tourOperator"
              />
            </v-flex>

            <!-- Title -->
            <v-flex xs12 sm4 class="pl-sm-2">
              <v-text-field
                v-model="otherForm.title"
                :label="$t('Title') + ' *'"
              />
            </v-flex>

            <!-- Start Date -->
            <v-flex xs12 sm4 class="pr-sm-2">
              <div class="field-label-custom">{{ $t('Start-Date') }} *</div>
              <v-menu
                v-model="otherStartDateMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  :value="dateInputValue(otherForm.startDate)"
                  solo
                  flat
                  hide-details
                  class="date-box-field"
                  placeholder="dd.mm.yyyy"
                  append-icon="event"
                  maxlength="10"
                  inputmode="numeric"
                  @input="onDateInput('otherForm', 'startDate', $event)"
                  @blur="onDateBlur('otherForm', 'startDate')"
                />
                <v-date-picker
                  v-model="otherForm.startDate"
                  locale="en"
                  no-title
                  @input="otherStartDateMenu = false"
                />
              </v-menu>
            </v-flex>

            <!-- End Date -->
            <v-flex xs12 sm4 class="px-sm-2">
              <div class="field-label-custom">{{ $t('End-Date') }} *</div>
              <v-menu
                v-model="otherEndDateMenu"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <v-text-field
                  slot="activator"
                  :value="dateInputValue(otherForm.endDate)"
                  solo
                  flat
                  hide-details
                  class="date-box-field"
                  placeholder="dd.mm.yyyy"
                  append-icon="event"
                  maxlength="10"
                  inputmode="numeric"
                  @input="onDateInput('otherForm', 'endDate', $event)"
                  @blur="onDateBlur('otherForm', 'endDate')"
                />
                <v-date-picker
                  v-model="otherForm.endDate"
                  locale="en"
                  no-title
                  @input="otherEndDateMenu = false"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4></v-flex>

            <!-- Description -->
            <v-flex xs12>
              <v-textarea
                v-model="otherForm.description"
                :label="$t('Description')"
                rows="2"
                auto-grow
              />
            </v-flex>

            <!-- Notes -->
            <v-flex xs12>
              <v-textarea
                v-model="otherForm.notes"
               :label="$t('Notes')"
                rows="3"
                auto-grow
              />
            </v-flex>

            <!-- Pricing -->
            <v-flex xs12>
              <div class="pricing-title">{{ $t('Pricing') }}</div>
            </v-flex>

            <v-flex xs12 sm3 class="pr-sm-2">
              <v-text-field
                v-model.number="otherForm.netPrice"
                :label="$t('Net-Price') + ' (' + activeCurrency + ')'"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                v-model.number="otherForm.vatRate"
                :label="$t('VAT-Rate') + ' (%)'"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                :value="formatPrice(otherVatAmount)"
                :label="$t('VAT-Amount')"
                readonly
              />
            </v-flex>

            <v-flex xs12 sm3 class="pl-sm-2">
              <v-text-field
                :value="formatPrice(otherGrossAmount)"
                :label="$t('Gross-Price')"
                readonly
              />
            </v-flex>

            <v-flex xs12 sm3 class="pr-sm-2">
              <v-text-field
                v-model.number="otherForm.commissionAmount"
                :label="$t('Commission-Amount')"
                type="number"
                min="0"
              />
            </v-flex>

            <v-flex xs12 sm3 class="px-sm-2">
              <v-text-field
                v-model.number="otherForm.supplierCost"
                :label="$t('Supplier-Cost')"
                type="number"
                min="0"
              />
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- RIGHT PASSENGER LIST -->
        <v-flex xs12 md3 class="service-passenger-side">
          <div class="side-passenger-panel">
            <div class="side-passenger-title">
              <span>{{ $t('Passengers') }}</span>
              <span>{{ serviceDialogPassengers.length }}</span>
            </div>

            <div
              v-for="(passenger, index) in serviceDialogPassengers"
              :key="'other-dialog-passenger-' + index"
              class="side-passenger-item"
            >
              <div class="side-passenger-name">
                {{ passenger.firstName }} {{ passenger.lastName }}
              </div>

              <div class="side-passenger-type">
                {{ getPassengerTypeText(passenger.kisiTipi) }}
              </div>
            </div>

            <div
              v-if="!serviceDialogPassengers.length"
              class="side-passenger-empty"
            >
              {{ $t('No-passenger-added') }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="dialog-actions">
      <v-spacer></v-spacer>

      <v-btn flat @click="closeOtherDialog">
        {{ $t('Cancel') }}
      </v-btn>

      <v-btn color="primary" @click="saveOther">
        {{ $t('Add-Other') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <!-- Voucher DIALOG -->
<v-dialog v-model="generalVoucherDialog" max-width="430" persistent>
  <v-card>
    <v-card-title class="headline">
      {{ $t('General-Voucher-PDF') }}
    </v-card-title>

    <v-card-text>
      <v-select
        v-model="generalVoucherLang"
        :items="serviceVoucherLangItems"
        item-text="text"
        item-value="value"
        :label="$t('Language')"
      ></v-select>

      <div class="mt-3 mb-2" style="font-weight:bold;color:#455a64;">
        {{ $t('Should-price-info-be-shown-on-PDF') }}
      </div>

      <v-radio-group
        v-model="generalVoucherShowPrice"
        row
        hide-details
      >
        <v-radio
          :label="$t('Show-Price')"
          :value="true"
        ></v-radio>

        <v-radio
          :label="$t('Hide-Price')"
          :value="false"
        ></v-radio>
      </v-radio-group>

      <div class="mt-3 grey--text" style="font-size:12px;">
        {{ $t('General-Voucher-card-view-note') }}
      </div>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn flat @click="generalVoucherDialog = false">
        {{ $t('Cancel') }}
      </v-btn>

      <v-btn
        color="primary"
        flat
        :loading="generalVoucherLoading"
        :disabled="generalVoucherLoading"
        @click="downloadGeneralVoucher"
      >
        {{ $t('Download') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<v-dialog v-model="serviceVoucherDialog" max-width="430" persistent>
  <v-card>
    <v-card-title class="headline">
      {{ $t('Voucher-PDF') }}
    </v-card-title>

    <v-card-text>
      <v-select
        v-model="serviceVoucherLang"
        :items="serviceVoucherLangItems"
        item-text="text"
        item-value="value"
        :label="$t('Language')"
      ></v-select>

      <div class="mt-3 mb-2" style="font-weight:bold;color:#455a64;">
        {{ $t('Should-price-info-be-shown-on-PDF') }}
      </div>

      <v-radio-group
        v-model="serviceVoucherShowPrice"
        row
        hide-details
      >
        <v-radio
          :label="$t('Show-Price')"
          :value="true"
        ></v-radio>

        <v-radio
          :label="$t('Hide-Price')"
          :value="false"
        ></v-radio>
      </v-radio-group>

      
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn flat @click="serviceVoucherDialog = false">
        {{ $t('Cancel') }}
      </v-btn>

      <v-btn
        color="primary"
        flat
        :loading="serviceVoucherLoading || flightVoucherLoading"
        :disabled="serviceVoucherLoading || flightVoucherLoading"
        @click="downloadServiceVoucher"
      >
        {{ $t('Download') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-dialog v-model="deleteConfirmDialog" max-width="430" persistent>
  <v-card>
    <v-card-title class="headline">
      {{ $t('Delete-Confirmation') }}
    </v-card-title>

    <v-card-text>
      {{ deleteConfirmMessage }}
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn flat @click="cancelDeleteConfirm">
        {{ $t('Cancel-Delete') }}
      </v-btn>

      <v-btn color="error" dark @click="confirmDelete">
        {{ $t('Yes-Delete') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-snackbar
  v-model="snackbar"
  :timeout="7000"
  top
  right
  color="error"
>
  {{ text1 }}
  <v-btn flat dark @click="snackbar = false">
    {{ $t('Close') }}
  </v-btn>
</v-snackbar>

  </div>
</template>


<script>
import tarihim from "@/components/app/customcomp/tarihim";
import caricomp from "@/components/app/customcomp/caricomp.vue";
import draggable from "vuedraggable";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import minisaticieklecomp from "@/components/app/coper/component/minisaticieklecomp.vue";
import tool from "../tools";
import rez from "../rezervasyon";
import airportNames from "../../satis/ucak/airportsNames.json";
import phoneinput from "@/components/app/customcomp/phoneinput.vue";
import Airports from "@/components/app/satis/ucak/airports.js";
import adresdefterisec from "@/components/app/coper/component/adresdefterisec.vue";
import SimpleTahsilatOdemeDialog from "@/components/app/coper/component/SimpleTahsilatOdemeDialog.vue";

function getCredentialsCurrency() {
  try {
    var credentialsText = window.localStorage.getItem("credentials");

    if (!credentialsText) {
      console.error("credentials localStorage içerisinde bulunamadı.");
      return "";
    }

    var credentials = JSON.parse(credentialsText);
    var currency =
      credentials &&
      credentials.ParaBirimi !== undefined &&
      credentials.ParaBirimi !== null
        ? credentials.ParaBirimi
        : credentials &&
          credentials.paraBirimi !== undefined &&
          credentials.paraBirimi !== null
          ? credentials.paraBirimi
          : "";

    return currency !== undefined && currency !== null
      ? currency.toString().trim()
      : "";
  } catch (error) {
    console.error("credentials para birimi okunamadı:", error);
    return "";
  }
}

export default {
  name: "ReservationList",

  components: {
    tarihim,
    caricomp,
    draggable,
    genelarama,
    minisaticieklecomp,
    airportNames,
    phoneinput,
    adresdefterisec,
    SimpleTahsilatOdemeDialog
  },

  data() {
    var credentialsCurrency = getCredentialsCurrency();

    return {
      addressBookSaveInProgress: false,
      closedPnrMap: {},
      countryItems: Airports.countiries(),
      airportList: airportNames,
      flightFromSearch: "",
flightToSearch: "",
      Rapor: {
  Filtreler: {
    KayitTarihiBasla: null,
    KayitTarihiBitis: null,
    ParaBirimi: credentialsCurrency,
    SearchText: null,
    Prm: {
      PCariKod: null,
      PPNR_No: null,
      PSirketNo: null,
      PCariSirket: null,
      PPNR_ParaBirimi: credentialsCurrency,
      PKayitTarihBas: null,
      PKayitTarihBit: null,
      PDonem1Bas: null,
      PDonem1Bit: null,
      PDonem2Bas: null,
      PDonem2Bit: null,
      PSaticiKod: null,
      PTurOp: null,
      PMasrafMerkezi: null
    }
  },
  Paging: {
    SayfaNo: 1,
    VeriAdet: 50,
    SiralamaTip: 1
  }
},
deleteConfirmDialog: false,
deleteConfirmMessage: "",
deleteConfirmType: "",
deleteConfirmCollectionName: "",
deleteConfirmIndex: null,
serviceVoucherDialog: false,
serviceVoucherLoading: false,
serviceVoucherLang: "",
serviceVoucherSection: null,
serviceVoucherShowPrice: true,
serviceVoucherLangItems: [
  { text: "Türkçe", value: "tr" },
  { text: "English", value: "en" },
  { text: "Deutsch", value: "de" },
  { text: "Français", value: "fr" }
],
      generalVoucherDialog: false,
      flightVoucherLoading: false,
generalVoucherLoading: false,
generalVoucherLang: "",
generalVoucherShowPrice: true,
      loadingvmodel: false,
text1: "",
snackbar: false,
simplePaymentLoading: false,
simplePaymentSectionOpen: true,
simpleInvoiceDraftDeleteLoading: false,
rezControl: 0,

kalemData: {
  kalem: rez.Kalem(),
  Kalemler: [],
  Rez: rez.Rezervasyon(),
  Kisiler: [],
  islem: "new",
  aktif: false,
  recordno: null
},
hotelRoomTypeList: [
  { text: "SINGLE", value: "SGL" },
  { text: "DOUBLE", value: "DBL" },
  { text: "TRIPLE", value: "TRP" }
],

      statecari: [],

      serviceSectionOrder: [
        "flights",
        "hotels",
        "cruises",
        "cars",
        "transfers",
        "dailyTours",
        "others"
      ],

      serviceSectionOpen: {
        flights: true,
        hotels: true,
        cruises: true,
        cars: true,
        transfers: true,
        dailyTours: true,
        others: true
      },

      search: "",
      startDateFilter: null,
      endDateFilter: null,
      appliedStartDateFilter: null,
      appliedEndDateFilter: null,
      statusFilter: "All Statuses",

      dialog: false,
      detailMode: false,
      isEditMode: false,
      editingPnrCode: null,
      selectedReservationIndex: -1,
      editingPassengerIndex: null,

      editingFlightIndex: null,
      editingHotelIndex: null,
      editingCruiseIndex: null,
      editingCarIndex: null,
      editingTransferIndex: null,
      editingDailyTourIndex: null,
      editingOtherIndex: null,

      carDropoffAutoFill: true,
      passengerBirthDateText: "",

      fromDateMenu: false,
      toDateMenu: false,

      flightDialog: false,
      hotelDialog: false,
      carDialog: false,
      transferDialog: false,
      dailyTourDialog: false,
      passengerDialog: false,
      cruiseDialog: false,
      otherDialog: false,

      flightDepartureDateMenu: false,
      flightArrivalDateMenu: false,
      flightOptionDateMenu: false,
      hotelCheckInMenu: false,
      hotelCheckOutMenu: false,
      carPickupDateMenu: false,
      carDropoffDateMenu: false,
      transferDateMenu: false,
      dailyTourDateMenu: false,
      cruiseCheckInMenu: false,
      cruiseCheckOutMenu: false,
      otherStartDateMenu: false,
      otherEndDateMenu: false,
      passengerBirthDateMenu: false,

      statusList: ["All Statuses", "Open", "Closed"],
      formStatusList: ["Open", "Closed"],
      formPaymentList: ["Unpaid", "Partial", "Paid"],
      currencyList: ["EUR", "USD", "GBP", "TRY"],

      flightBookingTypeList: ["Reservation", "Ticket"],
      flightClassList: ["Economy", "Business", "First"],
      flightTypeList: ["International", "Domestic"],
      passengerTypeItems: ["Yetişkin", "Çocuk", "Bebek"],
      genderItems: [
  { text: "Erkek", value: "E" },
  { text: "Kadın", value: "K" }
],

      boardTypeList: [
        "Room Only",
        "Bed & Breakfast",
        "Half Board",
        "Full Board"
      ],

      carCategoryList: ["Economy", "Compact", "SUV", "Premium"],
      transferTypeList: ["Private", "Shared", "VIP"],
      maxTransferExtraHourCount: 3,

      headers: [
  { text: this.$t("PNR"), value: "displayPnr", sortable: false },
  { text: this.$t("Customer"), value: "customer", sortable: false },
  { text: this.$t("Travel-Dates"), value: "travelDate", sortable: false },
  { text: this.$t("Status"), value: "status", sortable: false },
  { text: this.$t("Payment"), value: "payment", sortable: false },
  { text: this.$t("Total"), value: "total", sortable: false },
  { text: this.$t("Actions"), value: "action", sortable: false, align: "center" }
],

      reservations: [],

      form: this.getEmptyReservationForm(),

      flightForm: this.getEmptyFlightForm(),
      hotelForm: this.getEmptyHotelForm(),
      carForm: this.getEmptyCarForm(),
      transferForm: this.getEmptyTransferForm(),
      dailyTourForm: this.getEmptyDailyTourForm(),
      cruiseForm: this.getEmptyCruiseForm(),
      otherForm: this.getEmptyOtherForm(),

      passengerForm: this.getEmptyPassengerForm()
    };
  },

  computed: {
    //Fatura silme işlemi için sabit yazılar seçili uygulama diline göre gösterilir.
    //Dil dosyalarına yeni anahtar eklenmeden TR / EN / DE / FR desteği sağlanır.
    simpleInvoiceDeleteTexts() {
      var locale =
        this.$i18n && this.$i18n.locale
          ? this.$i18n.locale.toString().trim().toLowerCase().split(/[-_]/)[0]
          : (window.localStorage.getItem("lang") || "tr")
              .toString()
              .trim()
              .toLowerCase()
              .split(/[-_]/)[0];

      var translations = {
        tr: {
          label: "Fatura Sil",
          moreActions: "Diğer İşlemler",
          notFound: "Silinecek fatura kaydı bulunamadı.",
          pnrNotFound: "Faturanın bağlı olduğu PNR bulunamadı.",
          confirm: "Bu rezervasyona ait fatura kaydını silmek istediğinize emin misiniz?",
          success: "Fatura silindi.",
          failed: "Fatura silinemedi."
        },
        en: {
          label: "Delete Invoice",
          moreActions: "More Actions",
          notFound: "No invoice record was found to delete.",
          pnrNotFound: "The PNR linked to the invoice could not be found.",
          confirm: "Are you sure you want to delete the invoice for this reservation?",
          success: "Invoice deleted.",
          failed: "Invoice could not be deleted."
        },
        de: {
          label: "Rechnung löschen",
          moreActions: "Weitere Aktionen",
          notFound: "Kein zu löschender Rechnungseintrag wurde gefunden.",
          pnrNotFound: "Die mit der Rechnung verknüpfte PNR wurde nicht gefunden.",
          confirm: "Möchten Sie die Rechnung für diese Reservierung wirklich löschen?",
          success: "Rechnung wurde gelöscht.",
          failed: "Rechnung konnte nicht gelöscht werden."
        },
        fr: {
          label: "Supprimer la facture",
          moreActions: "Autres actions",
          notFound: "Aucun enregistrement de facture à supprimer n’a été trouvé.",
          pnrNotFound: "Le PNR lié à la facture est introuvable.",
          confirm: "Voulez-vous vraiment supprimer la facture de cette réservation ?",
          success: "Facture supprimée.",
          failed: "Impossible de supprimer la facture."
        }
      };

      return translations[locale] || translations.tr;
    },

    //Ülke/uyruk listesini seçili uygulama diline göre gösterir.
    //Backend'e gönderilen mevcut ülke değeri değiştirilmez.
    translatedCountryItems() {
      var locale =
        this.$i18n && this.$i18n.locale
          ? this.$i18n.locale.toString().toLowerCase().split("-")[0]
          : (window.localStorage.getItem("lang") || "tr")
              .toString()
              .toLowerCase()
              .split("-")[0];

      if (["tr", "en", "de", "fr"].indexOf(locale) === -1) {
        locale = "tr";
      }

      var sourceItems = Array.isArray(this.countryItems)
        ? this.countryItems.slice()
        : [];

      var hasEnglishNationality = sourceItems.some(function(item) {
        return (
          item &&
          item.code &&
          item.code.toString().trim().toUpperCase() === "GB"
        );
      });

      //Kaynak listede GB kaydı yoksa İngiliz uyruğunu güvenli şekilde ekler.
      if (!hasEnglishNationality) {
        sourceItems.push({
          name: "İngiliz",
          currency: "GBP",
          code: "GB",
          name_translations: {
            en: "English"
          }
        });
      }

      var regionDisplayNames = null;

      try {
        if (
          typeof Intl !== "undefined" &&
          typeof Intl.DisplayNames === "function"
        ) {
          regionDisplayNames = new Intl.DisplayNames([locale], {
            type: "region"
          });
        }
      } catch (error) {
        regionDisplayNames = null;
      }

      var englishNationalityTexts = {
        tr: "İngiliz",
        en: "English",
        de: "Englisch",
        fr: "Anglais"
      };

      return sourceItems
        .map(function(item) {
          item = item || {};

          var code = item.code
            ? item.code.toString().trim().toUpperCase()
            : "";

          var sourceName = item.name
            ? item.name.toString().trim()
            : "";

          var englishName =
            item.name_translations &&
            item.name_translations.en
              ? item.name_translations.en.toString().trim()
              : "";

          var translatedName = "";

          //Uyruk alanında GB kaydı İngiliz / English olarak gösterilir.
          if (code === "GB") {
            translatedName =
              englishNationalityTexts[locale] ||
              sourceName ||
              englishName;
          }

          if (
            !translatedName &&
            regionDisplayNames &&
            /^[A-Z]{2}$/.test(code)
          ) {
            try {
              translatedName = regionDisplayNames.of(code) || "";
            } catch (error) {
              translatedName = "";
            }
          }

          if (!translatedName && locale === "en" && englishName) {
            translatedName = englishName;
          }

          if (!translatedName) {
            translatedName = sourceName || englishName || code;
          }

          var aliases = [
            translatedName,
            sourceName,
            englishName,
            code
          ];

          if (code === "GB") {
            aliases = aliases.concat([
              "İngiliz",
              "Ingiliz",
              "English",
              "British",
              "Britain",
              "England",
              "İngiltere",
              "Ingiltere",
              "Birleşik Krallık",
              "Birlesik Krallik",
              "United Kingdom",
              "Englisch",
              "Britisch",
              "Anglais",
              "Britannique"
            ]);
          }

          return Object.assign({}, item, {
            text: translatedName,
            //Mevcut backend kayıt yapısını bozmamak için orijinal değer korunur.
            value: sourceName || englishName || code,
            searchText: aliases
              .filter(function(value) {
                return (
                  value !== undefined &&
                  value !== null &&
                  value.toString().trim() !== ""
                );
              })
              .join(" ")
          });
        })
        .sort(function(a, b) {
          return (a.text || "").localeCompare(
            b.text || "",
            locale
          );
        });
    },

    //Yolcu tiplerini ekranda seçili dile göre gösterir.
    //Backend'e mevcut Türkçe değerler gönderilmeye devam eder.
    translatedPassengerTypeItems() {
      return [
        {
          text: this.$t("Adult"),
          value: "Yetişkin"
        },
        {
          text: this.$t("Child"),
          value: "Çocuk"
        },
        {
          text: this.$t("Baby"),
          value: "Bebek"
        }
      ];
    },

    //Cinsiyet seçeneklerini ekranda seçili dile göre gösterir.
    //Backend'e mevcut E/K kodları gönderilmeye devam eder.
    translatedGenderItems() {
      return [
        {
          text: this.$t("Male"),
          value: "E"
        },
        {
          text: this.$t("Female"),
          value: "K"
        }
      ];
    },

    translatedTransferServiceTypeList() {
  return [
    {
      text: this.$t("Transfers2"),
      value: "Transfer"
    },
    {
      text: this.$t("Allocation"),
      value: "Tahsis"
    }
  ];
},
  translatedStatusList() {
  return [
    { text: this.$t("All-Statuses"), value: "All Statuses" },
    { text: this.$t("Open"), value: "Open" },
    { text: this.$t("Closed"), value: "Closed" }
  ];
},

translatedFormStatusList() {
  return [
    { text: this.$t("Open"), value: "Open" },
    { text: this.$t("Closed"), value: "Closed" }
  ];
},

translatedFormPaymentList() {
  return [
    { text: this.$t("Unpaid"), value: "Unpaid" },
    { text: this.$t("Partial"), value: "Partial" },
    { text: this.$t("Paid"), value: "Paid" }
  ];
},
    reservationCountText() {
  var shownCount = this.filteredReservations
    ? this.filteredReservations.length
    : 0;

  var totalCount = this.reservations
    ? this.reservations.length
    : 0;

  if (shownCount === totalCount) {
    return shownCount + " " + this.$t("Records");
  }

  return shownCount + " / " + totalCount + " " + this.$t("Records");
},
    airportSelectItems() {
  return this.buildSortedAirportItems("");
},

airportFromSelectItems() {
  return this.buildSortedAirportItems(this.flightFromSearch);
},

airportToSelectItems() {
  return this.buildSortedAirportItems(this.flightToSearch);
},
    selectedReservation() {
      if (this.selectedReservationIndex > -1) {
        return this.reservations[this.selectedReservationIndex];
      }

      return null;
    },

    simplePayments() {
      if (
        this.kalemData &&
        this.kalemData.Rez &&
        Array.isArray(this.kalemData.Rez.odemeler)
      ) {
        return this.kalemData.Rez.odemeler;
      }

      return [];
    },

    simpleCollectedTotal() {
      return this.simplePayments.reduce(function(total, payment) {
        if (!payment) {
          return total;
        }

        var value =
          payment.hedefParaTutar !== undefined &&
          payment.hedefParaTutar !== null
            ? payment.hedefParaTutar
            : payment.HedefParaTutar;

        return total + Number(value || 0);
      }, 0);
    },

    simpleRemainingBalance() {
      var total = Number(this.reservationGrossTotal || 0);
      var collected = Number(this.simpleCollectedTotal || 0);

      return Math.max(0, total - collected);
    },

    simplePaymentStatus() {
      var collected = Number(this.simpleCollectedTotal || 0);
      var remainingBalance = Number(this.simpleRemainingBalance || 0);
      var tolerance = 0.01;

      if (collected <= tolerance) {
        return "Unpaid";
      }

      if (remainingBalance > tolerance) {
        return "Partial";
      }

      return "Paid";
    },

    serviceDialogPassengers() {
      if (!this.selectedReservation || !this.selectedReservation.passengers) {
        return [];
      }

      return this.selectedReservation.passengers;
    },

    filteredReservations() {
  var self = this;

  return this.reservations.filter(function(item) {
  if (!self.hasValidTakipNo(item)) {
    return false;
  }

  var text = self.search ? self.search.toLowerCase() : "";

    var matchSearch =
      !text ||
      (item.pnr && item.pnr.toString().toLowerCase().indexOf(text) > -1) ||
      (item.takipNo && item.takipNo.toString().toLowerCase().indexOf(text) > -1) ||
      (item.sourcePnr && item.sourcePnr.toString().toLowerCase().indexOf(text) > -1) ||
      (item.customer && item.customer.toLowerCase().indexOf(text) > -1);

    var matchStatus =
      self.statusFilter === "All Statuses" ||
      item.status === self.statusFilter;

    var itemDate = item.travelFrom || "";
    var matchStart = true;
    var matchEnd = true;

    if (self.appliedStartDateFilter) {
      matchStart = itemDate && itemDate >= self.appliedStartDateFilter;
    }

    if (self.appliedEndDateFilter) {
      matchEnd = itemDate && itemDate <= self.appliedEndDateFilter;
    }

    return matchSearch && matchStatus && matchStart && matchEnd;
  });
},

    activeCurrency() {
      return getCredentialsCurrency();
    },

    passengerCount() {
      return this.serviceDialogPassengers.length;
    },

    canAddServiceItems() {
      return this.passengerCount > 0;
    },

    reservationNetTotal() {
      if (!this.selectedReservation) return 0;
      return this.sumServiceField(this.selectedReservation, "netPrice");
    },

    reservationVatTotal() {
      if (!this.selectedReservation) return 0;
      return this.sumServiceField(this.selectedReservation, "vatAmount");
    },

    reservationGrossTotal() {
      if (!this.selectedReservation) return 0;
      return this.sumServiceField(this.selectedReservation, "grossPrice");
    },

    flightVatAmount() {
      return this.calculateVatAmount(
        this.flightForm.netPrice,
        this.flightForm.vatRate
      );
    },

   flightGrossAmount() {
  var net = Number(this.flightForm.netPrice) || 0;
  var tax = Number(this.flightForm.taxAmount) || 0;

  if (this.flightForm.flightType === "Domestic") {
    return (
      net +
      tax +
      (Number(this.flightForm.airportTax) || 0)
    );
  }

  return (
    this.calculateGrossAmount(
      this.flightForm.netPrice,
      this.flightForm.vatRate
    ) + tax
  );
},

    hotelVatAmount() {
      return this.calculateVatAmount(
        this.hotelForm.netPrice,
        this.hotelForm.vatRate
      );
    },

    hotelGrossAmount() {
      return this.calculateGrossAmount(
        this.hotelForm.netPrice,
        this.hotelForm.vatRate
      );
    },

    carVatAmount() {
      return this.calculateVatAmount(
        this.carForm.netPrice,
        this.carForm.vatRate
      );
    },

    carGrossAmount() {
      return this.calculateGrossAmount(
        this.carForm.netPrice,
        this.carForm.vatRate
      );
    },

    transferVatAmount() {
      return this.calculateVatAmount(
        this.transferForm.netPrice,
        this.transferForm.vatRate
      );
    },

    transferGrossAmount() {
      return this.calculateGrossAmount(
        this.transferForm.netPrice,
        this.transferForm.vatRate
      );
    },

    dailyTourVatAmount() {
      return this.calculateVatAmount(
        this.dailyTourForm.netPrice,
        this.dailyTourForm.vatRate
      );
    },

    dailyTourGrossAmount() {
      return this.calculateGrossAmount(
        this.dailyTourForm.netPrice,
        this.dailyTourForm.vatRate
      );
    },

    cruiseVatAmount() {
      return this.calculateVatAmount(
        this.cruiseForm.netPrice,
        this.cruiseForm.vatRate
      );
    },

    cruiseGrossAmount() {
      return this.calculateGrossAmount(
        this.cruiseForm.netPrice,
        this.cruiseForm.vatRate
      );
    },

    otherVatAmount() {
      return this.calculateVatAmount(
        this.otherForm.netPrice,
        this.otherForm.vatRate
      );
    },

    otherGrossAmount() {
      return this.calculateGrossAmount(
        this.otherForm.netPrice,
        this.otherForm.vatRate
      );
    }
  },

  watch: {
    "carForm.pickupLocation"(val) {
      if (!this.carForm.dropoffLocation || this.carDropoffAutoFill) {
        this.carForm.dropoffLocation = val;
        this.carDropoffAutoFill = true;
      }
    },

    "carForm.dropoffLocation"(val) {
      this.carDropoffAutoFill = val === this.carForm.pickupLocation;
    },

    simplePaymentStatus() {
      this.syncSimplePaymentStatus();
    }
  },

mounted() {
  this.openReservationDetailFromRoute()
},

  methods: {
    //Uyruk aramasında Türkçe, İngilizce ve ülke kodu karşılıklarını birlikte arar.
    countrySearchFilter(item, queryText, itemText) {
      var normalizeText = function(value) {
        var normalized = value === undefined || value === null
          ? ""
          : value.toString();

        normalized = normalized
          .toLocaleLowerCase("tr-TR")
          .replace(/ı/g, "i");

        if (typeof normalized.normalize === "function") {
          normalized = normalized
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
        }

        return normalized;
      };

      var searchValue =
        item && item.searchText
          ? item.searchText
          : itemText || "";

      return normalizeText(searchValue).indexOf(
        normalizeText(queryText)
      ) !== -1;
    },

    getExistingPaymentStatus(takipNo, pnrNo) {
  var reservations = this.reservations || [];

  var takipKey = takipNo ? takipNo.toString() : "";
  var pnrKey = pnrNo ? pnrNo.toString() : "";

  for (var i = 0; i < reservations.length; i++) {
    var reservation = reservations[i] || {};

    var reservationTakipNo =
      reservation.takipNo ||
      reservation.TakipNo ||
      reservation.pnr ||
      "";

    reservationTakipNo = reservationTakipNo
      ? reservationTakipNo.toString()
      : "";

    var childPnrList = reservation.childPnrList || [];

    var hasChildPnr = childPnrList.some(function(childPnr) {
      return childPnr && childPnr.toString() === pnrKey;
    });

    if (
      (takipKey && reservationTakipNo === takipKey) ||
      (pnrKey && reservationTakipNo === pnrKey) ||
      hasChildPnr
    ) {
      return reservation.payment || "Unpaid";
    }
  }

  return "Unpaid";
},

    getListPaymentInfo(item, takipNo, pnrNo) {
  item = item || {};

  var total = Number(
    item.Satis !== undefined && item.Satis !== null
      ? item.Satis
      : item.satis !== undefined && item.satis !== null
        ? item.satis
        : item.Tutar !== undefined && item.Tutar !== null
          ? item.Tutar
          : item.tutar || 0
  ) || 0;

  var paidValue =
    item.Odeme !== undefined && item.Odeme !== null
      ? item.Odeme
      : item.odeme !== undefined && item.odeme !== null
        ? item.odeme
        : item.Odenen !== undefined && item.Odenen !== null
          ? item.Odenen
          : item.odenen;

  var balanceValue =
    item.Bakiye !== undefined && item.Bakiye !== null
      ? item.Bakiye
      : item.bakiye !== undefined && item.bakiye !== null
        ? item.bakiye
        : item.Kalan !== undefined && item.Kalan !== null
          ? item.Kalan
          : item.kalan;

  var hasPaidValue =
    paidValue !== undefined &&
    paidValue !== null &&
    paidValue !== "";

  var hasBalanceValue =
    balanceValue !== undefined &&
    balanceValue !== null &&
    balanceValue !== "";

  var paidTotal = hasPaidValue ? Number(paidValue) || 0 : 0;
  var remainingBalance = hasBalanceValue
    ? Math.max(0, Number(balanceValue) || 0)
    : Math.max(0, total - paidTotal);

  var tolerance = 0.01;
  var paymentStatus = "Unpaid";

  if (paidTotal > tolerance) {
    if (
      remainingBalance <= tolerance ||
      (total > tolerance && paidTotal >= total - tolerance)
    ) {
      paymentStatus = "Paid";
    } else {
      paymentStatus = "Partial";
    }
  }

  // Liste servisi kısa süreli cache'ten eski veri döndürürse detay ekranında
  // güncellenen ödeme durumu listeye geri dönerken kaybolmasın.
  var existingStatus = this.getExistingPaymentStatus(takipNo, pnrNo);

  if (
    paymentStatus === "Unpaid" &&
    (existingStatus === "Partial" || existingStatus === "Paid")
  ) {
    paymentStatus = existingStatus;
  }

  return {
    status: paymentStatus,
    total: total,
    paidTotal: Math.max(0, paidTotal),
    remainingBalance: remainingBalance,
    hasBackendPaymentInfo: hasPaidValue || hasBalanceValue
  };
},
    saveReservationDialog() {
  // Yeni rezervasyon oluşturuluyorsa mevcut metot çalışsın.
  if (!this.isEditMode) {
    this.createReservationDraft();
    return;
  }

  // Mevcut rezervasyon güncelleniyorsa yeni #NEW taslağı oluşturma.
  if (!this.selectedReservation) {
    this.text1 = "Güncellenecek rezervasyon bulunamadı.";
    this.snackbar = true;
    return;
  }

  if (!this.form.customerCode) {
    alert("Customer zorunludur.");
    return;
  }

  if (!this.form.travelFrom || !this.form.travelTo) {
    alert("Travel From and Travel To zorunludur.");
    return;
  }

  var travelFrom = this.normalizeDateValue(this.form.travelFrom);
  var travelTo = this.normalizeDateValue(this.form.travelTo);

  if (!travelFrom || !travelTo) {
    alert(
      "Seyahat tarihleri zorunludur ve dd.mm.yyyy formatında olmalıdır."
    );
    return;
  }

  if (travelFrom > travelTo) {
    alert("Travel From tarihi Travel To tarihinden büyük olamaz.");
    return;
  }

  var currentReservation = this.selectedReservation;

  // Yalnızca dialogda değiştirilebilen ana bilgileri güncelle.
  // Yolcular ve hizmet kalemleri korunur.
  this.$set(
    currentReservation,
    "customerCode",
    this.form.customerCode || ""
  );

  this.$set(
    currentReservation,
    "customer",
    this.form.customerName || this.form.customer || ""
  );

  this.$set(currentReservation, "travelFrom", travelFrom);
  this.$set(currentReservation, "travelTo", travelTo);

  this.$set(
    currentReservation,
    "travelDate",
    this.formatTravelDate(travelFrom, travelTo)
  );

  this.$set(
    currentReservation,
    "status",
    this.form.status || "Open"
  );

  this.$set(
    currentReservation,
    "payment",
    this.form.payment || "Unpaid"
  );

  this.$set(
    currentReservation,
    "currency",
    getCredentialsCurrency()
  );

  this.$set(
    currentReservation,
    "isClosed",
    (this.form.status || "Open") === "Closed"
  );

  // Takip numarasını kaybetme.
  this.editingPnrCode =
    currentReservation.takipNo ||
    currentReservation.TakipNo ||
    currentReservation.pnr ||
    this.editingPnrCode;

  this.isEditMode = true;

  // Sadece dialogu kapat.
  // closeDialog() kullanılmıyor; çünkü edit kimliğini sıfırlıyor.
  this.dialog = false;
  this.resetForm();
},
    deleteSimpleInvoiceDraft() {
  if (!this.selectedReservation) {
    this.text1 = this.simpleInvoiceDeleteTexts.notFound;
    this.snackbar = true;
    return;
  }

  var pnrNo = this.getRealPnrForGeneralVoucher();

  if (!pnrNo) {
    pnrNo =
      this.selectedReservation.sourcePnr ||
      this.selectedReservation.pnr ||
      "";
  }

  pnrNo = pnrNo ? pnrNo.toString().trim() : "";

  if (!pnrNo || pnrNo === "0" || pnrNo === "-") {
    this.text1 = this.simpleInvoiceDeleteTexts.pnrNotFound;
    this.snackbar = true;
    return;
  }

  var confirmed = confirm(
    this.simpleInvoiceDeleteTexts.confirm
  );

  if (!confirmed) {
    return;
  }

  var params = {
    PNR_No: Number(pnrNo) || pnrNo
  };

  this.simpleInvoiceDraftDeleteLoading = true;

  tool.http_post(this, "PNRFaturaTaslagiSil", params).then(
    response => {
      this.simpleInvoiceDraftDeleteLoading = false;

      if (response.body && response.body.Status === true) {
        window.localStorage.removeItem("container_toplufatura");

        this.clearSimpleInvoiceInfoFromUI();

        this.text1 = this.simpleInvoiceDeleteTexts.success;
        this.snackbar = true;
        return;
      }

      this.text1 =
        response.body &&
        response.body.ErrorList &&
        response.body.ErrorList.length
          ? response.body.ErrorList[0]
          : this.simpleInvoiceDeleteTexts.failed;
      this.snackbar = true;
    },
    response => {
      this.simpleInvoiceDraftDeleteLoading = false;

      this.HataYonetimi
        ? this.HataYonetimi(response, params, this.simpleInvoiceDeleteTexts.failed)
        : null;

      if (!this.HataYonetimi) {
        this.text1 = "Service Unavailable - PNRFaturaTaslagiSil";
        this.snackbar = true;
      }
    }
  );
},

    clearSimpleInvoiceInfoFromUI() {
  if (!this.selectedReservation) {
    return;
  }

  var displayPnr =
    this.selectedReservation.displayPnr ||
    this.selectedReservation.takipNo ||
    this.selectedReservation.pnr ||
    "";

  this.$set(this.selectedReservation, "isInvoiced", false);
  this.$set(this.selectedReservation, "invoiceNo", "");
  this.$set(this.selectedReservation, "invoiceSeries", "");
  this.$set(this.selectedReservation, "invoiceText", "");
  this.$set(this.selectedReservation, "invoiceNoList", []);
  this.$set(this.selectedReservation, "invoicedPnrList", []);

  (this.reservations || []).forEach(function(item) {
    if (!item) {
      return;
    }

    var itemDisplayPnr =
      item.displayPnr ||
      item.takipNo ||
      item.pnr ||
      "";

    if (
      itemDisplayPnr &&
      displayPnr &&
      itemDisplayPnr.toString() === displayPnr.toString()
    ) {
      this.$set(item, "isInvoiced", false);
      this.$set(item, "invoiceNo", "");
      this.$set(item, "invoiceSeries", "");
      this.$set(item, "invoiceText", "");
      this.$set(item, "invoiceNoList", []);
      this.$set(item, "invoicedPnrList", []);
    }
  }.bind(this));
},

    simpleInvoiceGetInvoiceInfoByTakipNo(takipNo) {
  return new Promise(function(resolve) {
    takipNo = takipNo ? takipNo.toString().trim() : "";

    if (!takipNo) {
      resolve(null);
      return;
    }

    var credentials = null;

    try {
      credentials = JSON.parse(window.localStorage.getItem("credentials"));
    } catch (e) {
      credentials = null;
    }

    var rapor = {};

    try {
      rapor = JSON.parse(JSON.stringify(this.Rapor || {}));
    } catch (e) {
      rapor = this.Rapor || {};
    }

    if (!rapor.Filtreler) {
      rapor.Filtreler = {};
    }

    if (!rapor.Filtreler.Prm) {
      rapor.Filtreler.Prm = {};
    }

    var credentialsCurrency = getCredentialsCurrency();
    rapor.Filtreler.ParaBirimi = credentialsCurrency;
    rapor.Filtreler.Prm.PPNR_ParaBirimi = credentialsCurrency;

    // Refresh sonrası fatura bilgisi kaybolmasın diye tarihi geniş tutuyoruz.
    rapor.Filtreler.KayitTarihiBasla = "2000-01-01";
    rapor.Filtreler.KayitTarihiBitis = "2099-12-31";
    rapor.Filtreler.SearchText = takipNo;

    if (credentials) {
      rapor.Filtreler.Prm.PCariSirket = credentials.SirketKodu;
      rapor.Filtreler.Prm.PSirketNo = credentials.CoperSirketNo;
    }

    tool.http_post(this, "GunlukSatisListPaging", rapor).then(
      function(response) {
        if (response.body && response.body.Status === true) {
          var mappedList = (response.body.data || [])
            .map(function(item) {
              return this.mapListItemToSimpleReservation(item);
            }.bind(this))
            .filter(function(item) {
              return this.hasValidTakipNo(item);
            }.bind(this));

          var groupedList = this.groupReservationListByTakipNo(mappedList);

          var found = groupedList.find(function(item) {
            var itemTakipNo =
              item.displayPnr ||
              item.takipNo ||
              item.pnr ||
              "";

            return itemTakipNo.toString() === takipNo.toString();
          });

          if (found && found.isInvoiced) {
            resolve({
              isInvoiced: true,
              invoiceNo: found.invoiceNo || "",
              invoiceSeries: found.invoiceSeries || "",
              invoiceText: found.invoiceText || "",
              invoiceNoList: found.invoiceNoList || [],
              invoicedPnrList: found.invoicedPnrList || []
            });
            return;
          }
        }

        resolve(null);
      }.bind(this),
      function() {
        resolve(null);
      }.bind(this)
    );
  }.bind(this));
},
    simpleInvoiceApplyApprovedInvoiceToUI(faturaTaslak, invoiceText) {
  if (!this.selectedReservation) return;

  this.selectedReservation.isInvoiced = true;
  this.selectedReservation.invoiceText = invoiceText || "";

  this.selectedReservation.invoiceNo =
    (faturaTaslak && faturaTaslak.FaturaNo) || "";

  this.selectedReservation.invoiceSeries =
    (faturaTaslak && faturaTaslak.FaturaSeri) || "";

  if (!this.selectedReservation.invoiceNoList) {
    this.selectedReservation.invoiceNoList = [];
  }

  if (
    invoiceText &&
    this.selectedReservation.invoiceNoList.indexOf(invoiceText) === -1
  ) {
    this.selectedReservation.invoiceNoList.push(invoiceText);
  }

  var displayPnr =
    this.selectedReservation.displayPnr ||
    this.selectedReservation.takipNo ||
    this.selectedReservation.pnr ||
    "";

  if (this.reservations && this.reservations.length) {
    this.reservations.forEach(function(item) {
      var itemDisplayPnr =
        item.displayPnr ||
        item.takipNo ||
        item.pnr ||
        "";

      if (itemDisplayPnr && displayPnr && itemDisplayPnr.toString() === displayPnr.toString()) {
        item.isInvoiced = true;
        item.invoiceText = invoiceText || "";
        item.invoiceNo = this.selectedReservation.invoiceNo;
        item.invoiceSeries = this.selectedReservation.invoiceSeries;

        if (!item.invoiceNoList) {
          item.invoiceNoList = [];
        }

        if (invoiceText && item.invoiceNoList.indexOf(invoiceText) === -1) {
          item.invoiceNoList.push(invoiceText);
        }
      }
    }.bind(this));
  }
},
    simpleInvoiceBuildApprovedInvoiceText(faturaTaslak, approveData) {
  var seri =
    (faturaTaslak && faturaTaslak.FaturaSeri) ||
    (approveData && approveData.FaturaSeri) ||
    "";

  var no =
    (faturaTaslak && faturaTaslak.FaturaNo) ||
    (approveData && approveData.FaturaNo) ||
    "";

  if (seri || no) {
    return ((seri || "") + "-" + (no || ""))
      .replace(/^-/, "")
      .replace(/-$/, "");
  }

  if (faturaTaslak && faturaTaslak.FaturaNoStr) {
    return faturaTaslak.FaturaNoStr;
  }

  if (approveData && approveData.FaturaNoStr) {
    return approveData.FaturaNoStr;
  }

  return "";
},
    simpleInvoiceApproveDraft(faturaTaslak, taslakIdList, takipNo) {
  if (!faturaTaslak) {
    this.loadingvmodel = false;
    this.simpleInvoiceError("Fatura taslağı bulunamadı.");
    return;
  }

  if (!taslakIdList || taslakIdList.length === 0) {
    if (faturaTaslak.Id) {
      taslakIdList = [faturaTaslak.Id];
    } else {
      this.loadingvmodel = false;
      this.simpleInvoiceError("Onaylanacak fatura taslak ID bulunamadı.");
      return;
    }
  }

  var updateParams = {
    FaturaTaslak: faturaTaslak
  };

  tool.http_post(this, "FaturaTaslakUpdate", updateParams).then(
    function(updateResponse) {
      if (!updateResponse.body || updateResponse.body.Status !== true) {
        this.loadingvmodel = false;

        this.simpleInvoiceError(
          updateResponse.body &&
          updateResponse.body.ErrorList &&
          updateResponse.body.ErrorList.length
            ? updateResponse.body.ErrorList[0]
            : "Fatura taslağı güncellenemedi."
        );

        return;
      }

      var approveParams = {
        TaslakIdList: taslakIdList
      };

      tool.http_post(this, "SatisFaturasiTaslakOnayla", approveParams).then(
        function(approveResponse) {
          this.loadingvmodel = false;

          if (approveResponse.body && approveResponse.body.Status === true) {
            var invoiceText = this.simpleInvoiceBuildApprovedInvoiceText(
              faturaTaslak,
              approveResponse.body.data
            );

            this.simpleInvoiceApplyApprovedInvoiceToUI(
              faturaTaslak,
              invoiceText
            );

            this.text1 = invoiceText
              ? "Fatura basıldı: " + invoiceText
              : "Fatura başarıyla basıldı.";

            this.snackbar = true;
            return;
          }

          this.simpleInvoiceError(
            approveResponse.body &&
            approveResponse.body.ErrorList &&
            approveResponse.body.ErrorList.length
              ? approveResponse.body.ErrorList[0]
              : "Fatura taslağı onaylanamadı."
          );
        }.bind(this),
        function(response) {
          this.loadingvmodel = false;
          this.HataYonetimi
            ? this.HataYonetimi(response, approveParams, "Fatura taslağı onaylanamadı")
            : this.simpleInvoiceError("Fatura taslağı onaylanamadı.");
        }.bind(this)
      );
    }.bind(this),
    function(response) {
      this.loadingvmodel = false;
      this.HataYonetimi
        ? this.HataYonetimi(response, updateParams, "Fatura taslağı güncellenemedi")
        : this.simpleInvoiceError("Fatura taslağı güncellenemedi.");
    }.bind(this)
  );
},
    getSimplePaymentPnrNo() {
      if (!this.selectedReservation) return "";

      var pnrNo = this.getRealPnrForGeneralVoucher();
      pnrNo = pnrNo ? pnrNo.toString().trim() : "";

      if (!pnrNo || pnrNo === "0" || pnrNo === "-") return "";

      return pnrNo;
    },

    prepareSimplePaymentContext() {
      var pnrNo = this.getSimplePaymentPnrNo();

      if (!pnrNo || !this.kalemData || !this.kalemData.Rez) {
        return false;
      }

      this.$set(this.kalemData.Rez, "pNR_No", Number(pnrNo) || pnrNo);

      if (!this.kalemData.Rez.toplamTL) {
        this.$set(this.kalemData.Rez, "toplamTL", {});
      }

      this.$set(
        this.kalemData.Rez.toplamTL,
        "netSatis",
        Number(this.selectedReservation.total) || 0
      );

      return true;
    },

    getSimplePaymentDate() {
      var now = new Date();
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().padStart(2, "0");
      var day = now.getDate().toString().padStart(2, "0");

      return year + "-" + month + "-" + day;
    },

    getSimplePayments() {
      if (!this.prepareSimplePaymentContext()) {
        if (this.kalemData && this.kalemData.Rez) {
          this.$set(this.kalemData.Rez, "odemeler", []);
        }
        this.syncSimplePaymentStatus();
        return;
      }

      var activeCurrency = getCredentialsCurrency();

      if (!activeCurrency) {
        this.$set(this.kalemData.Rez, "odemeler", []);
        this.syncSimplePaymentStatus();
        this.text1 = "Kullanıcı para birimi bulunamadı.";
        this.snackbar = true;
        return;
      }

      var params = {
        pNR_No: this.kalemData.Rez.pNR_No,
        hedefParaBirimi: activeCurrency,
        kurTarihi: this.getSimplePaymentDate()
      };

      this.simplePaymentLoading = true;

      tool.http_post(this, "GetOdeme", params).then(
        response => {
          this.simplePaymentLoading = false;

          var payments = response && response.body
            ? response.body.data
            : [];

          this.$set(
            this.kalemData.Rez,
            "odemeler",
            Array.isArray(payments) ? payments : []
          );

          this.$nextTick(() => {
            this.syncSimplePaymentStatus();
          });
        },
        response => {
          this.simplePaymentLoading = false;
          this.$set(this.kalemData.Rez, "odemeler", []);
          this.syncSimplePaymentStatus();
          this.text1 = "Ödemeler getirilemedi.";
          this.snackbar = true;
        }
      );
    },

    syncSimplePaymentStatus() {
      var paymentStatus = this.simplePaymentStatus || "Unpaid";

      if (this.selectedReservation) {
        this.$set(this.selectedReservation, "payment", paymentStatus);
        this.$set(this.selectedReservation, "currency", getCredentialsCurrency());
      }

      if (this.form) {
        this.form.payment = paymentStatus;
        this.form.currency = getCredentialsCurrency();
      }
    },

    openSimplePaymentDialog() {
      if (!this.prepareSimplePaymentContext()) {
        this.text1 = "Tahsilat eklemek için rezervasyonun kaydedilmiş bir PNR'ı olmalıdır.";
        this.snackbar = true;
        return;
      }

      if (
        !this.$refs.simpleTahsilatOdemeDialog ||
        typeof this.$refs.simpleTahsilatOdemeDialog.open !== "function"
      ) {
        this.text1 = "Tahsilat giriş ekranı açılamadı.";
        this.snackbar = true;
        return;
      }

      var activeCurrency = getCredentialsCurrency();

      if (!activeCurrency) {
        this.text1 = "Kullanıcı para birimi bulunamadı.";
        this.snackbar = true;
        return;
      }

      if (Number(this.simpleRemainingBalance || 0) <= 0.01) {
        this.text1 = "Bu rezervasyonun kalan bakiyesi bulunmuyor.";
        this.snackbar = true;
        return;
      }

      var rezCari = this.kalemData && this.kalemData.Rez
        ? this.kalemData.Rez.cariKod || this.kalemData.Rez.CariKod
        : null;

      var currentCode =
        (this.selectedReservation && this.selectedReservation.customerCode) ||
        (rezCari && (rezCari.kod || rezCari.Kod || rezCari.id || rezCari.Id)) ||
        "";

      currentCode = currentCode ? currentCode.toString().trim() : "";

      if (!currentCode) {
        this.text1 = "Tahsilat eklemek için rezervasyonda cari kod bulunmalıdır.";
        this.snackbar = true;
        return;
      }

      var paymentDate = this.getSimplePaymentDate();
      var remainingBalance = Number(this.simpleRemainingBalance || 0);
      var paymentAmount =
        remainingBalance > 0
          ? remainingBalance
          : (
              Number(this.reservationGrossTotal) ||
              Number(this.selectedReservation && this.selectedReservation.total) ||
              0
            );

      this.$refs.simpleTahsilatOdemeDialog.open({
        simpleMode: true,
        pnrNo: this.kalemData.Rez.pNR_No,
        isEditMode: false,
        operationType: "TAHSILAT",
        paymentMethod: "CASH",
        currentCode: currentCode,
        amount: paymentAmount,
        date: paymentDate,
        dueDate: paymentDate,
        exchangeType: activeCurrency,
        exchangeRate: 1,
        exchangeAmount: paymentAmount,
        forceCurrency: true
      });
    },

    onSimplePaymentSaved(payload) {
      this.simplePaymentSectionOpen = true;

      if (payload && Array.isArray(payload.payments)) {
        this.$set(this.kalemData.Rez, "odemeler", payload.payments);
        this.$nextTick(() => {
          this.syncSimplePaymentStatus();
        });
      }

      this.getSimplePayments();
    },

    deleteSimplePayment(payment) {
      if (!payment || this.simplePaymentLoading) return;

      var confirmed = confirm(
        this.$t('Are-you-sure-you-want-to-delete-this-record')
      );

      if (!confirmed) return;

      var params = {
        P_SirketAdi: payment.sirketAdi,
        P_HesapKodu: payment.hesapKodu,
        P_Tarih: payment.tarih,
        P_SiraNo: payment.siraNo
      };

      this.simplePaymentLoading = true;

      tool.http_post(this, "GenelOdemeSil", params).then(
        response => {
          this.simplePaymentLoading = false;
          this.getSimplePayments();
        },
        response => {
          this.simplePaymentLoading = false;
          this.text1 = "Ödeme silinemedi.";
          this.snackbar = true;
        }
      );
    },

    getSimplePaymentCurrency(payment) {
      if (!payment || !payment.para) return "-";

      return payment.para.paraBirimi || payment.para.ParaBirimi || "-";
    },

    getSimplePaymentRate(payment) {
      if (!payment || !payment.para) return 0;

      return Number(payment.para.kur || payment.para.Kur || 0);
    },
    buildSortedAirportItems(searchText) {
  var search = (searchText || "").toString().trim().toUpperCase();

  var items = (this.airportList || []).map(function(item) {
    var text = item || "";
    var parts = text.split(" - ");
    var code = parts.length
      ? parts[parts.length - 1].trim().toUpperCase()
      : "";

    return {
      text: text,
      value: code,
      code: code
    };
  });

  if (search.length < 3) {
    return items;
  }

  return items.sort(function(a, b) {
    var aExact = a.code === search;
    var bExact = b.code === search;

    // Yazılan değer havalimanı koduyla tamamen aynıysa en üste getir.
    if (aExact && !bExact) return -1;
    if (!aExact && bExact) return 1;

    var aCodeStarts = a.code.indexOf(search) === 0;
    var bCodeStarts = b.code.indexOf(search) === 0;

    // Kodu yazılan harflerle başlayanları ikinci sıraya getir.
    if (aCodeStarts && !bCodeStarts) return -1;
    if (!aCodeStarts && bCodeStarts) return 1;

    var aText = (a.text || "").toUpperCase();
    var bText = (b.text || "").toUpperCase();

    var aContains = aText.indexOf(search) > -1;
    var bContains = bText.indexOf(search) > -1;

    // İçerisinde aranan metin bulunan diğer sonuçlar daha sonra gelsin.
    if (aContains && !bContains) return -1;
    if (!aContains && bContains) return 1;

    return aText.localeCompare(bText);
  });
},
    onTransferExtraHourChange(value) {
  if (!value) {
    this.$set(this.transferForm, "extraHours", []);
    this.$set(this.transferForm, "extraHourAmounts", []);
    return;
  }

  if (
    !Array.isArray(this.transferForm.extraHours) ||
    this.transferForm.extraHours.length === 0
  ) {
    this.$set(this.transferForm, "extraHours", [""]);
    this.$set(this.transferForm, "extraHourAmounts", [0]);
  }
},

addTransferExtraHour() {
  if (!Array.isArray(this.transferForm.extraHours)) {
    this.$set(this.transferForm, "extraHours", []);
  }

  if (!Array.isArray(this.transferForm.extraHourAmounts)) {
    this.$set(this.transferForm, "extraHourAmounts", []);
  }

  if (
    this.transferForm.extraHours.length >=
    this.maxTransferExtraHourCount
  ) {
    return;
  }

  this.transferForm.extraHours.push("");
  this.transferForm.extraHourAmounts.push(0);
},

removeTransferExtraHour(index) {
  if (!Array.isArray(this.transferForm.extraHours)) return;

  this.transferForm.extraHours.splice(index, 1);

  if (Array.isArray(this.transferForm.extraHourAmounts)) {
    this.transferForm.extraHourAmounts.splice(index, 1);
  }

  if (this.transferForm.extraHours.length === 0) {
    this.transferForm.hasExtraHour = false;
  }
},

onTransferExtraHourInput(index, value) {
  var text = value === null || value === undefined
    ? ""
    : value.toString();

  text = text.replace(/\D/g, "").substring(0, 4);

  if (text.length > 2) {
    text = text.substring(0, 2) + ":" + text.substring(2);
  }

  this.$set(this.transferForm.extraHours, index, text);
},

onTransferExtraHourAmountInput(index, value) {
  if (!Array.isArray(this.transferForm.extraHourAmounts)) {
    this.$set(this.transferForm, "extraHourAmounts", []);
  }

  var amount = Number(value);

  if (!isFinite(amount) || amount < 0) {
    amount = 0;
  }

  this.$set(this.transferForm.extraHourAmounts, index, amount);
},

normalizeTransferExtraHour(index) {
  var value = this.transferForm.extraHours[index];

  if (!value) {
    this.$set(this.transferForm.extraHours, index, "");
    return;
  }

  var parts = value.toString().split(":");
  var hour = Number(parts[0]) || 0;
  var minute = Number(parts[1]) || 0;

  if (minute > 59) {
    hour += Math.floor(minute / 60);
    minute = minute % 60;
  }

  var formatted =
    this.twoDigit(hour) + ":" + this.twoDigit(minute);

  this.$set(this.transferForm.extraHours, index, formatted);
},

twoDigit(value) {
  value = Number(value) || 0;
  return value < 10 ? "0" + value : value.toString();
},
    getRealPnrListForGeneralVoucher() {
  if (!this.selectedReservation) return [];

  var list = [];
  var sections = [
    "flights",
    "hotels",
    "cruises",
    "cars",
    "transfers",
    "dailyTours",
    "others"
  ];

  sections.forEach(function(section) {
    var serviceList = this.selectedReservation[section] || [];

    serviceList.forEach(function(item) {
      var pnrNo = this.getRealPnrFromServiceItem(item);

      if (pnrNo && list.indexOf(pnrNo) === -1) {
        list.push(pnrNo);
      }
    }.bind(this));
  }.bind(this));

  if (
    list.length === 0 &&
    this.selectedReservation.childPnrList &&
    this.selectedReservation.childPnrList.length
  ) {
    this.selectedReservation.childPnrList.forEach(function(pnrNo) {
      pnrNo = pnrNo ? pnrNo.toString() : "";

      if (pnrNo && list.indexOf(pnrNo) === -1) {
        list.push(pnrNo);
      }
    });
  }

  return list;
},

    getDisplayPnrNoForUser() {
  if (!this.selectedReservation) return "";

  return (
    this.selectedReservation.displayPnr ||
    this.selectedReservation.takipNo ||
    this.selectedReservation.TakipNo ||
    this.selectedReservation.pnr ||
    ""
  );
},

getRealPnrFromServiceItem(item) {
  if (!item) return "";

  var pnrNo =
    item.pnrNo ||
    item.PNR_No ||
    item.pNR_No ||
    item.PnrNo ||
    item.pnrNo ||
    item.realPnr ||
    item.sourcePnr ||
    "";

  pnrNo = pnrNo ? pnrNo.toString().trim() : "";

  if (!pnrNo || pnrNo === "0" || pnrNo === "-") {
    return "";
  }

  return pnrNo;
},

getRealPnrForServiceVoucher(section) {
  if (!this.selectedReservation || !section) return "";

  var list = this.selectedReservation[section] || [];

  for (var i = 0; i < list.length; i++) {
    var pnrNo = this.getRealPnrFromServiceItem(list[i]);

    if (pnrNo) {
      return pnrNo;
    }
  }

  return "";
},

getRealPnrForGeneralVoucher() {
  if (!this.selectedReservation) return "";

  var sections = [
    "flights",
    "hotels",
    "cruises",
    "cars",
    "transfers",
    "dailyTours",
    "others"
  ];

  for (var i = 0; i < sections.length; i++) {
    var pnrNo = this.getRealPnrForServiceVoucher(sections[i]);

    if (pnrNo) {
      return pnrNo;
    }
  }

  if (
    this.selectedReservation.childPnrList &&
    this.selectedReservation.childPnrList.length
  ) {
    return this.selectedReservation.childPnrList[0].toString();
  }

  var sourcePnr =
    this.selectedReservation.sourcePnr ||
    this.selectedReservation.realPnr ||
    "";

  sourcePnr = sourcePnr ? sourcePnr.toString().trim() : "";

  if (sourcePnr && sourcePnr !== this.getDisplayPnrNoForUser().toString()) {
    return sourcePnr;
  }

  return "";
},
//deneme
openReservationDetailFromRoute() {
  var query = this.$route && this.$route.query ? this.$route.query : {};

  var takipNo =
    query.TakipNo ||
    query.takipNo ||
    query.PNR_No ||
    query.pnrNo ||
    query.pnr ||
    "";

  if (!takipNo) return;

  takipNo = takipNo.toString();

  this.search = takipNo;
  this.statusFilter = "All Statuses";
  this.detailMode = false;
  this.selectedReservationIndex = -1;

  var sourceItem = {
    pnr: takipNo,
    takipNo: takipNo,
    displayPnr: takipNo,
    sourcePnr: takipNo,

    status: "Open",
    payment: "Unpaid",
    total: 0,
    currency: getCredentialsCurrency(),
    isClosed: false,

    isInvoiced: false,
    invoiceNo: "",
    invoiceSeries: "",
    invoiceText: "",
    invoiceNoList: [],
    invoicedPnrList: []
  };

  this.simpleInvoiceGetInvoiceInfoByTakipNo(takipNo).then(
    function(invoiceInfo) {
      if (invoiceInfo) {
        sourceItem.isInvoiced = invoiceInfo.isInvoiced || false;
        sourceItem.invoiceNo = invoiceInfo.invoiceNo || "";
        sourceItem.invoiceSeries = invoiceInfo.invoiceSeries || "";
        sourceItem.invoiceText = invoiceInfo.invoiceText || "";
        sourceItem.invoiceNoList = invoiceInfo.invoiceNoList || [];
        sourceItem.invoicedPnrList = invoiceInfo.invoicedPnrList || [];
      }

      this.loadReservationDetail(takipNo, sourceItem);
    }.bind(this),
    function() {
      this.loadReservationDetail(takipNo, sourceItem);
    }.bind(this)
  );
},



    //
groupReservationListByTakipNo(list) {
  list = list || [];

  var groupedMap = {};
  var order = [];

  list.forEach(function(item) {
    if (!item) return;

    var takipNo =
      item.takipNo ||
      item.TakipNo ||
      item.Takip_No ||
      item.takip_No ||
      item.pnr ||
      "";

    takipNo = takipNo ? takipNo.toString().trim() : "";

    if (!takipNo || takipNo === "0" || takipNo === "-") {
      return;
    }

    var childPnr =
      item.sourcePnr ||
      item.pnr ||
      item.PNR_No ||
      item.pNR_No ||
      "";

    childPnr = childPnr ? childPnr.toString() : "";

    if (!groupedMap[takipNo]) {
      var groupItem = JSON.parse(JSON.stringify(item));

      // Kullanıcı tarafında PNR olarak TakipNo gösterilecek.
      groupItem.displayPnr = takipNo;
      groupItem.takipNo = takipNo;

      // UI genelinde PNR gibi görünen değer TakipNo olsun.
      groupItem.pnr = takipNo;

      // Gerçek child PNR'ları içeride saklıyoruz.
      groupItem.sourcePnr = childPnr;
      groupItem.childPnrList = [];
      if (childPnr) {
        groupItem.childPnrList.push(childPnr);
      }

      groupItem.isTakipGroup = true;

      // Artık tek servis değil MICE grup satırı.
      groupItem.serviceTypeNo = 0;
      groupItem.serviceTypeLabel = "MICE";

      groupItem.total = 0;
      groupItem.paidTotal = 0;
      groupItem.remainingBalance = 0;

      groupItem._allClosed = true;
      groupItem._paymentStatuses = [];
      groupItem._hasBackendPaymentInfo = false;

      groupItem.isInvoiced = false;
groupItem.invoiceText = "";
groupItem.invoiceNoList = [];
groupItem.invoicedPnrList = [];

      groupedMap[takipNo] = groupItem;
      order.push(takipNo);
    } else {
      if (
        childPnr &&
        groupedMap[takipNo].childPnrList.indexOf(childPnr) === -1
      ) {
        groupedMap[takipNo].childPnrList.push(childPnr);
      }

      if (!groupedMap[takipNo].sourcePnr && childPnr) {
        groupedMap[takipNo].sourcePnr = childPnr;
      }
    }

    var group = groupedMap[takipNo];

    group.total += Number(item.total) || 0;

    if (!group.customer && item.customer) {
      group.customer = item.customer;
    }

    if (!group.customerCode && item.customerCode) {
      group.customerCode = item.customerCode;
    }

    if (!group.currency && item.currency) {
      group.currency = item.currency;
    }

    // Tarih başlangıcı en erken, bitiş en geç olsun.
    if (item.travelFrom) {
      if (!group.travelFrom || item.travelFrom < group.travelFrom) {
        group.travelFrom = item.travelFrom;
      }
    }

    if (item.travelTo) {
      if (!group.travelTo || item.travelTo > group.travelTo) {
        group.travelTo = item.travelTo;
      }
    }

    group.travelDate = this.formatTravelDate(group.travelFrom, group.travelTo);

    // Tüm child PNR'lar kapalıysa grup kapalı gözüksün.
    if (!item.isClosed) {
      group._allClosed = false;
    }

    group.isClosed = group._allClosed;
    group.status = group._allClosed ? "Closed" : "Open";

    group.paidTotal += Number(item.paidTotal) || 0;
    group._paymentStatuses.push(item.payment || "Unpaid");

    if (item.hasBackendPaymentInfo === true) {
      group._hasBackendPaymentInfo = true;
    }

if (item.isInvoiced) {
  group.isInvoiced = true;

  if (item.invoiceText && group.invoiceNoList.indexOf(item.invoiceText) === -1) {
    group.invoiceNoList.push(item.invoiceText);
  }

  if (item.sourcePnr && group.invoicedPnrList.indexOf(item.sourcePnr) === -1) {
    group.invoicedPnrList.push(item.sourcePnr);
  }
}

  }.bind(this));

  return order.map(function(key) {
    var item = groupedMap[key];

    var tolerance = 0.01;

    item.total = this.roundMoney
      ? this.roundMoney(item.total)
      : Number(item.total || 0);

    item.paidTotal = this.roundMoney
      ? this.roundMoney(item.paidTotal)
      : Number(item.paidTotal || 0);

    item.remainingBalance = Math.max(0, item.total - item.paidTotal);

    if (item._hasBackendPaymentInfo || item.paidTotal > tolerance) {
      if (item.paidTotal <= tolerance) {
        item.payment = "Unpaid";
      } else if (item.remainingBalance <= tolerance) {
        item.payment = "Paid";
      } else {
        item.payment = "Partial";
      }
    } else {
      var paymentStatuses = item._paymentStatuses || [];
      var hasPaid = paymentStatuses.indexOf("Paid") > -1;
      var hasPartial = paymentStatuses.indexOf("Partial") > -1;
      var hasUnpaid = paymentStatuses.indexOf("Unpaid") > -1;

      if (hasPaid && !hasPartial && !hasUnpaid) {
        item.payment = "Paid";
      } else if (hasPaid || hasPartial) {
        item.payment = "Partial";
      } else {
        item.payment = "Unpaid";
      }
    }

    delete item._allClosed;
    delete item._paymentStatuses;
    delete item._hasBackendPaymentInfo;

if (item.invoiceNoList && item.invoiceNoList.length) {
  item.invoiceText = item.invoiceNoList.join(", ");
}

return item;

  }.bind(this));
},

    getLoadedMiceValue(obj, names, defaultValue) {
  if (!obj) return defaultValue || "";

  for (var i = 0; i < names.length; i++) {
    var key = names[i];

    if (
      obj[key] !== undefined &&
      obj[key] !== null &&
      obj[key] !== ""
    ) {
      return obj[key];
    }
  }

  return defaultValue || "";
},

getLoadedMiceDetail(kalem, detailName) {
  if (!kalem) return {};

  if (detailName === "hotel") {
    return kalem.kalemOtel || kalem.KalemOtel || kalem.baseKalem || kalem.BaseKalem || {};
  }

  if (detailName === "transfer") {
    return kalem.kalemArac || kalem.KalemArac || kalem.baseKalem || kalem.BaseKalem || {};
  }

  if (detailName === "cruise") {
    return kalem.kalemGemi || kalem.KalemGemi || kalem.baseKalem || kalem.BaseKalem || {};
  }

  if (detailName === "flight") {
    return kalem.kalemCharter || kalem.KalemCharter || kalem.baseKalem || kalem.BaseKalem || {};
  }

  return kalem.baseKalem || kalem.BaseKalem || {};
},

applyLoadedMiceDetailFields(serviceItem, kalem) {
  if (!serviceItem || !kalem) return serviceItem;

  var saticiTip = this.getMiceSaticiTipNo(kalem);

  // FLIGHT / CHARTER
  if (saticiTip === 8) {
    var charter = this.getLoadedMiceDetail(kalem, "flight");

    serviceItem.airlinePnr = this.getLoadedMiceValue(
      charter,
      [
        "CharterKod",
        "charterKod",
        "Kontenjan",
        "kontenjan"
      ],
      serviceItem.airlinePnr || ""
    );

    serviceItem.bookingType = this.getLoadedMiceValue(
      charter,
      [
        "BookingType",
        "bookingType"
      ],
      serviceItem.bookingType || ""
    );

    serviceItem.classType = this.getLoadedMiceValue(
      charter,
      [
        "ClassType",
        "classType"
      ],
      serviceItem.classType || ""
    );

    serviceItem.flightType = this.getLoadedMiceValue(
      charter,
      [
        "FlightType",
        "flightType"
      ],
      serviceItem.flightType || ""
    );
  }

  // HOTEL
  if (saticiTip === 1) {
    var hotel = this.getLoadedMiceDetail(kalem, "hotel");

    serviceItem.country = this.getLoadedMiceValue(
      hotel,
      [
        "Country",
        "country"
      ],
      serviceItem.country || ""
    );

    serviceItem.boardType = this.getLoadedMiceValue(
      hotel,
      [
        "BoardType",
        "boardType"
      ],
      serviceItem.boardType || ""
    );

    serviceItem.roomType =
      serviceItem.roomType ||
      this.getLoadedMiceValue(
        hotel,
        [
          "odaTipiIsim",
          "OdaTipiIsim",
          "OdaTipi",
          "odaTipi"
        ],
        ""
      );

    serviceItem.city =
      serviceItem.city ||
      this.getLoadedMiceValue(
        hotel,
        [
          "konum",
          "Konum"
        ],
        ""
      );
  }

  // TRANSFER
  if (saticiTip === 2) {
    var transfer = this.getLoadedMiceDetail(kalem, "transfer");

    serviceItem.plateNumber = this.getLoadedMiceValue(
      transfer,
      [
        "PlateNumber",
        "plateNumber",
        "plaka"
      ],
      serviceItem.plateNumber || ""
    );

    serviceItem.driverName = this.getLoadedMiceValue(
      transfer,
      [
        "DriverName",
        "driverName",
        "soforAdi"
      ],
      serviceItem.driverName || ""
    );

    serviceItem.driverPhone = this.getLoadedMiceValue(
      transfer,
      [
        "DriverGsm",
        "driverGsm",
        "soforGsm",
        "GSM",
        "gsm"
      ],
      serviceItem.driverPhone || ""
    );

    serviceItem.confirmationNo = this.getLoadedMiceValue(
      transfer,
      [
        "ConfirmationNo",
        "confirmationNo",
        "rezervasyonNo"
      ],
      serviceItem.confirmationNo || ""
    );

    serviceItem.from =
      serviceItem.from ||
      this.getLoadedMiceValue(
        transfer,
        [
          "nerden",
          "Nerden"
        ],
        ""
      );

    serviceItem.to =
      serviceItem.to ||
      this.getLoadedMiceValue(
        transfer,
        [
          "nereye",
          "Nereye"
        ],
        ""
      );

    serviceItem.vehicleType =
      serviceItem.vehicleType ||
      this.getLoadedMiceValue(
        transfer,
        [
          "arac",
          "Arac"
        ],
        ""
      );

    serviceItem.flightNumber = this.getLoadedMiceValue(
      transfer,
      [
        "UcusNo",
        "ucusNo"
      ],
      serviceItem.flightNumber || ""
    );

    var loadedFlightTime = this.getLoadedMiceValue(
      transfer,
      [
        "UcusSaat",
        "ucusSaat"
      ],
      ""
    );

    serviceItem.flightTime = loadedFlightTime
      ? this.backendDateTimeToTime(loadedFlightTime)
      : "";

    serviceItem.serviceType = this.getLoadedMiceValue(
      transfer,
      [
        "HizmetSekli",
        "hizmetSekli"
      ],
      serviceItem.serviceType || "Transfer"
    );

    var loadedExtraHourItems = [
      {
        hour: this.getLoadedMiceValue(
          transfer,
          ["EkSaat1", "ekSaat1"],
          ""
        ),
        amount: Number(
          this.getLoadedMiceValue(
            transfer,
            ["EkSaatTutar1", "ekSaatTutar1"],
            0
          )
        ) || 0
      },
      {
        hour: this.getLoadedMiceValue(
          transfer,
          ["EkSaat2", "ekSaat2"],
          ""
        ),
        amount: Number(
          this.getLoadedMiceValue(
            transfer,
            ["EkSaatTutar2", "ekSaatTutar2"],
            0
          )
        ) || 0
      },
      {
        hour: this.getLoadedMiceValue(
          transfer,
          ["EkSaat3", "ekSaat3"],
          ""
        ),
        amount: Number(
          this.getLoadedMiceValue(
            transfer,
            ["EkSaatTutar3", "ekSaatTutar3"],
            0
          )
        ) || 0
      }
    ].filter(function(item) {
      return item.hour && item.hour !== "00:00";
    }).slice(0, this.maxTransferExtraHourCount || 3);

    serviceItem.extraHours = loadedExtraHourItems.map(function(item) {
      return item.hour;
    });

    serviceItem.extraHourAmounts = loadedExtraHourItems.map(function(item) {
      return item.amount;
    });

    serviceItem.hasExtraHour = serviceItem.extraHours.length > 0;
  }

  // CRUISE / GEMI
  if (saticiTip === 9) {
    var cruise = this.getLoadedMiceDetail(kalem, "cruise");

    serviceItem.hotelName = this.getLoadedMiceValue(
      cruise,
      [
        "Gemi",
        "gemi"
      ],
      serviceItem.hotelName || ""
    );

    serviceItem.city = this.getLoadedMiceValue(
      cruise,
      [
        "Konum",
        "konum"
      ],
      serviceItem.city || ""
    );

    serviceItem.country = this.getLoadedMiceValue(
      cruise,
      [
        "Country",
        "country"
      ],
      serviceItem.country || ""
    );

    serviceItem.confirmationNo = this.getLoadedMiceValue(
      cruise,
      [
        "ConfirmationNo",
        "confirmationNo"
      ],
      serviceItem.confirmationNo || ""
    );

    serviceItem.cabinType = this.getLoadedMiceValue(
      cruise,
      [
        "CabinType",
        "cabinType"
      ],
      serviceItem.cabinType || ""
    );

    // UI bazı yerlerde roomType okuyorsa o da dolsun
    serviceItem.roomType =
      serviceItem.roomType ||
      serviceItem.cabinType;
  }

  return serviceItem;
},
    backendBoardTypeToSimple(value) {
  if (value === null || value === undefined || value === "") return "";

  var v = value.toString();

  var map = {
    "0": "Room Only",
    "1": "Bed & Breakfast",
    "2": "Half Board",
    "3": "Full Board",
    "4": "All Inclusive",
    "5": "Ultra All Inclusive"
  };

  return map[v] || value;
},

createReservationDraft() {
  if (!this.form.customerCode) {
    alert("Customer zorunludur.");
    return;
  }

  if (!this.form.travelFrom || !this.form.travelTo) {
    alert("Travel From and Travel To zorunludur.");
    return;
  }

  var travelFrom = this.normalizeDateValue(this.form.travelFrom);
  var travelTo = this.normalizeDateValue(this.form.travelTo);

  if (!travelFrom || !travelTo) {
    alert("Seyahat tarihleri zorunludur ve dd.mm.yyyy formatında olmalıdır.");
    return;
  }

  if (travelFrom > travelTo) {
    alert("Travel From tarihi Travel To tarihinden büyük olamaz.");
    return;
  }

  this.form.travelFrom = travelFrom;
  this.form.travelTo = travelTo;

  var draftItem = {
    guid: "",
    Guid: "",

    // Henüz backend kaydı yok. TakipNo/Pnr MiceSave sonrası oluşacak.
    pnr: "NEW",
    takipNo: "",

    sourcePnr: "",
    childPnrList: [],

    customer: this.form.customerName || this.form.customer || "",
    customerCode: this.form.customerCode || "",

    travelFrom: this.form.travelFrom,
    travelTo: this.form.travelTo,
    travelDate: this.formatTravelDate(this.form.travelFrom, this.form.travelTo),

    status: this.form.status || "Open",
    payment: this.form.payment || "Unpaid",

    total: Number(this.form.total) || 0,
    currency: getCredentialsCurrency(),

    isClosed: false,

    serviceTypeNo: 0,
    serviceTypeLabel: "MICE",

    flights: [],
    hotels: [],
    cars: [],
    transfers: [],
    dailyTours: [],
    cruises: [],
    others: [],
    passengers: [],

    miceHeader: {
      kayitTarihi: new Date(),
      rezVeren: "",
      masrafMerkezi: this.emptyTableSimple ? this.emptyTableSimple() : null,
      anaTip: 0,
      ulke: "",
      karsiRezKod: "",
      turKod: "",
      acenteDepartman: this.emptyTableSimple ? this.emptyTableSimple() : null,
      hizmetNo: "",
      referansKod: "",
      HedefKur: null,
      acente: this.emptySaticiTable ? this.emptySaticiTable() : null
    }
  };

  this.reservations.push(draftItem);
  this.selectedReservationIndex = this.reservations.length - 1;

  this.editingPnrCode = null;
  this.isEditMode = false;

  this.dialog = false;
  this.detailMode = true;

  if (this.openAllServiceSections) {
    this.openAllServiceSections();
  }
},
    hasValidTakipNo(item) {
  if (!item) return false;

  var takipNo =
    item.takipNo ||
    item.TakipNo ||
    item.Takip_No ||
    item.takip_No ||
    "";

  takipNo = takipNo.toString().trim();

  return takipNo !== "" && takipNo !== "0" && takipNo !== "-";
},

//Para değerini 2 ondalığa yuvarlar
   roundMoney(value) {
  var number = Number(value);

  if (!isFinite(number)) {
    return 0;
  }

  return Number(number.toFixed(2));
},

//Para değerini ekranda 2 haneli gösterir
formatPrice(value) {
  return this.roundMoney(value).toFixed(2);
},

//Tutarların küsürat bozulmasını engeller
normalizeServiceMoneyFields(serviceItem) {
  if (!serviceItem) {
    return serviceItem;
  }

  var moneyFields = [
    "netPrice",
    "vatAmount",
    "grossPrice",
    "supplierCost",
    "commissionAmount",
    "taxAmount",
    "airportTax",
    "fuelPriceDifference"
  ];

  moneyFields.forEach(function(field) {
    if (
      serviceItem[field] !== undefined &&
      serviceItem[field] !== null &&
      serviceItem[field] !== ""
    ) {
      serviceItem[field] = this.roundMoney(serviceItem[field]);
    }
  }.bind(this));

  return serviceItem;
},

//Net tutar ve kdv oranına göre kdv tutarını hesaplar
 calculateVatAmount(net, vatRate) {
  var netNumber = Number(net) || 0;
  var rateNumber = Number(vatRate) || 0;

  return this.roundMoney((netNumber * rateNumber) / 100);
},

//Net tutar + kdv tutarından gross tutarı hesaplar
calculateGrossAmount(net, vatRate) {
  var netNumber = Number(net) || 0;
  var vatAmount = this.calculateVatAmount(netNumber, vatRate);

  return this.roundMoney(netNumber + vatAmount);
},



//Tarih değerini yyyy-mm-dd formatına çevirir
  normalizeDateValue(value) {
  if (!value) return "";

  if (value instanceof Date) {
    return value.toISOString().substring(0, 10);
  }

  value = value.toString();

  if (value.indexOf("T") > -1) {
    value = value.substring(0, 10);
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }

  if (/^\d{2}\.\d{2}\.\d{4}$/.test(value)) {
    return this.dateTextToIso(value, false);
  }

  return "";
},

//Tarihi dd.mm.yyyy formatında gösterir
formatDateTR(value) {
  value = this.normalizeDateValue(value);
  if (!value) return "";

  var parts = value.split("-");
  if (parts.length !== 3) return value;

  return parts[2] + "." + parts[1] + "." + parts[0];
},

//İki tarihi liste ekranında dd.mm.yyyy - dd.mm.yyyy fotmarında döner
formatTravelDate(from, to) {
  var f = this.formatDateTR(from);
  var t = this.formatDateTR(to);

  if (!f && !t) return "-";
  if (f && !t) return f + " -";
  if (!f && t) return "- " + t;

  return f + " - " + t;
},


//Tek bir tarihi dd.mm.yyyy formatında gösterir
displayDate(value) {
      return value ? this.formatDateTR(value) : "";
    },

//Tarihi ingilizce formatında gösterir
    displayDateShort(value) {
      if (!value) return "-";

      var parts = value.split("-");
      if (parts.length !== 3) return value;

      var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];

      return parts[2] + " " + months[Number(parts[1]) - 1];
    },


    //Tarihi uzun ingilizce formatında gösterir
displayDateLong(value) {
  value = this.normalizeDateValue(value);
  if (!value || value === "0001-01-01") return "-";

  var parts = value.split("-");
  if (parts.length !== 3) return value;

  var months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  return parts[2] + " " + months[Number(parts[1]) - 1] + " " + parts[0];
},


//Input içindeki tarih değerini kullanıcıya dd.MM.yyyy formatında gösterir
dateInputValue(value) {
  if (!value) return "";

  if (value instanceof Date) {
    var year = value.getFullYear().toString();
    var month = ("0" + (value.getMonth() + 1)).slice(-2);
    var day = ("0" + value.getDate()).slice(-2);
    return day + "." + month + "." + year;
  }

  var text = value.toString();

  if (text.indexOf("T") > -1) {
    text = text.substring(0, 10);
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
    var parts = text.split("-");
    return parts[2] + "." + parts[1] + "." + parts[0];
  }

  return this.formatDateInputText(text);
},

//Kullanıcının yazdığı tarih inputunu dd.mm.yyyy maskesine çevirir
formatDateInputText(value) {
  var digits = (value || "")
    .toString()
    .replace(/\D/g, "")
    .substring(0, 8);

  var formatted = digits;

  if (digits.length > 4) {
    formatted =
      digits.substring(0, 2) +
      "." +
      digits.substring(2, 4) +
      "." +
      digits.substring(4, 8);
  } else if (digits.length > 2) {
    formatted =
      digits.substring(0, 2) +
      "." +
      digits.substring(2, 4);
  }

  return formatted;
},


//dd.MM.yyyy tarih metnini yyyy-MM-dd formatına çevirir
dateTextToIso(value, showAlert) {
  var formatted = this.formatDateInputText(value);
  var match = formatted.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);

  if (!match) {
    return "";
  }

  var day = match[1];
  var month = match[2];
  var year = match[3];

  if (!this.isValidDateParts(day, month, year)) {
    if (showAlert) {
      alert("Geçerli bir tarih giriniz.");
    }

    return "";
  }

  return year + "-" + month + "-" + day;
},


//Gün, ay, yıl parçalarının gerçek ve geçerli bir tarih olup olmadığını kontrol eder
isValidDateParts(day, month, year) {
  day = Number(day);
  month = Number(month);
  year = Number(year);

  if (!day || !month || !year) return false;
  if (year < 1900 || year > 2100) return false;

  var date = new Date(year, month - 1, day);

  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
},


//Tarih inputuna yazı yazıldıkça değeri maskeler ve uygunsa ISO tarihe çevirir
onDateInput(formName, field, value) {
  var formatted = this.formatDateInputText(value);
  var digits = formatted.replace(/\D/g, "");

  if (digits.length === 8) {
    var isoDate = this.dateTextToIso(formatted, false);
    this.$set(this[formName], field, isoDate || formatted);
    return;
  }

  this.$set(this[formName], field, formatted);
},


//Tarih inputundan çıkınca format ve geçerlilik kontrolü yapar
onDateBlur(formName, field) {
  var value = this[formName] ? this[formName][field] : "";

  if (!value) {
    this.$set(this[formName], field, "");
    return;
  }

  var text = this.dateInputValue(value);

  if (text.length !== 10) {
    alert("Tarih dd.mm.yyyy formatında olmalıdır.");
    this.$set(this[formName], field, "");
    return;
  }

  var isoDate = this.dateTextToIso(text, true);

  if (!isoDate) {
    this.$set(this[formName], field, "");
    return;
  }

  this.$set(this[formName], field, isoDate);
},


// Ayrı gelen tarih ve saat bilgisini backend için datetime string haline getirir
combineDateAndTime(date, time) {
  if (!date || !time || time === "--:--") return null;

  if (time.toString().indexOf("T") !== -1) {
    return time;
  }

  var parts = time.split(":");
  var hh = parts[0] || "00";
  var mm = parts[1] || "00";

  return date + "T" + hh + ":" + mm + ":00";
},


//Backend’den gelen datetime değerinden sadece HH:mm saat bilgisini alır
backendDateTimeToTime(value) {
  if (!value) return "";

  var text = value.toString();

  if (text.indexOf("0001-01-01") !== -1) return "";

  if (text.indexOf("T") !== -1) {
    return text.split("T")[1].substring(0, 5);
  }

  return "";
},


//UI’daki HH:mm saat bilgisini backend’in beklediği tarihli saat formatına çevirir
simpleTimeToBackend(value) {
  if (!value) return "0001-01-01T00:00:00";

  var v = value.toString();

  if (v.indexOf("T") > -1) return v;

  if (/^\d{2}:\d{2}$/.test(v)) {
    return "1899-12-30T" + v + ":00";
  }

  return v;
},


//Backend’den gelen saat/datetime bilgisini UI için HH:mm formatına çevirir
backendTimeToSimple(value) {
  if (!value) return "";

  var v = value.toString();

  if (v.indexOf("0001-01-01") > -1) return "";
  if (v.indexOf("1899-12-30T") > -1) return v.substring(11, 16);
  if (v.indexOf("T") > -1) return v.substring(11, 16);

  return v;
},


//Servis formlarındaki saat inputunu HH:mm formatında maskeler
onServiceTimeInput(formName, field, value) {
  var digits = (value || "").toString().replace(/\D/g, "").substring(0, 4);

  var formatted = digits;

  if (digits.length > 2) {
    formatted = digits.substring(0, 2) + ":" + digits.substring(2, 4);
  }

  this.$set(this[formName], field, formatted);
},


//Flight formundaki departure/arrival saat inputlarını HH:mm formatında maskeler
    onFlightTimeInput(field, value) {
  var digits = (value || "").toString().replace(/\D/g, "").substring(0, 4);

  var formatted = digits;

  if (digits.length > 2) {
    formatted = digits.substring(0, 2) + ":" + digits.substring(2, 4);
  }

  this.$set(this.flightForm, field, formatted);
},

//Flight formundaki opsiyon saatini HH:mm formatında maskeler
onFlightOptionTimeInput(value) {
  this.onFlightTimeInput("opsiyonSaati", value);
},



//Reservation status değerine göre chip class döner
getStatusClass(status) {
      if (status === "Open") return "chip-open";
      if (status === "Closed") return "chip-closed";
      return "";
    },


//Payment değerine göre chip class döner 
    getPaymentClass(payment) {
      if (payment === "Unpaid") return "chip-unpaid";
      if (payment === "Partial") return "chip-partial";
      if (payment === "Paid") return "chip-paid";
      return "";
    },


//Liste satırındaki raw API datasından servis tipini bulur
 getServiceTypeNoFromListItem(item) {
  item = item || {};

  var tip =
    item.SaticiTip ||
    item.saticiTip ||
    item.SaticiTipi ||
    item.saticiTipi ||
    (item.Details ? (item.Details.SaticiTip || item.Details.saticiTip) : null) ||
    (item.baseKalem ? (item.baseKalem.SaticiTip || item.baseKalem.saticiTip) : null) ||
    0;

  tip = Number(tip) || 0;

  if (!tip) {
    var text = (
      (item.SaticiAd || item.saticiAd || "") + " " +
      (item.Aciklama || item.aciklama || "")
    ).toLowerCase();

    if (
      text.indexOf("thy") > -1 ||
      text.indexOf("pegasus") > -1 ||
      text.indexOf("flight") > -1 ||
      text.indexOf("uç") > -1 ||
      text.indexOf("uc") > -1
    ) {
      return 8;
    }

    if (
      text.indexOf("otel") > -1 ||
      text.indexOf("hotel") > -1
    ) {
      return 1;
    }

    if (
      text.indexOf("rent") > -1 ||
      text.indexOf("car") > -1 ||
      text.indexOf("araç") > -1 ||
      text.indexOf("arac") > -1
    ) {
      return 5;
    }

    if (
      text.indexOf("transfer") > -1
    ) {
      return 2;
    }

    if (
      text.indexOf("tour") > -1 ||
      text.indexOf("tur") > -1
    ) {
      return 4;
    }

    if (
      text.indexOf("cruise") > -1 ||
      text.indexOf("gemi") > -1
    ) {
      return 9;
    }
  }

  return tip;
},


//Servis tip numarasını okunabilir etikete çevirir
getServiceTypeLabel(serviceTypeNo) {
  serviceTypeNo = Number(serviceTypeNo) || 0;

  if (serviceTypeNo === 8) return "Flight";
  if (serviceTypeNo === 1) return "Hotel";
  if (serviceTypeNo === 5) return "Car";
  if (serviceTypeNo === 2) return "Transfer";
  if (serviceTypeNo === 4) return "Daily Tour";
  if (serviceTypeNo === 9) return "Cruise";

  return "Other";
},


//Servis tipine göre Vuetify icon adını döner
getServiceIcon(serviceTypeNo) {
  serviceTypeNo = Number(serviceTypeNo) || 0;

  if (serviceTypeNo === 8) return "flight";
  if (serviceTypeNo === 1) return "hotel";
  if (serviceTypeNo === 5) return "directions_car";
  if (serviceTypeNo === 2) return "airport_shuttle";
  if (serviceTypeNo === 4) return "map";
  if (serviceTypeNo === 9) return "directions_boat";

  return "work_outline";
},


// Servis tipine göre icon badge CSS class’ını döner
getServiceIconClass(serviceTypeNo) {
  serviceTypeNo = Number(serviceTypeNo) || 0;

  if (serviceTypeNo === 1) return "service-type-icon--hotel";
  if (serviceTypeNo === 2) return "service-type-icon--transfer";
  if (serviceTypeNo === 4) return "service-type-icon--tour";
  if (serviceTypeNo === 5) return "service-type-icon--car";
  if (serviceTypeNo === 8) return "service-type-icon--flight";
  if (serviceTypeNo === 9) return "service-type-icon--cruise";
  if (serviceTypeNo === 10) return "service-type-icon--other";

  return "service-type-icon--other";
},   

//Hotel room type kodunu ekranda gösterilecek oda tipi adına çevirir
getHotelRoomTypeName(code) {
  if (!code) return "";

  var list = this.hotelRoomTypeList || [];

  for (var i = 0; i < list.length; i++) {
    if (list[i].value === code || list[i].text === code) {
      return list[i].text;
    }
  }

  return code;
},




//Yeni/boş reservation form objesini oluşturur
getEmptyReservationForm() {
      return {
        pnr: "",
        customerCode: "",
        customerName: "",
        customer: "",
        travelFrom: "",
        travelTo: "",
        status: "Open",
        payment: "Unpaid",
        total: 0,
        currency: getCredentialsCurrency(),
        flights: [],
        hotels: [],
        cars: [],
        transfers: [],
        dailyTours: [],
        cruises: [],
        others: [],
        passengers: []
      };
    },


    //Yeni/boş passenger form objesini oluşturur
    getEmptyPassengerForm() {
      return {
        kisiTipi: "Yetişkin",
        birthDate: "",
        idNumber: "",
        gender: "",
        firstName: "",
        lastName: "",
        phone: "",
        nationality: "",
        email: "",
        passportNumber: "",
        address: ""
      };
    },


    //Yeni/boş flight form objesini oluşturur
    getEmptyFlightForm() {
      return {
        airline: "",
        satici: null,
        flightNumber: "",
        airlinePnr: "",
        classType: "Economy",
        flightType: "International",
        from: "",
        to: "",
        departureDate: "",
        departureTime: "",
        arrivalDate: "",
        arrivalTime: "",
        ticketNumber: "",
        netPrice: 0,
        vatRate: 0,
        commissionAmount: 0,
        supplierCost: 0,
        fuelPriceDifference: 0,
        airportTax: 0,
        taxAmount: 0,
        tourOperator: "",
        bookingType: "Reservation",
        opsiyonluMusteri: false,
        opsiyonTarihi: "",
        opsiyonSaati: "",
        notes: ""
      };
    },


    //Yeni/boş hotel form objesini oluşturur
    getEmptyHotelForm() {
      return {
        hotelName: "",
        satici: null,
        city: "",
        country: "",
        checkIn: "",
        checkOut: "",
        rooms: 1,
        guests: 1,
        roomType: "SGL",
        boardType: "Bed & Breakfast",
        confirmationNo: "",
        netPrice: 0,
        vatRate: 0,
        commissionAmount: 0,
        supplierCost: 0,
        tourOperator: "",
        notes: ""
      };
    },

    //Yeni/boş car form objesini oluşturur
    getEmptyCarForm() {
      return {
        company: "",
        satici: null,
        carType: "",
        category: "Economy",
        pickupLocation: "",
        dropoffLocation: "",
        pickupDate: "",
        pickupTime: "",
        dropoffDate: "",
        dropoffTime: "",
        confirmationNo: "",
        netPrice: 0,
        vatRate: 0,
        commissionAmount: 0,
        supplierCost: 0,
        tourOperator: "",
        notes: ""
      };
    },


    //Yeni/boş transfer form objesini oluşturur
    getEmptyTransferForm() {
      return {
        company: "",
        satici: null,
        tourOperator: "",
        type: "Private",
        serviceType: "Transfer",
        hasExtraHour: false,
        extraHours: [],
        extraHourAmounts: [],
        vehicleType: "",
        plateNumber: "",
        driverName: "",
        driverPhone: "",
        from: "",
        to: "",
        date: "",
        time: "",
        flightNumber: "",
        flightTime: "",
        passengerCount: 1,
        confirmationNo: "",
        netPrice: 0,
        vatRate: 0,
        commissionAmount: 0,
        supplierCost: 0,
        notes: ""
      };
    },


    // Yeni/boş dailytour form objesini oluşturur
    getEmptyDailyTourForm() {
      return {
        supplier: "",
        satici: null,
        tourCode: "",
        tourName: "",
        date: "",
        time: "",
        meetingPoint: "",
        program: "",
        netPrice: 0,
        vatRate: 0,
        commissionAmount: 0,
        supplierCost: 0,
        tourOperator: "",
        notes: ""
      };
    },

    //Yeni/boş cruise form objesini oluşturur
    getEmptyCruiseForm() {
      return {
        supplier: "",
        satici: null,
        tourOperator: "",
        hotelName: "",
        city: "",
        country: "",
        checkIn: "",
        checkOut: "",
        rooms: 1,
        guests: 1,
        roomType: "",
        boardType: "Bed & Breakfast",
        confirmationNo: "",
        netPrice: 0,
        vatRate: 0,
        commissionAmount: 0,
        supplierCost: 0,
        notes: ""
      };
    },


    //Yeni/boş other form objesini oluşturur
    getEmptyOtherForm() {
      return {
        supplier: "",
        satici: null,
        tourOperator: "",
        startDate: "",
        endDate: "",
        description: "",
        netPrice: 0,
        vatRate: 0,
        commissionAmount: 0,
        supplierCost: 0,
        title: "",
        notes: ""
      };
    },




    //Pnr listesini çeker
getReservationList() {
  this.loadingvmodel = true;

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));
  var credentialsCurrency = getCredentialsCurrency();

  this.Rapor.Filtreler.KayitTarihiBasla = this.startDateFilter;
  this.Rapor.Filtreler.KayitTarihiBitis = this.endDateFilter;
  this.Rapor.Filtreler.SearchText = this.search || null;
  this.Rapor.Filtreler.ParaBirimi = credentialsCurrency;
  this.Rapor.Filtreler.Prm.PPNR_ParaBirimi = credentialsCurrency;

  this.Rapor.Filtreler.Prm.PCariSirket = credentials.SirketKodu;
  this.Rapor.Filtreler.Prm.PSirketNo = credentials.CoperSirketNo;

  tool.http_post(this, "GunlukSatisListPaging", this.Rapor).then(
    response => {
      this.loadingvmodel = false;

     if (response.body.Status === true) {
  var mappedList = (response.body.data || [])
    .map(function(item) {
      return this.mapListItemToSimpleReservation(item);
    }.bind(this))
    .filter(function(item) {
      return this.hasValidTakipNo(item);
    }.bind(this));

  this.reservations = this.groupReservationListByTakipNo(mappedList);
} else {
        this.text1 = response.body.ErrorList && response.body.ErrorList.length
          ? response.body.ErrorList[0]
          : "Rezervasyon listesi getirilemedi.";
        this.snackbar = true;
      }
    },
    response => {
      this.loadingvmodel = false;
      this.text1 = "Rezervasyon listesi getirilemedi.";
      this.snackbar = true;
    }
  );
},


//GunlukSatisListPaging satırını Simple Mode liste objesine çevirir
mapListItemToSimpleReservation(item) {
  item = item || {};

  var pnrNo =
    item.PNR_No ||
    item.pNR_No ||
    item.PnrNo ||
    item.PNRNO ||
    item.Pnr ||
    item.pnr ||
    item.PNR ||
    "";

  var takipNo =
    item.TakipNo ||
    item.takipNo ||
    item.Takip_No ||
    item.takip_No ||
    item.SatisGrubu ||
    item.satisGrubu ||
    item.SatisGrup ||
    item.satisGrup ||
    item.GrupNo ||
    item.grupNo ||
    "";

  var pnrKey = pnrNo ? pnrNo.toString() : "";
  var takipKey = takipNo ? takipNo.toString() : "";

  var travelFrom = this.normalizeDateValue(
    item.IlkGiris || item.ilkGiris || item.Donem1 || item.donem1 || item.KayitTarihi || item.kayitTarihi
  );

  var travelTo = this.normalizeDateValue(
    item.SonCikis || item.sonCikis || item.Donem2 || item.donem2 || item.IlkGiris || item.ilkGiris || item.Donem1 || item.donem1
  );

  var deletedValue =
    item.Deleted !== undefined ? item.Deleted :
    item.deleted !== undefined ? item.deleted :
    item.IsDeleted !== undefined ? item.IsDeleted :
    item.isDeleted !== undefined ? item.isDeleted :
    false;

  var isBackendClosed =
    deletedValue === true ||
    deletedValue === 1 ||
    deletedValue === "1" ||
    deletedValue === "true" ||
    deletedValue === "True" ||
    deletedValue === "TRUE";

  var isLocallyClosed =
    this.closedPnrMap &&
    pnrKey &&
    this.closedPnrMap[pnrKey] === true;

  var isClosed = isBackendClosed || isLocallyClosed;

  var invoiceNo =
  item.FaturaNo ||
  item.faturaNo ||
  item.SatisFaturaNo ||
  item.satisFaturaNo ||
  item.SatisFatNo ||
  item.satisFatNo ||
  "";

var invoiceSeries =
  item.FaturaSeri ||
  item.faturaSeri ||
  item.SeriNo ||
  item.seriNo ||
  item.SatisFatSeri ||
  item.satisFatSeri ||
  "";

var invoiceText = "";

if (invoiceSeries || invoiceNo) {
  invoiceText = ((invoiceSeries || "") + "-" + (invoiceNo || "")).trim();

  if (invoiceText === "-") {
    invoiceText = "";
  }

  invoiceText = invoiceText.replace(/^-/, "").replace(/-$/, "");
}

var isInvoiced =
  invoiceNo !== null &&
  invoiceNo !== undefined &&
  invoiceNo !== "" &&
  invoiceNo !== 0 &&
  invoiceNo !== "0";

  var serviceTypeNo = this.getServiceTypeNoFromListItem(item);
  var paymentInfo = this.getListPaymentInfo(item, takipKey, pnrKey);

  return {
    pnr: pnrKey,

    takipNo: takipKey,

    sourcePnr: pnrKey,
    childPnrList: pnrKey ? [pnrKey] : [],

    isInvoiced: isInvoiced,
invoiceNo: invoiceNo,
invoiceSeries: invoiceSeries,
invoiceText: invoiceText,
invoicedPnrList: isInvoiced && pnrKey ? [pnrKey] : [],

    customer: item.Unvan || item.unvan || item.Isim || item.isim || item.MusteriAdi || item.musteriAdi || "",
    customerCode: item.CariKod || item.cariKod || item.MusteriKodu || item.musteriKodu || "",

    travelFrom: travelFrom,
    travelTo: travelTo,
    travelDate: this.formatTravelDate(travelFrom, travelTo),

    status: isClosed ? "Closed" : "Open",
    payment: paymentInfo.status,
    total: paymentInfo.total,
    paidTotal: paymentInfo.paidTotal,
    remainingBalance: paymentInfo.remainingBalance,
    hasBackendPaymentInfo: paymentInfo.hasBackendPaymentInfo,
    currency: getCredentialsCurrency(),
    isClosed: isClosed,

    serviceTypeNo: serviceTypeNo,
    serviceTypeLabel: this.getServiceTypeLabel(serviceTypeNo),

    flights: [],
    hotels: [],
    cars: [],
    transfers: [],
    dailyTours: [],
    cruises: [],
    others: [],
    passengers: []
  };
},

//Tarih filtrelerini uygular ve listeyi tekrar çeker
    applyDateFilter() {
  if (
    this.startDateFilter &&
    this.endDateFilter &&
    this.startDateFilter > this.endDateFilter
  ) {
    alert("Başlangıç tarihi bitiş tarihinden büyük olamaz.");
    return;
  }

  this.getReservationList();
},

//Yeni rezervasyon ekleme dialogunu açar
    addPnr() {
  this.isEditMode = false;
  this.editingPnrCode = null;

  this.resetForm();

  this.dialog = true;
},

//Yeni rezervasyon ekleme/düzenleme dialogunu kapatır
    closeDialog() {
  this.dialog = false;
  this.isEditMode = false;
  this.editingPnrCode = null;

  this.resetForm();
},


    //Liste satırından detaya güvenli giriş yapar
    openReservationDetailSafe(item) {
  if (item && item.isClosed) {
    alert("Bu kayıt kapatılmıştır. İçine girilemez.");
    return;
  }

  if (!item) {
    alert("Rezervasyon bulunamadı.");
    return;
  }

  var takipNo =
    item.takipNo ||
    item.TakipNo ||
    item.pnr ||
    item.sourcePnr ||
    "";

  if (!takipNo || takipNo == "0") {
    this.openReservationDetail(item);
    return;
  }

  this.loadReservationDetail(takipNo, item);
},


//TakipNo ile MiceLoad çağırır ve detay ekranını doldurur
loadReservationDetail(takipNo, sourceItem) {
  this.loadingvmodel = true;

  var activeCurrency = getCredentialsCurrency();

  if (!activeCurrency) {
    this.loadingvmodel = false;
    this.text1 = "Kullanıcı para birimi bulunamadı.";
    this.snackbar = true;
    return;
  }

  var params = {
    TakipNo: Number(takipNo) || takipNo,
    hedefParaBirimi: activeCurrency
  };

  tool.http_post(this, "MiceLoad", params).then(
    response => {
      this.loadingvmodel = false;

      if (response.body.Status === true) {
        var loadedItem = this.mapLoadedMiceToSimple(response.body.data, sourceItem);

        var index = this.findReservationIndex(loadedItem.pnr);

        if (index > -1) {
          this.$set(this.reservations, index, loadedItem);
          this.selectedReservationIndex = index;
        } else {
          this.reservations.push(loadedItem);
          this.selectedReservationIndex = this.reservations.length - 1;
        }

        this.detailMode = true;
        this.openAllServiceSections();
        this.getSimplePayments();
      } else {
        this.text1 = response.body.ErrorList && response.body.ErrorList.length
          ? response.body.ErrorList[0]
          : "MICE rezervasyon getirilemedi.";
        this.snackbar = true;
      }
    },
    response => {
      this.loadingvmodel = false;
      this.text1 = "MICE rezervasyon getirilemedi.";
      this.snackbar = true;
    }
  );
},


//Mevcut reservations içindeki satırı detay modunda açar
openReservationDetail(item) {
  this.selectedReservationIndex = this.findReservationIndex(item.pnr);
  this.detailMode = true;

  this.openAllServiceSections();
  this.getSimplePayments();
},


//Detay ekranından listeye döner ve listeyi backend’den yeniden çeker
    closeReservationDetail() {
  this.detailMode = false;
  this.selectedReservationIndex = -1;
  if (this.kalemData && this.kalemData.Rez) {
    this.$set(this.kalemData.Rez, "odemeler", []);
  }
  this.getReservationList();
},


//Verilen PNR/TakipNo değerine göre reservations içinde index bulur
findReservationIndex(pnr) {
      return this.reservations.findIndex(function(item) {
        return item.pnr === pnr;
      });
    },


 //Pnr kapatır
    closePnrFromList(item) {
  if (!item || !item.pnr) {
    alert("PNR bulunamadı.");
    return;
  }

  if (this.loadingvmodel) {
    return;
  }

  var pnrNo = item.pnr.toString();

  if (item.isClosed === true || item.status === "Closed") {
    alert(pnrNo + " PNR zaten kapalı.");
    return;
  }

  var onay = confirm(pnrNo + " PNR kapatılacak. Onaylıyor musunuz?");

  if (!onay) return;

  this.loadingvmodel = true;

  var params = {
    IptalTipi: 1,
    IptalNo: pnrNo,
    IptalNedeni: "Simple Mode PNR Kapatma"
  };

  tool.http_post(this, "RezervasyonIptal", params).then(
    response => {
      this.loadingvmodel = false;

      var body = response && response.body ? response.body : {};

      if (body.Status === true) {
        if (!this.closedPnrMap) {
          this.$set(this, "closedPnrMap", {});
        }

        this.$set(this.closedPnrMap, pnrNo, true);

        this.$set(item, "status", "Closed");
        this.$set(item, "isClosed", true);

        if (this.reservations && this.reservations.length) {
          this.reservations.forEach(r => {
            if (r && r.pnr && r.pnr.toString() === pnrNo) {
              this.$set(r, "status", "Closed");
              this.$set(r, "isClosed", true);
            }
          });
        }

        if (
          this.selectedReservation &&
          this.selectedReservation.pnr &&
          this.selectedReservation.pnr.toString() === pnrNo
        ) {
          this.$set(this.selectedReservation, "status", "Closed");
          this.$set(this.selectedReservation, "isClosed", true);
        }

        this.statusFilter = "All Statuses";

        this.text1 = "PNR kapatıldı.";
        this.snackbar = true;
      } else {
        alert(
          body.ErrorList && body.ErrorList.length
            ? body.ErrorList[0]
            : "PNR kapatılamadı."
        );
      }
    },
    response => {
      this.loadingvmodel = false;
      alert("Service Unavailable - Rezervasyon/Iptal");
    }
  );
},




//MiceLoad response’unu Simple Mode detay objesine çevirir
mapLoadedMiceToSimple(rezData, sourceItem) {
  rezData = rezData || {};
  sourceItem = sourceItem || {};

  var passengers = (rezData.adresler || rezData.Adresler || []).map(function(adres) {
    return this.mapAdresToPassenger(adres);
  }.bind(this));

  var kalemler = rezData.kalemler || rezData.Kalemler || [];

  var takipNo =
    rezData.takipNo ||
    rezData.TakipNo ||
    rezData.Takip_No ||
    rezData.takip_No ||
    rezData.satisGrubu ||
    rezData.SatisGrubu ||
    sourceItem.takipNo ||
    sourceItem.pnr ||
    "";

  var takipKey = takipNo ? takipNo.toString() : "";

  var firstKalem = kalemler && kalemler.length ? kalemler[0] : null;

  var firstCari =
    rezData.cariKod ||
    rezData.CariKod ||
    (firstKalem ? (firstKalem.cariKod || firstKalem.CariKod) : null) ||
    null;

  var travelDates = this.getTravelDatesFromMice(rezData, kalemler);

  var toplamTL = rezData.toplamTL || rezData.ToplamTL || null;

  var total = toplamTL
    ? Number(
        toplamTL.netSatis ||
        toplamTL.NetSatis ||
        toplamTL.satis ||
        toplamTL.Satis ||
        0
      )
    : Number(sourceItem.total || 0);

  var simpleItem = {
    pnr: takipKey || sourceItem.pnr || sourceItem.sourcePnr || "",
displayPnr: takipKey || sourceItem.displayPnr || sourceItem.pnr || "",

   takipNo: takipKey,

    sourcePnr: "",
    childPnrList: [],

    miceHeader: {
      kayitTarihi: rezData.kayitTarihi || rezData.KayitTarihi || new Date(),
      rezVeren: rezData.rezVeren || rezData.RezVeren || "",
      masrafMerkezi: rezData.masrafMerkezi || rezData.MasrafMerkezi || null,
      anaTip: rezData.anaTip || rezData.AnaTip || 0,
      ulke: rezData.ulke || rezData.Ulke || "",
      karsiRezKod: rezData.karsiRezKod || rezData.KarsiRezKod || "",
      turKod: rezData.turKod || rezData.TurKod || "",
      acenteDepartman: rezData.acenteDepartman || rezData.AcenteDepartman || null,
      hizmetNo: rezData.hizmetNo || rezData.HizmetNo || "",
      referansKod: rezData.referansKod || rezData.ReferansKod || "",
      HedefKur: rezData.HedefKur || rezData.hedefKur || null,
      acente: rezData.acente || rezData.Acente || null
    },

    customer: firstCari
      ? (
          firstCari.isim ||
          firstCari.Isim ||
          firstCari.unvan ||
          firstCari.Unvan ||
          firstCari.Unvan1 ||
          firstCari.Unvani1 ||
          ""
        )
      : (sourceItem.customer || ""),

    customerCode: firstCari
      ? (firstCari.kod || firstCari.Kod || "")
      : (sourceItem.customerCode || ""),

    travelFrom: travelDates.from,
    travelTo: travelDates.to,
    travelDate: this.formatTravelDate(travelDates.from, travelDates.to),

    status: sourceItem.status || "Open",
payment: sourceItem.payment || "Unpaid",

isInvoiced: sourceItem.isInvoiced || false,
invoiceNo: sourceItem.invoiceNo || "",
invoiceSeries: sourceItem.invoiceSeries || "",
invoiceText: sourceItem.invoiceText || "",
invoiceNoList: sourceItem.invoiceNoList || [],
invoicedPnrList: sourceItem.invoicedPnrList || [],

total: total,

    currency: getCredentialsCurrency(),

    isClosed: sourceItem.isClosed || false,

    flights: [],
    hotels: [],
    cars: [],
    transfers: [],
    dailyTours: [],
    cruises: [],
    others: [],
    passengers: passengers
  };

  kalemler.forEach(function(kalem) {
    var serviceItem = this.mapLoadedKalemToService(kalem, passengers);

    if (!serviceItem) {
      return;
    }

    this.applyMiceIdentityToServiceItem(serviceItem, kalem, simpleItem);
    this.applyLoadedMiceDetailFields(serviceItem, kalem);
    this.normalizeServiceMoneyFields(serviceItem);

    var saticiTip = this.getMiceSaticiTipNo(kalem);

    if (saticiTip === 8) {
      simpleItem.flights.push(serviceItem);
    } else if (saticiTip === 1) {
      simpleItem.hotels.push(serviceItem);
    } else if (saticiTip === 5) {
      simpleItem.cars.push(serviceItem);
    } else if (saticiTip === 2) {
      simpleItem.transfers.push(serviceItem);
    } else if (saticiTip === 4) {
      simpleItem.dailyTours.push(serviceItem);
    } else if (saticiTip === 9) {
      simpleItem.cruises.push(serviceItem);
    } else {
      simpleItem.others.push(serviceItem);
    }
  }.bind(this));

  return simpleItem;
},


//Load edilen kalemdeki PNR_No, Guid, islemRef gibi MICE kimliklerini servis item’a taşır
applyMiceIdentityToServiceItem(serviceItem, kalem, simpleItem) {
  var pnrNo =
    kalem.PNR_No ||
    kalem.pNR_No ||
    kalem.PnrNo ||
    kalem.pnrNo ||
    kalem.PNR ||
    kalem.pnr ||
    "";

  var pnrKey = pnrNo ? pnrNo.toString() : "";

  serviceItem.pnrNo = pnrKey;
  serviceItem.PNR_No = pnrNo || 0;

  serviceItem.guid = kalem.Guid || kalem.guid || "";
  serviceItem.Guid = kalem.Guid || kalem.guid || "";

  serviceItem.islemRef =
    Number(kalem.islemRef || kalem.IslemRef || kalem.islemREF || 0) || 0;

  serviceItem.cariKod = kalem.cariKod || kalem.CariKod || null;

  if (pnrKey) {
    if (!simpleItem.sourcePnr) {
      simpleItem.sourcePnr = pnrKey;
    }

    if (simpleItem.childPnrList.indexOf(pnrKey) === -1) {
      simpleItem.childPnrList.push(pnrKey);
    }
  }

  return serviceItem;
},


//MICE kalemindeki saticiTip değerini numeric tipe çevirir
getMiceSaticiTipNo(kalem) {
  if (!kalem) return 0;

  var value =
    kalem.saticiTip !== undefined ? kalem.saticiTip :
    kalem.SaticiTip !== undefined ? kalem.SaticiTip :
    kalem.satici && kalem.satici.tip !== undefined ? kalem.satici.tip :
    kalem.Satici && kalem.Satici.Tip !== undefined ? kalem.Satici.Tip :
    0;

  if (typeof value === "number") {
    return value;
  }

  var text = value ? value.toString().toLowerCase() : "";

  var parsed = parseInt(text, 10);
  if (!isNaN(parsed)) {
    return parsed;
  }

  if (text.indexOf("otel") > -1 || text.indexOf("hotel") > -1) return 1;
  if (text.indexOf("arac") > -1 || text.indexOf("transfer") > -1) return 2;
  if (text.indexOf("acente") > -1 || text.indexOf("daily") > -1 || text.indexOf("tour") > -1) return 4;
  if (text.indexOf("rent") > -1 || text.indexOf("car") > -1) return 5;
  if (text.indexOf("charter") > -1 || text.indexOf("flight") > -1 || text.indexOf("uçak") > -1 || text.indexOf("ucak") > -1) return 8;
  if (text.indexOf("gemi") > -1 || text.indexOf("cruise") > -1) return 9;
  if (text.indexOf("diger") > -1 || text.indexOf("diğer") > -1 || text.indexOf("other") > -1) return 10;

  return 0;
},

//MICE header ve kalemlerinden travelFrom/travelTo tarih aralığını hesaplar
getTravelDatesFromMice(rezData, kalemler) {
  var from =
    this.normalizeDateValue(
      rezData.travelFrom ||
      rezData.TravelFrom ||
      rezData.donem1 ||
      rezData.Donem1 ||
      rezData.kayitTarihi ||
      rezData.KayitTarihi
    );

  var to =
    this.normalizeDateValue(
      rezData.travelTo ||
      rezData.TravelTo ||
      rezData.donem2 ||
      rezData.Donem2 ||
      rezData.kayitTarihi ||
      rezData.KayitTarihi
    );

  var dates = [];

  (kalemler || []).forEach(function(kalem) {
    var d1 = this.normalizeDateValue(kalem.donem1 || kalem.Donem1);
    var d2 = this.normalizeDateValue(kalem.donem2 || kalem.Donem2);

    if (d1 && d1 !== "0001-01-01") {
      dates.push(d1);
    }

    if (d2 && d2 !== "0001-01-01") {
      dates.push(d2);
    }
  }.bind(this));

  if (dates.length) {
    dates.sort();

    if (!from || from === "0001-01-01") {
      from = dates[0];
    }

    if (!to || to === "0001-01-01") {
      to = dates[dates.length - 1];
    }
  }

  return {
    from: from,
    to: to || from
  };
},

//Backend adres/yolcu objesini UI passenger objesine çevirir
mapAdresToPassenger(adres) {
  adres = adres || {};

  var adSoyad =
    adres.adSoyad ||
    adres.AdSoyad ||
    adres.isim ||
    adres.Isim ||
    "";

  var parts = adSoyad.split(" ");

  var dogumTarihi = this.normalizeDateValue(
    adres.dogumTarihi ||
    adres.DogumTarihi ||
    adres.birthDate ||
    adres.BirthDate
  );

  if (dogumTarihi === "0001-01-01") {
    dogumTarihi = null;
  }

  var firstName =
    adres.firstName ||
    adres.FirstName ||
    parts[0] ||
    "";

  var lastName =
    adres.lastName ||
    adres.LastName ||
    parts.slice(1).join(" ") ||
    "";

  var passportNumber =
    adres.pasaportNo ||
    adres.PasaportNo ||
    adres.passportNumber ||
    adres.PassportNumber ||
    "";

  var nationality =
    adres.ulke ||
    adres.Ulke ||
    adres.uyruk ||
    adres.Uyruk ||
    adres.nationality ||
    adres.Nationality ||
    "";

  if (nationality) {
    var natUpper = nationality.toString().trim().toUpperCase();

    if (natUpper === "TR" || natUpper === "TURKIYE" || natUpper === "TÜRKİYE") {
      nationality = "Türkiye";
    }
  }

  return {
    id: adres.id || adres.ID || adres.Ref || null,
    kod: adres.kod || adres.Kod || adres.AdresID || null,
    kisiTableRef: adres.kisiTableRef || adres.KisiTableRef || adres.KisiTableREF || null,

    profilId: adres.profilId || adres.ProfilId || adres.ProfilID || 0,
    sicilId: adres.sicilId || adres.SicilId || adres.SicilID || 0,
    kisiSira: adres.kisiSira !== undefined ? adres.kisiSira : (adres.KisiSira !== undefined ? adres.KisiSira : null),
    yas: adres.yas || adres.Yas || 0,

    kisiTipi: this.backendKisiTipToSimple(
      adres.kisiTip !== undefined ? adres.kisiTip : adres.kisiTipi
    ),

    firstName: firstName,
    lastName: lastName,

    name: firstName,
    surname: lastName,

    adSoyad: adSoyad || (firstName + " " + lastName).trim(),

    birthDate: dogumTarihi,

    phone: adres.gsm || adres.GSM || adres.telefon1 || adres.Telefon1 || "",
    gsm: adres.gsm || adres.GSM || "",
    telefon1: adres.telefon1 || adres.Telefon1 || "",

    email: adres.eMail || adres.Email || adres.email || "",
    eMail: adres.eMail || adres.Email || adres.email || "",

    idNumber: adres.tcKimlikNo || adres.TCKimlikNo || "",
    tcKimlikNo: adres.tcKimlikNo || adres.TCKimlikNo || "",

    gender: adres.cinsiyet || adres.Cinsiyet || "",
    cinsiyet: adres.cinsiyet || adres.Cinsiyet || "",

    address: adres.adres || adres.Adres || "",
    adres: adres.adres || adres.Adres || "",

    passportNumber: passportNumber,
    pasaportNo: passportNumber,
    PasaportNo: passportNumber,

    nationality: nationality,
    ulke: nationality,
    Ulke: nationality,
    country: nationality,
    uyruk: nationality,
    Uyruk: nationality,

    pasaportVerilisYeri: adres.pasaportVerilisYeri || adres.PasaportVerilisYeri || "",
    pasaportVerilisTarihi: adres.pasaportVerilisTarihi || adres.PasaportVerilisTarihi || "0001-01-01",
    pasaportBitisTarihi: adres.pasaportBitisTarihi || adres.PasaportBitisTarihi || "0001-01-01",

    disID: adres.disID || adres.DisID || null,
    mileCard: adres.mileCard || adres.MileCard || null,
    tekerlekliSandalye: adres.tekerlekliSandalye || adres.TekerlekliSandalye || 0
  };
},

mapPassengerToAdres(passenger, index) {
  passenger = passenger || {};

  var firstName =
    passenger.firstName ||
    passenger.name ||
    "";

  var lastName =
    passenger.lastName ||
    passenger.surname ||
    "";

  var adSoyad =
    passenger.adSoyad ||
    ((firstName || "") + " " + (lastName || "")).trim();

  var dogumTarihi =
    passenger.birthDate ||
    passenger.dogumTarihi ||
    null;

  if (dogumTarihi) {
    dogumTarihi = this.normalizeDateValue(dogumTarihi);
  }

  var nationality =
    passenger.nationality ||
    passenger.ulke ||
    passenger.Ulke ||
    passenger.country ||
    passenger.uyruk ||
    passenger.Uyruk ||
    "";

  if (nationality) {
    var natUpper = nationality.toString().trim().toUpperCase();

    if (natUpper === "TR" || natUpper === "TURKIYE" || natUpper === "TÜRKİYE") {
      nationality = "Türkiye";
    }
  }

  var passportNumber =
    passenger.passportNumber ||
    passenger.pasaportNo ||
    passenger.PasaportNo ||
    passenger.PassportNumber ||
    "";

  return {
    id: passenger.id || null,

    kisiTip: this.simpleKisiTipToBackend(passenger.kisiTipi || passenger.kisiTip),
    kisiSira: index,
    yas: passenger.yas || 0,

    profilId: passenger.profilId || passenger.ProfilId || passenger.ProfilID || 0,
    sicilId: passenger.sicilId || passenger.SicilId || passenger.SicilID || 0,

    tcKimlikNo: passenger.idNumber || passenger.tcKimlikNo || "",
    TCKimlikNo: passenger.idNumber || passenger.tcKimlikNo || "",

    uyeNo: passenger.uyeNo || "",

    adSoyad: adSoyad,
    AdSoyad: adSoyad,

    adres: passenger.address || passenger.adres || "",
    Adres: passenger.address || passenger.adres || "",

    dogumTarihi: dogumTarihi || null,
    DogumTarihi: dogumTarihi || null,

    cinsiyet: passenger.cinsiyet || this.simpleGenderToBackend(passenger.gender),
    Cinsiyet: passenger.cinsiyet || this.simpleGenderToBackend(passenger.gender),

    telefon1: passenger.telefon1 || passenger.phone || "",
    Telefon1: passenger.telefon1 || passenger.phone || "",

    gsm: passenger.gsm || passenger.phone || "",
    GSM: passenger.gsm || passenger.phone || "",

    eMail: passenger.eMail || passenger.email || "",
    Email: passenger.eMail || passenger.email || "",

    kisiTableRef: passenger.kisiTableRef || passenger.KisiTableRef || null,
    KisiTableRef: passenger.kisiTableRef || passenger.KisiTableRef || null,

    kod: passenger.kod || passenger.Kod || null,
    Kod: passenger.kod || passenger.Kod || null,

    firstName: firstName,
    FirstName: firstName,

    lastName: lastName,
    LastName: lastName,

    ulke: nationality,
    Ulke: nationality,
    uyruk: nationality,
    Uyruk: nationality,
    nationality: nationality,

    pasaportNo: passportNumber,
    PasaportNo: passportNumber,
    passportNumber: passportNumber,

    pasaportVerilisYeri: passenger.pasaportVerilisYeri || passenger.PasaportVerilisYeri || "",
    PasaportVerilisYeri: passenger.pasaportVerilisYeri || passenger.PasaportVerilisYeri || "",

    pasaportVerilisTarihi: passenger.pasaportVerilisTarihi || passenger.PasaportVerilisTarihi || "0001-01-01",
    PasaportVerilisTarihi: passenger.pasaportVerilisTarihi || passenger.PasaportVerilisTarihi || "0001-01-01",

    pasaportBitisTarihi: passenger.pasaportBitisTarihi || passenger.PasaportBitisTarihi || "0001-01-01",
    PasaportBitisTarihi: passenger.pasaportBitisTarihi || passenger.PasaportBitisTarihi || "0001-01-01",

    disID: passenger.disID || null,
    DisID: passenger.disID || null,

    tekerlekliSandalye: passenger.tekerlekliSandalye || 0,
    TekerlekliSandalye: passenger.tekerlekliSandalye || 0,

    mileCard: passenger.mileCard || null,
    MileCard: passenger.mileCard || null
  };
},

//Backend kalem objesini UI servis objesine çevirir
mapLoadedKalemToService(kalem, passengers) {
  var kalemPassengers = [];

if (kalem.kisiSira && kalem.kisiSira.length) {
  kalem.kisiSira.forEach(function(sira) {
    if (passengers[sira]) {
      kalemPassengers.push(passengers[sira]);
    }
  });
} else {
  kalemPassengers = passengers.slice(0);
}

kalemPassengers = this.uniqueServicePassengers(kalemPassengers);

  var base = {
    satici: kalem.satici || { kod: "", isim: "" },
    tourOperator: kalem.turOperatoru || { kod: "", isim: "" },
    passengers: kalemPassengers,
    netPrice: Number(kalem.yet_Satis) || 0,
    supplierCost: Number(kalem.yet_Alis) || 0,
    commissionAmount: Number(kalem.komisyonTutar) || 0,
    vatRate: 0,
    vatAmount: 0,
    grossPrice: Number(kalem.yet_Satis) || 0,
    notes: kalem.aciklama || kalem.Aciklama || ""
  };

  if (kalem.saticiTip == 8) {
  var charter = kalem.kalemCharter || kalem.baseKalem || {};
  var operatorKod = charter.OperatorCari || charter.operatorCari || "";

  return Object.assign(base, {
    tourOperator: operatorKod
      ? {
          id: operatorKod,
          kod: operatorKod,
          isim: operatorKod,
          tip: 12
        }
      : {
          id: "",
          kod: "",
          isim: "",
          tip: 12
        },

    from: charter.Nerden || charter.nerden || "",
    to: charter.Nereye || charter.nereye || "",

    // UcusNo sistemde 1/2 gibi çalışıyor
    ucusNo: charter.UcusNo || charter.ucusNo || "1",

    // Şimdilik listede/eski UI'da görünsün diye bırakıyoruz
    flightNumber: charter.UcusNo || charter.ucusNo || "",

    airlinePnr:
  charter.PNR ||
  charter.pnr ||
  charter.CharterKod ||
  charter.charterKod ||
  charter.Kontenjan ||
  charter.kontenjan ||
  "",
    ticketNumber: charter.BiletNo || charter.biletNo || "",

    departureDate: kalem.donem1 || null,
    arrivalDate: kalem.donem2 || null,

    departureTime:
      charter.Saat &&
      charter.Saat.toString().indexOf("0001-01-01") === -1
        ? charter.Saat
        : "",

    arrivalTime: "",

    vatRate: kalem.satis ? Number(kalem.satis.KDVOran) || 0 : 0,
    vatAmount: kalem.satis ? Number(kalem.satis.KDVTutar) || 0 : 0,

    taxAmount:
  Number(charter.YetiskinTax) ||
  Number(charter.yetiskinTax) ||
  Number(charter.FuelPriceDifference) ||
  Number(charter.fuelPriceDifference) ||
  0,

fuelPriceDifference:
  Number(charter.YetiskinTax) ||
  Number(charter.yetiskinTax) ||
  0,

    flightType: charter.FlightType || charter.flightType || "International",
    bookingType: charter.BookingType || charter.bookingType || "Reservation",
    classType: charter.ClassType || charter.classType || "Economy",

    opsiyonluMusteri:
      charter.OpsiyonluMusteri === true ||
      charter.opsiyonluMusteri === true,

    opsiyonTarihi:
      charter.OpsiyonTarihi ||
      charter.opsiyonTarihi ||
      "",

    opsiyonSaati: this.backendTimeToSimple(
      charter.OpsiyonSaati ||
      charter.opsiyonSaati ||
      ""
    )
  });
}

 if (kalem.saticiTip == 1) {
  var otel = kalem.kalemOtel || kalem.baseKalem || {};

  var vatRate = kalem.satis ? Number(kalem.satis.KDVOran) || 0 : 0;
  var vatAmount = kalem.satis ? Number(kalem.satis.KDVTutar) || 0 : 0;

  var grossPrice = Number(kalem.yet_Satis) || 0;
  var netPrice = grossPrice - vatAmount;

  return Object.assign(base, {
    city: otel.konum || "",

    country: otel.Country || otel.country || "",

    roomType: otel.odaTipi
  ? otel.odaTipi.kod ||
    otel.odaTipi.id ||
    ""
  : "",

  roomTypeName: otel.odaTipi
  ? otel.odaTipi.isim ||
    otel.odaTipiIsim ||
    this.getHotelRoomTypeName(otel.odaTipi.kod || otel.odaTipi.id || "")
  : "",

    boardType:
      otel.BoardType ||
      otel.boardType ||
      this.backendBoardTypeToSimple(otel.pansiyon),

    checkIn: kalem.donem1 || null,
    checkOut: kalem.donem2 || null,

    rooms: Number(otel.odaSayi) || 1,
    guests: Number(kalem.yet_KisiSayisi) || 1,

    confirmationNo: kalem.tedarikciAciklama || "",

    // Pricing
    netPrice: netPrice,
    vatRate: vatRate,
    vatAmount: vatAmount,
    grossPrice: grossPrice,
    commissionAmount: Number(kalem.komisyonTutar) || 0,
    supplierCost: Number(kalem.yet_Alis) || 0
  });
}

if (kalem.saticiTip == 5) {
  var rent = kalem.kalemRentACar || kalem.baseKalem || {};

  var carLoadVatRate = kalem.satis
    ? Number(kalem.satis.KDVOran) || 0
    : 0;

  var carLoadVatAmount = kalem.satis
    ? Number(kalem.satis.KDVTutar) || 0
    : 0;

  var carLoadGrossPrice = Number(kalem.yet_Satis) || 0;
  var carLoadNetPrice = carLoadGrossPrice;

  // Backend KDVTutar null/0 dönerse ekranda göstermek için hesapla
  if (!carLoadVatAmount && carLoadVatRate > 0 && carLoadGrossPrice > 0) {
    carLoadNetPrice = Number(
      (carLoadGrossPrice / (1 + carLoadVatRate / 100)).toFixed(2)
    );
    carLoadVatAmount = Number(
      (carLoadGrossPrice - carLoadNetPrice).toFixed(2)
    );
  } else {
    carLoadNetPrice = carLoadGrossPrice - carLoadVatAmount;
  }

  return Object.assign(base, {
    carType: rent.arac || rent.Arac || "",
    category: rent.kategori || rent.Kategori || "",

    pickupLocation: rent.alisYeri || rent.AlisYeri || "",
    dropoffLocation:
      rent.teslimYeri ||
      rent.TeslimYeri ||
      rent.alisYeri ||
      rent.AlisYeri ||
      "",

    pickupDate: kalem.donem1 || rent.alisTarih || rent.AlisTarih || null,
    dropoffDate: kalem.donem2 || rent.teslimTarih || rent.TeslimTarihi || null,

    pickupTime: this.backendDateTimeToTime
      ? this.backendDateTimeToTime(rent.alisSaat || rent.AlisSaat)
      : this.backendTimeToSimple(rent.alisSaat || rent.AlisSaat),

    dropoffTime: this.backendDateTimeToTime
      ? this.backendDateTimeToTime(rent.teslimSaat || rent.TeslimSaat)
      : this.backendTimeToSimple(rent.teslimSaat || rent.TeslimSaat),

    confirmationNo:
      rent.ConfirmationNo ||
      rent.confirmationNo ||
      kalem.tedarikciAciklama ||
      "",

    netPrice: carLoadNetPrice,
    vatRate: carLoadVatRate,
    vatAmount: carLoadVatAmount,
    grossPrice: carLoadGrossPrice,
    commissionAmount: Number(kalem.komisyonTutar) || 0,
    supplierCost: Number(kalem.yet_Alis) || 0
  });
}

if (kalem.saticiTip == 2) {
  var transfer = kalem.kalemArac || kalem.baseKalem || {};

  var transferLoadVatRate = kalem.satis
    ? Number(kalem.satis.KDVOran) || 0
    : 0;

  var transferLoadVatAmount = kalem.satis
    ? Number(kalem.satis.KDVTutar) || 0
    : 0;

  var transferLoadGrossPrice = Number(kalem.yet_Satis) || 0;
  var transferLoadNetPrice = transferLoadGrossPrice;

  // Backend KDVTutar null/0 dönerse ekranda göstermek için hesapla
  if (!transferLoadVatAmount && transferLoadVatRate > 0 && transferLoadGrossPrice > 0) {
    transferLoadNetPrice = Number(
      (transferLoadGrossPrice / (1 + transferLoadVatRate / 100)).toFixed(2)
    );

    transferLoadVatAmount = Number(
      (transferLoadGrossPrice - transferLoadNetPrice).toFixed(2)
    );
  } else {
    transferLoadNetPrice = transferLoadGrossPrice - transferLoadVatAmount;
  }

  return Object.assign(base, {
    from:
      transfer.nerden ||
      transfer.nereden ||
      transfer.Nerden ||
      transfer.Nereden ||
      "",

    to:
      transfer.nereye ||
      transfer.Nereye ||
      "",

    date: kalem.donem1 || null,

    time: this.backendDateTimeToTime
  ? this.backendDateTimeToTime(
      transfer.saat ||
      transfer.Saat ||
      transfer.seferSaat ||
      transfer.SeferSaat
    )
  : this.backendTimeToSimple(
      transfer.saat ||
      transfer.Saat ||
      transfer.seferSaat ||
      transfer.SeferSaat
    ),

    type:
      transfer.tip ||
      transfer.Tip ||
      transfer.tasimaTipi ||
      transfer.TasimaTipi ||
      "",

    vehicleType:
      transfer.arac ||
      transfer.Arac ||
      "",

    passengerCount:
      Number(kalem.yet_KisiSayisi) || 1,

    driverName:
      transfer.DriverName ||
      transfer.driverName ||
      transfer.soforAdi ||
      transfer.SoforAdi ||
      "",

    driverPhone:
      transfer.DriverGsm ||
      transfer.driverGsm ||
      transfer.DriverPhone ||
      transfer.driverPhone ||
      transfer.soforGsm ||
      transfer.SoforGsm ||
      transfer.GSM ||
      "",

    plateNumber:
      transfer.PlateNumber ||
      transfer.plateNumber ||
      transfer.plaka ||
      transfer.Plaka ||
      "",

    confirmationNo:
      transfer.ConfirmationNo ||
      transfer.confirmationNo ||
      transfer.rezervasyonNo ||
      transfer.RezervasyonNo ||
      kalem.tedarikciAciklama ||
      "",

    netPrice: transferLoadNetPrice,
    vatRate: transferLoadVatRate,
    vatAmount: transferLoadVatAmount,
    grossPrice: transferLoadGrossPrice,
    commissionAmount: Number(kalem.komisyonTutar) || 0,
    supplierCost: Number(kalem.yet_Alis) || 0
  });
}

if (kalem.saticiTip == 4) {
  var dailyTour = kalem.kalemAcente || kalem.baseKalem || {};

  var dailyTourLoadVatRate = kalem.satis
    ? Number(kalem.satis.KDVOran) || 0
    : 0;

  var dailyTourLoadVatAmount = kalem.satis
    ? Number(kalem.satis.KDVTutar) || 0
    : 0;

  var dailyTourLoadGrossPrice = Number(kalem.yet_Satis) || 0;
  var dailyTourLoadNetPrice = dailyTourLoadGrossPrice;

  if (
    !dailyTourLoadVatAmount &&
    dailyTourLoadVatRate > 0 &&
    dailyTourLoadGrossPrice > 0
  ) {
    dailyTourLoadNetPrice = Number(
      (dailyTourLoadGrossPrice / (1 + dailyTourLoadVatRate / 100)).toFixed(2)
    );

    dailyTourLoadVatAmount = Number(
      (dailyTourLoadGrossPrice - dailyTourLoadNetPrice).toFixed(2)
    );
  } else {
    dailyTourLoadNetPrice = dailyTourLoadGrossPrice - dailyTourLoadVatAmount;
  }

  return Object.assign(base, {
    tourCode:
      dailyTour.TurKodu ||
      dailyTour.turKodu ||
      dailyTour.Tip ||
      dailyTour.tip ||
      "",

    tourName:
      dailyTour.TourName ||
      dailyTour.tourName ||
      kalem.aciklama ||
      "",

    date: kalem.donem1 || dailyTour.AcenteRezTar || dailyTour.acenteRezTar || null,

    time: this.backendDateTimeToTime
      ? this.backendDateTimeToTime(dailyTour.Saat || dailyTour.saat)
      : this.backendTimeToSimple(dailyTour.Saat || dailyTour.saat),

    meetingPoint:
      dailyTour.BulusmaYeri ||
      dailyTour.bulusmaYeri ||
      "",

    pickupLocation:
      dailyTour.BulusmaYeri ||
      dailyTour.bulusmaYeri ||
      "",

    program:
      dailyTour.Program ||
      dailyTour.program ||
      "",

    description:
      dailyTour.Program ||
      dailyTour.program ||
      "",

    netPrice: dailyTourLoadNetPrice,
    vatRate: dailyTourLoadVatRate,
    vatAmount: dailyTourLoadVatAmount,
    grossPrice: dailyTourLoadGrossPrice,
    commissionAmount: Number(kalem.komisyonTutar) || 0,
    supplierCost: Number(kalem.yet_Alis) || 0
  });
}

if (kalem.saticiTip == 9) {
  var gemi = kalem.kalemGemi || kalem.baseKalem || {};

  var vatRate = kalem.satis ? Number(kalem.satis.KDVOran) || 0 : 0;
  var vatAmount = kalem.satis ? Number(kalem.satis.KDVTutar) || 0 : 0;
  var grossPrice = Number(kalem.yet_Satis) || 0;
  var netPrice = grossPrice;

  if (!vatAmount && vatRate > 0 && grossPrice > 0) {
    netPrice = Number((grossPrice / (1 + vatRate / 100)).toFixed(2));
    vatAmount = Number((grossPrice - netPrice).toFixed(2));
  } else {
    netPrice = grossPrice - vatAmount;
  }

  return Object.assign(base, {
   hotelName:
  gemi.Gemi ||
  gemi.gemi ||
  kalem.aciklama ||
  "",

    city: gemi.Konum || gemi.konum || "",

    country: gemi.Country || gemi.country || "",

    confirmationNo:
      gemi.ConfirmationNo ||
      gemi.confirmationNo ||
      kalem.tedarikciAciklama ||
      "",

    roomType: gemi.CabinType || gemi.cabinType || "",
    cabinType: gemi.CabinType || gemi.cabinType || "",

    checkIn: kalem.donem1 || null,
    checkOut: kalem.donem2 || null,

    rooms: Number(gemi.KabinSayisi) || 1,
    guests: Number(kalem.yet_KisiSayisi) || 1,

    netPrice: netPrice,
    vatRate: vatRate,
    vatAmount: vatAmount,
    grossPrice: grossPrice,
    commissionAmount: Number(kalem.komisyonTutar) || 0,
    supplierCost: Number(kalem.yet_Alis) || 0
  });
}

if (kalem.saticiTip == 10) {
  var other = kalem.kalemDiger || kalem.baseKalem || {};

  var otherLoadVatRate = kalem.satis
    ? Number(kalem.satis.KDVOran) || 0
    : 0;

  var otherLoadVatAmount = kalem.satis
    ? Number(kalem.satis.KDVTutar) || 0
    : 0;

  var otherLoadGrossPrice = Number(kalem.yet_Satis) || 0;
  var otherLoadNetPrice = otherLoadGrossPrice;

  if (!otherLoadVatAmount && otherLoadVatRate > 0 && otherLoadGrossPrice > 0) {
    otherLoadNetPrice = Number(
      (otherLoadGrossPrice / (1 + otherLoadVatRate / 100)).toFixed(2)
    );

    otherLoadVatAmount = Number(
      (otherLoadGrossPrice - otherLoadNetPrice).toFixed(2)
    );
  } else {
    otherLoadNetPrice = otherLoadGrossPrice - otherLoadVatAmount;
  }

  return Object.assign(base, {
    title:
      other.IsKodu ||
      other.isKodu ||
      kalem.aciklama ||
      "",

    description:
      other.isAciklama ||
      other.IsAciklama ||
      other.Aciklama ||
      other.aciklama ||
      kalem.tedarikciAciklama ||
      "",

    startDate: kalem.donem1 || null,
    endDate: kalem.donem2 || kalem.donem1 || null,

    netPrice: otherLoadNetPrice,
    vatRate: otherLoadVatRate,
    vatAmount: otherLoadVatAmount,
    grossPrice: otherLoadGrossPrice,
    commissionAmount: Number(kalem.komisyonTutar) || 0,
    supplierCost: Number(kalem.yet_Alis) || 0
  });
}

  return null;
},





openAdresDefteriSec() {
  if (!this.selectedReservation) {
    return;
  }

  if (this.$refs.adresdefterisec) {
    this.$refs.adresdefterisec.open();
  }
},



onAdresDefteriPassengerSelected(adres) {
  if (!this.selectedReservation) {
    return;
  }

  if (!this.selectedReservation.passengers) {
    this.$set(this.selectedReservation, "passengers", []);
  }

  var passenger = this.mapAdresDefteriToPassenger(adres);

  var exists = this.selectedReservation.passengers.some(function(p) {
    var sameAddressBookId =
      passenger.addressBookId &&
      p.addressBookId &&
      String(p.addressBookId) === String(passenger.addressBookId);

    var sameTc =
      passenger.idNumber &&
      p.idNumber &&
      String(p.idNumber) === String(passenger.idNumber);

    return sameAddressBookId || sameTc;
  });

  if (exists) {
    alert("Bu kişi zaten yolcu listesine eklenmiş.");
    return;
  }

  this.selectedReservation.passengers.push(passenger);
},


//
mapAdresDefteriToPassenger(adres) {
  adres = adres || {};

  return {
    kisiTipi: "Yetişkin",

    firstName: adres.Ad || adres.Isim || "",
    lastName: adres.Soyad || "",

    birthDate: this.normalizeAdresDefteriDate(
      adres.DogumTarihi ||
      adres.DogumGunu ||
      adres.DogumTarih ||
      null
    ),

    idNumber: adres.TCKimlikNo || "",
    gender: adres.Cinsiyet || "",
    cinsiyet: adres.Cinsiyet || "",

    phone: adres.GSM || adres.Telefon1 || adres.Telefon || "",
    email: adres.Email || adres.EMail || "",

    nationality: adres.Ulke || "",
    passportNumber:
      adres.PasaportNo ||
      adres.PassportNumber ||
      adres.Pasaport ||
      "",

    address:
      adres.Adres ||
      adres.Adres1 ||
      "",

    city: adres.Sehir || "",
    country: adres.Ulke || "",

    fromAddressBook: true,
    addressBookId: adres.Id || adres.Kod || null,
    addressBookCode: adres.Kod || "",
    addressBookSaved: true,

    rawAddressBook: adres
  };
},


//
normalizeAdresDefteriDate(value) {
  if (!value) {
    return "";
  }

  if (typeof value === "string") {
    var text = value.trim();

    var trMatch = text.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (trMatch) {
      return trMatch[3] + "-" + trMatch[2] + "-" + trMatch[1];
    }

    var isoMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
      return isoMatch[1] + "-" + isoMatch[2] + "-" + isoMatch[3];
    }

    var msMatch = text.match(/\/Date\((\d+)\)\//);
    if (msMatch) {
      var d = new Date(Number(msMatch[1]));
      return this.formatDateObjectForInput(d);
    }
  }

  if (value instanceof Date) {
    return this.formatDateObjectForInput(value);
  }

  return "";
},


//
formatDateObjectForInput(date) {
  if (!date || isNaN(date.getTime())) {
    return "";
  }

  var year = date.getFullYear();
  var month = ("0" + (date.getMonth() + 1)).slice(-2);
  var day = ("0" + date.getDate()).slice(-2);

  return year + "-" + month + "-" + day;
},


//
getPassengerAddressBookKey(passenger) {
  passenger = passenger || {};

  var tc = this.onlyDigits(passenger.idNumber);
  if (tc) {
    return "TC:" + tc;
  }

  var passport = this.safeUpper(passenger.passportNumber);
  if (passport) {
    return "PSP:" + passport;
  }

  var name = this.safeUpper(passenger.firstName);
  var surname = this.safeUpper(passenger.lastName);
  var phone = this.onlyDigits(passenger.phone);

  if (name && surname && phone) {
    return "NPH:" + name + "|" + surname + "|" + phone;
  }

  if (name && surname) {
    return "NM:" + name + "|" + surname;
  }

  return "";
},


//
   saveMissingPassengersToAddressBook() {
  if (this.addressBookSaveInProgress) {
    return Promise.resolve();
  }

  this.addressBookSaveInProgress = true;

  var passengers =
    this.selectedReservation && this.selectedReservation.passengers
      ? this.selectedReservation.passengers
      : [];

  var chain = Promise.resolve();
  var savedCache = {};

  passengers.forEach(
    function(passenger, index) {
      chain = chain.then(
        function() {
          if (!passenger) {
            return Promise.resolve();
          }

          var key = this.getPassengerAddressBookKey(passenger);

          if (!key) {
            return Promise.resolve();
          }

          if (passenger.fromAddressBook === true || passenger.addressBookSaved === true) {
            savedCache[key] = {
              Id: passenger.addressBookId || null,
              Kod: passenger.addressBookCode || ""
            };

            return Promise.resolve(savedCache[key]);
          }

          if (savedCache[key]) {
            this.updatePassengerAddressBookInfo(index, savedCache[key]);
            return Promise.resolve(savedCache[key]);
          }

          return this.savePassengerToAddressBookIfNeeded(passenger, index).then(
            function(savedAdres) {
              if (savedAdres) {
                savedCache[key] = savedAdres;
              }

              return savedAdres;
            }.bind(this)
          );
        }.bind(this)
      );
    }.bind(this)
  );

  return chain.then(
    function(result) {
      this.addressBookSaveInProgress = false;
      return result;
    }.bind(this),
    function(error) {
      this.addressBookSaveInProgress = false;
      return Promise.reject(error);
    }.bind(this)
  );
},


//
savePassengerToAddressBookIfNeeded(passenger, index) {
  if (!passenger) {
    return Promise.resolve();
  }

  if (passenger.fromAddressBook === true || passenger.addressBookSaved === true) {
    return Promise.resolve();
  }

  var firstName = (passenger.firstName || "").trim();
  var lastName = (passenger.lastName || "").trim();

  if (!firstName && !lastName) {
    return Promise.resolve();
  }

  return this.findAddressBookPassenger(passenger).then(
    function(existingAdres) {
      if (existingAdres) {
        this.updatePassengerAddressBookInfo(index, existingAdres);
        return existingAdres;
      }

      var adresValue = this.mapPassengerToAddressBookValue(passenger);

      return new Promise(
        function(resolve, reject) {
          tool.http_post(this, "AdresInsert", { Value: adresValue }).then(
            function(response) {
              if (response.body && response.body.Status === true) {
                var savedAdres = response.body.data || adresValue;

                this.updatePassengerAddressBookInfo(index, savedAdres);

                resolve(savedAdres);
              } else {
                var errorText =
                  response.body &&
                  response.body.ErrorList &&
                  response.body.ErrorList.length
                    ? response.body.ErrorList[0]
                    : "Adres kaydı eklenemedi.";

                reject(errorText);
              }
            }.bind(this),
            function() {
              reject("Adres kaydı sırasında hata oluştu.");
            }.bind(this)
          );
        }.bind(this)
      );
    }.bind(this)
  );
},


//
findAddressBookPassenger(passenger) {
  var params = {
    Isim: null,
    Kategori: null,
    Telefon: null,
    Ulke: null,
    Sehir: null,
    OnlineCIn: null,
    DogumGunu_Gun: null,
    DogumGunu_Ay: null,
    TCKimlikNo: null
  };

  if (passenger.idNumber) {
    params.TCKimlikNo = passenger.idNumber;
  } else if (passenger.phone) {
    params.Telefon = passenger.phone;
  } else {
    params.Isim =
      ((passenger.firstName || "") + " " + (passenger.lastName || "")).trim() ||
      null;
  }

  return new Promise(
    function(resolve, reject) {
      tool.http_post(this, "AdresList", params).then(
        function(response) {
          if (response.body && response.body.Status === true) {
            var list = response.body.data || [];
            var found = null;

            for (var i = 0; i < list.length; i++) {
              if (this.isSameAddressBookPerson(passenger, list[i])) {
                found = list[i];
                break;
              }
            }

            resolve(found);
          } else {
            reject("Adres defteri kontrolü yapılamadı.");
          }
        }.bind(this),
        function() {
          reject("Adres defteri kontrolü sırasında hata oluştu.");
        }.bind(this)
      );
    }.bind(this)
  );
},


//
isSameAddressBookPerson(passenger, adres) {
  passenger = passenger || {};
  adres = adres || {};

  var passengerTc = this.onlyDigits(passenger.idNumber);
  var adresTc = this.onlyDigits(adres.TCKimlikNo);

  if (passengerTc && adresTc && passengerTc === adresTc) {
    return true;
  }

  var passengerPassport = this.safeUpper(passenger.passportNumber);
  var adresPassport = this.safeUpper(adres.PasaportNo);

  if (passengerPassport && adresPassport && passengerPassport === adresPassport) {
    return true;
  }

  var passengerName = this.safeUpper(passenger.firstName);
  var passengerSurname = this.safeUpper(passenger.lastName);
  var adresName = this.safeUpper(adres.Ad);
  var adresSurname = this.safeUpper(adres.Soyad);

  var passengerPhone = this.onlyDigits(passenger.phone);
  var adresPhone =
    this.onlyDigits(adres.GSM) ||
    this.onlyDigits(adres.Telefon1) ||
    this.onlyDigits(adres.Telefon);

  if (
    passengerName &&
    passengerSurname &&
    adresName &&
    adresSurname &&
    passengerName === adresName &&
    passengerSurname === adresSurname
  ) {
    if (!passengerPhone || !adresPhone) {
      return true;
    }

    return passengerPhone === adresPhone;
  }

  return false;
},


//
mapPassengerToAddressBookValue(passenger) {
  passenger = passenger || {};

  var credentials = JSON.parse(window.localStorage.getItem("credentials"));

  return {
    CreatedBy: null,
    CreatedDate: null,
    ModifiedBy: null,
    ModifiedDate: null,

    PspOfsTeslimAlan: null,
    PspOfsTeslimTarihi: null,
    PspMusTeslimEden: null,
    PspMusTeslimTarihi: null,

    dptBolge: { id: null, kod: null, isim: null, tip: null },
    dptYonetim: { id: null, kod: null, isim: null, tip: null },
    dptDepartman: { id: null, kod: null, isim: null, tip: null },
    dptAltDepartman: { id: null, kod: null, isim: null, tip: null },
    dptBolum: { id: null, kod: null, isim: null, tip: null },
    dptCariKod: { id: null, kod: null, isim: null, tip: null },

    SicilID: null,
    Id: 0,
    Kod: 0,

    Kategori: null,

    Ad: passenger.firstName || "",
    Soyad: passenger.lastName || "",

    Adres: passenger.address || "",
    DogumTarihi: passenger.birthDate || null,

    Ulke: passenger.country || passenger.nationality || null,
    Sehir: passenger.city || null,
    Uyruk: passenger.nationality || null,

    Meslek: null,

    Telefon1: passenger.phone || null,
    Telefon2: null,
    GSM: passenger.phone || null,

    Email: passenger.email || null,

    PasaportTip: 0,
    PasaportNo: passenger.passportNumber || null,
    VerildigiYer: null,
    VerilisTarihi: null,
    BitisTarihi: null,

    Sigara: null,
    Notlar: null,
    USAVize: null,
    USABitis: null,
    AnneAdi: null,
    BabaAdi: null,

    TCKimlikNo: passenger.idNumber || null,
    DogumYeri: null,

    Cinsiyet: this.passengerGenderToAdresGender(passenger.gender || passenger.cinsiyet),

    RezIstekleri: null,

    SirketNo: credentials ? credentials.CoperSirketNo : null,
    UyeNo: null,

    PspCocukVar: false,
    PspCocukVizeIstiyor: false,
    Cocuk1Kod: null,

    OnlineCIn: false,

    OzelGun1: null,
    OzelGun2: null,
    OzelGun3: null,
    OzelGun4: null,
    OzelGun5: null,

    EskiYeni: null
  };
},


//
updatePassengerAddressBookInfo(index, adres) {
  if (
    !this.selectedReservation ||
    !this.selectedReservation.passengers ||
    index === null ||
    index === undefined ||
    index < 0
  ) {
    return;
  }

  var oldPassenger = this.selectedReservation.passengers[index] || {};
  var updatedPassenger = Object.assign({}, oldPassenger);

  updatedPassenger.fromAddressBook = true;
  updatedPassenger.addressBookSaved = true;
  updatedPassenger.addressBookId = adres.Id || oldPassenger.addressBookId || null;
  updatedPassenger.addressBookCode = adres.Kod || oldPassenger.addressBookCode || "";

  this.$set(this.selectedReservation.passengers, index, updatedPassenger);
},


//
passengerGenderToAdresGender(value) {
  var v = (value || "").toString().toLowerCase();

  if (v === "1") return 1;
  if (v === "2") return 2;

  if (v === "e" || v === "erkek" || v === "male" || v === "m") return 1;
  if (v === "k" || v === "kadın" || v === "kadin" || v === "female" || v === "f") return 2;

  return null;
},


//
onlyDigits(value) {
  return (value || "").toString().replace(/\D/g, "");
},

//
safeUpper(value) {
  return (value || "").toString().trim().toUpperCase();
},


//



















    uniqueServicePassengers(list) {
  var result = [];
  var seen = {};

  (list || []).forEach(function(passenger, index) {
    passenger = passenger || {};

    var key = "";

    if (passenger.kisiTableRef) {
      key = "KISIREF:" + passenger.kisiTableRef;
    } else if (passenger.id) {
      key = "ID:" + passenger.id;
    } else if (passenger.kod) {
      key = "KOD:" + passenger.kod;
    } else if (passenger.addressBookId) {
      key = "ADDR:" + passenger.addressBookId;
    } else if (passenger.idNumber) {
      key = "TC:" + passenger.idNumber;
    } else if (passenger.passportNumber) {
      key = "PASS:" + passenger.passportNumber;
    } else {
      key =
        "NAME:" +
        (passenger.firstName || "").toString().trim().toLowerCase() +
        "|" +
        (passenger.lastName || "").toString().trim().toLowerCase() +
        "|" +
        (passenger.birthDate || "");
    }

    if (!key || key === "NAME:||") {
      key = "INDEX:" + index;
    }

    if (!seen[key]) {
      seen[key] = true;
      result.push(passenger);
    }
  });

  return result;
},
 


    
    
    
    




    openDeleteConfirm(message, type, collectionName, index) {
  this.deleteConfirmMessage = message;
  this.deleteConfirmType = type;
  this.deleteConfirmCollectionName = collectionName || "";
  this.deleteConfirmIndex = index;
  this.deleteConfirmDialog = true;
},

cancelDeleteConfirm() {
  this.deleteConfirmDialog = false;
  this.deleteConfirmMessage = "";
  this.deleteConfirmType = "";
  this.deleteConfirmCollectionName = "";
  this.deleteConfirmIndex = null;
},

confirmDelete() {
  if (!this.selectedReservation) {
    this.cancelDeleteConfirm();
    return;
  }

  var index = this.deleteConfirmIndex;

  if (this.deleteConfirmType === "passenger") {
    if (
      this.selectedReservation.passengers &&
      index !== null &&
      index > -1
    ) {
      this.selectedReservation.passengers.splice(index, 1);
    }

    this.cancelDeleteConfirm();
    return;
  }

  if (this.deleteConfirmType === "service") {
    var collectionName = this.deleteConfirmCollectionName;

    if (
      collectionName &&
      this.selectedReservation[collectionName] &&
      index !== null &&
      index > -1
    ) {
      this.selectedReservation[collectionName].splice(index, 1);
      this.recalculateReservationTotal();
    }

    this.cancelDeleteConfirm();
    return;
  }

  this.cancelDeleteConfirm();
},
    getServiceVoucherEndpoint(section) {
  var map = {
    hotels: "Coper/SimpleHotelVoucherPdfDownload", 
    flights: "Coper/SimpleFlightVoucherPdfDownload",
    cruises: "Coper/CruiseVoucherPdfDownload",
    cars: "Coper/RentACarVoucherPdfDownload",
    transfers: "Coper/TransferVoucherPdfDownload",
    dailyTours: "Coper/DailyTourVoucherPdfDownload",
    others: "Coper/OtherVoucherPdfDownload"
  };

  return map[section] || null;
},
    
    
    openAllServiceSections() {
  this.serviceSectionOpen = {
    flights: true,
    hotels: true,
    cruises: true,
    cars: true,
    transfers: true,
    dailyTours: true,
    others: true
  };
},
    onPassengerBirthDateTextInput(value) {
  var digits = (value || "").toString().replace(/\D/g, "").substring(0, 8);

  var formatted = digits;

  if (digits.length > 4) {
    formatted =
      digits.substring(0, 2) +
      "." +
      digits.substring(2, 4) +
      "." +
      digits.substring(4, 8);
  } else if (digits.length > 2) {
    formatted =
      digits.substring(0, 2) +
      "." +
      digits.substring(2, 4);
  }

  this.passengerBirthDateText = formatted;

  if (digits.length === 8) {
    this.setPassengerBirthDateFromText();
  } else {
    this.passengerForm.birthDate = "";
  }
},

isValidBirthDate(day, month, year) {
  day = Number(day);
  month = Number(month);
  year = Number(year);

  if (!day || !month || !year) return false;
  if (year < 1900 || year > 2100) return false;

  var date = new Date(year, month - 1, day);

  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
},

onPassengerBirthDatePicked() {
  this.passengerBirthDateText = this.displayDate(
    this.passengerForm.birthDate
  );

  this.passengerBirthDateMenu = false;
},

setPassengerBirthDateFromText() {
  var value = (this.passengerBirthDateText || "").trim();

  if (!value) {
    this.passengerForm.birthDate = "";
    return;
  }

  var match = value.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);

  if (!match) {
    this.passengerForm.birthDate = "";
    return;
  }

  var day = match[1];
  var month = match[2];
  var year = match[3];

  if (!this.isValidBirthDate(day, month, year)) {
    this.passengerForm.birthDate = "";
    alert("Geçerli bir doğum tarihi giriniz.");
    return;
  }

  this.passengerForm.birthDate = year + "-" + month + "-" + day;
},
    
// FATURA
goToInvoicePage() {
  if (this.loadingvmodel) return;

  if (!this.selectedReservation) {
    this.simpleInvoiceError("Fatura için rezervasyon bulunamadı.");
    return;
  }

  if (this.selectedReservation.isClosed === true) {
    this.simpleInvoiceError("Kapalı rezervasyon için fatura oluşturulamaz.");
    return;
  }

  var invoiceGrossTotal = Number(this.reservationGrossTotal) || 0;

  if (invoiceGrossTotal <= 0) {
    this.simpleInvoiceError(
      "Fatura oluşturulamaz. Rezervasyonun brüt satış toplamı 0,00. En az bir hizmete satış tutarı girip rezervasyonu kaydediniz."
    );
    return;
  }

  // Fatura hazırlanmadan önce ekrandaki güncel kalemleri mutlaka backend'e kaydet.
  // Böylece TopluSatisFaturasiHazirla satış tutarlarını sıfır görmez.
  this.form.customerCode = this.selectedReservation.customerCode || "";
  this.form.customerName = this.selectedReservation.customer || "";
  this.form.customer = this.selectedReservation.customer || "";
  this.form.travelFrom = this.selectedReservation.travelFrom || "";
  this.form.travelTo = this.selectedReservation.travelTo || "";
  this.form.status = this.selectedReservation.status || "Open";
  this.form.payment = this.selectedReservation.payment || "Unpaid";
  this.form.total = invoiceGrossTotal;
  this.form.currency = getCredentialsCurrency();

  var mevcutTakipNo =
    this.selectedReservation.takipNo ||
    this.selectedReservation.TakipNo ||
    this.selectedReservation.Takip_No ||
    this.selectedReservation.satisGrubu ||
    this.selectedReservation.SatisGrubu ||
    "";

  this.editingPnrCode =
    mevcutTakipNo && mevcutTakipNo != "0" && mevcutTakipNo !== "-"
      ? mevcutTakipNo
      : null;

  this.isEditMode = !!this.editingPnrCode;
  this.loadingvmodel = true;

  this.saveMissingPassengersToAddressBook().then(
    function() {
      this.saveMice(
        function(savedItem, savedData) {
          savedItem = savedItem || {};
          savedData = savedData || {};

          var takipNo =
            savedItem.takipNo ||
            savedItem.TakipNo ||
            savedItem.Takip_No ||
            savedData.takipNo ||
            savedData.TakipNo ||
            savedData.Takip_No ||
            savedData.satisGrubu ||
            savedData.SatisGrubu ||
            (this.selectedReservation
              ? this.selectedReservation.takipNo ||
                this.selectedReservation.TakipNo ||
                this.selectedReservation.Takip_No ||
                this.selectedReservation.satisGrubu ||
                this.selectedReservation.SatisGrubu ||
                this.selectedReservation.displayPnr ||
                this.selectedReservation.pnr
              : "") ||
            "";

          if (!takipNo || takipNo == "0" || takipNo === "-") {
            this.loadingvmodel = false;
            this.simpleInvoiceError(
              "Rezervasyon kaydedildi fakat fatura için Takip No alınamadı."
            );
            return;
          }

          this.simpleInvoicePrepareByTakipNo(takipNo);
        }.bind(this),
        function() {
          this.loadingvmodel = false;
        }.bind(this)
      );
    }.bind(this),
    function(errorText) {
      this.loadingvmodel = false;
      this.simpleInvoiceError(
        errorText || "Yolcular adres defterine kaydedilemedi."
      );
    }.bind(this)
  );
},

simpleInvoicePrepareByTakipNo(takipNo) {
  this.loadingvmodel = true;

  this.simpleInvoiceGetPnrList(takipNo).then(
    function(pnrList) {
      if (!pnrList || pnrList.length === 0) {
        this.loadingvmodel = false;
        this.simpleInvoiceError(
          this.$t
            ? this.$t("No-invoiceable-PNR-found-for-this-tracking-number")
            : "Bu takip no için faturalanacak PNR bulunamadı."
        );
        return;
      }

      this.simpleInvoiceBuildContainerList(pnrList).then(
        function(invoiceList) {
          if (!invoiceList || invoiceList.length === 0) {
            this.loadingvmodel = false;
            this.simpleInvoiceError(
              this.$t
                ? this.$t("Valid-PNR-could-not-be-prepared-for-invoice")
                : "Fatura için geçerli PNR hazırlanamadı."
            );
            return;
          }

          this.simpleInvoiceGetDefaultInvoiceTemplate().then(
            function(templateName) {
              if (!templateName) {
                this.loadingvmodel = false;
                this.simpleInvoiceError(
                  this.$t
                    ? this.$t("Invoice-template-not-found")
                    : "Fatura şablonu bulunamadı."
                );
                return;
              }

              this.simpleInvoiceCreateDraft(invoiceList, templateName).then(
                function(invoiceDraftResult) {
                  var faturaTaslak = null;
                  var taslakIdList = [];

                  // Yeni yapı:
                  // resolve({
                  //   faturaTaslak: response.body.data.IlkFatura,
                  //   taslakIdList: response.body.data.TaslakIdList || []
                  // })
                  if (
                    invoiceDraftResult &&
                    invoiceDraftResult.faturaTaslak
                  ) {
                    faturaTaslak = invoiceDraftResult.faturaTaslak;
                    taslakIdList = invoiceDraftResult.taslakIdList || [];
                  } else {
                    // Eski yapı ile yanlışlıkla IlkFatura direkt dönüyorsa patlamasın.
                    faturaTaslak = invoiceDraftResult;
                    taslakIdList = [];
                  }

                  if (!faturaTaslak) {
                    this.loadingvmodel = false;
                    this.simpleInvoiceError(
                      this.$t
                        ? this.$t("Invoice-draft-could-not-be-created")
                        : "Fatura taslağı oluşturulamadı."
                    );
                    return;
                  }

                  if (
                    (!taslakIdList || taslakIdList.length === 0) &&
                    faturaTaslak.Id
                  ) {
                    taslakIdList = [faturaTaslak.Id];
                  }

                  this.simpleInvoiceDownloadDraftPdf(
                    faturaTaslak,
                    takipNo
                  ).then(
                    function() {
                      this.simpleInvoiceApproveDraft(
                        faturaTaslak,
                        taslakIdList,
                        takipNo
                      );
                    }.bind(this),
                    function(message) {
                      this.loadingvmodel = false;
                      this.simpleInvoiceError(
                        message ||
                          (
                            this.$t
                              ? this.$t("Invoice-PDF-could-not-be-downloaded")
                              : "Invoice PDF indirilemedi."
                          )
                      );
                    }.bind(this)
                  );
                }.bind(this),
                function(message) {
                  this.loadingvmodel = false;
                  this.simpleInvoiceError(
                    message ||
                      (
                        this.$t
                          ? this.$t("Invoice-draft-could-not-be-created")
                          : "Fatura taslağı oluşturulamadı."
                      )
                  );
                }.bind(this)
              );
            }.bind(this),
            function(message) {
              this.loadingvmodel = false;
              this.simpleInvoiceError(
                message ||
                  (
                    this.$t
                      ? this.$t("Invoice-template-not-found")
                      : "Fatura şablonu bulunamadı."
                  )
              );
            }.bind(this)
          );
        }.bind(this),
        function(message) {
          this.loadingvmodel = false;
          this.simpleInvoiceError(
            message ||
              (
                this.$t
                  ? this.$t("Invoice-dates-could-not-be-prepared")
                  : "Fatura tarihleri hazırlanamadı."
              )
          );
        }.bind(this)
      );
    }.bind(this),
    function(message) {
      this.loadingvmodel = false;
      this.simpleInvoiceError(
        message ||
          (
            this.$t
              ? this.$t("Invoice-PNR-list-could-not-be-received")
              : "Faturalanacak PNR listesi alınamadı."
          )
      );
    }.bind(this)
  );
},

simpleInvoiceGetDefaultInvoiceOptions() {
  return {
    FaturaKesimOzellik: {
      Tip: 0,
      FaturaTur: 0,
      FaturaTip: 2,
      KesimTip: 1
    },
    ParaBirimi: getCredentialsCurrency(),
    Kur: 1,
    HerPnrTekFatura: false,
    TevkifatID: {
      id: null,
      intField: null,
      isim: null,
      kod: null,
      tip: null
    }
  };
},

simpleInvoiceGetDefaultInvoiceTemplate() {
  return new Promise(function(resolve, reject) {
    var options = this.simpleInvoiceGetDefaultInvoiceOptions();

    var params = {
      FaturaKesimOzellik: options.FaturaKesimOzellik
    };

    tool.http_post(this, "FaturaSablonList", params).then(
      function(response) {
        if (response.body && response.body.Status === true) {
          var list = response.body.data || [];

          if (list.length > 0) {
            resolve(list[0]);
            return;
          }

          reject("Fatura şablonu bulunamadı.");
          return;
        }

        reject(
          response.body &&
          response.body.ErrorList &&
          response.body.ErrorList.length
            ? response.body.ErrorList[0]
            : "Fatura şablonu bulunamadı."
        );
      }.bind(this),
      function() {
        reject("Service Unavailable - FaturaSablonList");
      }.bind(this)
    );
  }.bind(this));
},

simpleInvoiceCreateDraft(invoiceList, templateName) {
  return new Promise(function(resolve, reject) {
    var options = this.simpleInvoiceGetDefaultInvoiceOptions();

    var pnrlist = (invoiceList || []).map(function(item) {
      return {
        PNR_No: Number(item.PNR_No) || item.PNR_No,
        VadeTarihi: item.VadeTarihi,
        FaturaTarihi: item.FaturaTarihi
      };
    });

    var params = {
      PNR_List: pnrlist,
      FaturaKesimOzellik: options.FaturaKesimOzellik,
      ParaBirimi: options.ParaBirimi,
      Kur: options.Kur,
      Sablon: templateName,
      HerPnrTekFatura: options.HerPnrTekFatura,
      TevkifatID: options.TevkifatID
    };

    tool.http_post(this, "TopluSatisFaturasiHazirla", params).then(
      function(response) {
        if (
          response.body &&
          response.body.Status === true &&
          response.body.data &&
          response.body.data.IlkFatura
        ) {
          resolve({
  faturaTaslak: response.body.data.IlkFatura,
  taslakIdList: response.body.data.TaslakIdList || []
});
          return;
        }

        reject(
          response.body &&
          response.body.ErrorList &&
          response.body.ErrorList.length
            ? response.body.ErrorList[0]
            : "Fatura taslağı oluşturulamadı."
        );
      }.bind(this),
      function(response) {
        this.HataYonetimi
          ? this.HataYonetimi(response, params, "Fatura taslağı oluşturulamadı")
          : null;

        reject("Service Unavailable - TopluSatisFaturasiHazirla");
      }.bind(this)
    );
  }.bind(this));
},

simpleInvoiceDownloadDraftPdf(faturaTaslak, takipNo) {
  return new Promise(function(resolve, reject) {
    var params = {
      FaturaTaslak: faturaTaslak
    };

    tool.api_post_FileDownload(
      this,
      "Coper/CoperSatisFaturasiTaslakPdf",
      params
    ).then(
      response => {
        tool.CreateDownloadLink(
          response,
          this.simpleInvoiceGetDraftPdfFileName(faturaTaslak, takipNo)
        );

        resolve(true);
      },
      response => {
        this.HataYonetimi
          ? this.HataYonetimi(response, params, "Invoice PDF indirilemedi")
          : null;

        reject("Invoice PDF indirilemedi.");
      }
    );
  }.bind(this));
},

simpleInvoiceGetDraftPdfFileName(faturaTaslak, takipNo) {
  var seri = faturaTaslak && faturaTaslak.FaturaSeri ? faturaTaslak.FaturaSeri : "";
  var no = faturaTaslak && faturaTaslak.FaturaNo ? faturaTaslak.FaturaNo : "";

  var fileName = "CoperSalesInvoice";

  if (seri || no) {
    fileName += "_" + seri + "-" + no;
  } else if (takipNo) {
    fileName += "_" + takipNo;
  }

  fileName = fileName.replace(/[\\\/:*?"<>|]/g, "");
  fileName = fileName.replace(/\s+/g, "_");

  return fileName + ".pdf";
},

simpleInvoiceGetPnrList(takipNo) {
  return new Promise(function(resolve, reject) {
    var raporParam = {
      PNR_No: null,
      Cari_Kod: null,

      Kayit_Tarihi1: null,
      Kayit_Tarihi2: null,
      Giris_Tarihi1: null,
      Giris_Tarihi2: null,
      Cikis_Tarihi1: null,
      Cikis_Tarihi2: null,
      SonCikis1: null,
      SonCikis2: null,
      IlkGiris1: null,
      IlkGiris2: null,

      // Mevcut fatura ekranındaki sorgu davranışıyla aynı şekilde PNR'ı getir.
      // Asıl satış tutarı kontrolü TopluSatisFaturasiHazirla tarafında yapılır.
      FaturalamayaHazir: false,

      DosyaTip: null,
      Dosya: null,
      Acente: null,
      dptBolge: null,
      dptYonetim: null,
      dptDepartman: null,
      dptAltDepartman: null,
      dptBolum: null,
      FatGrup: null,
      MasrafMerkezi: null,

      SatisGrubu: Number(takipNo) || takipNo,

      PozisyonNo: null,
      SaticiTip: 0,
      SaticiKod: null,
      KalemMasrafMerkezi: null,
      EFatura: null,
      MasrafYeri: null,
      KarsiRezKod: null,
      SatisGrupTip: null,
      Ic_Dis: null
    };

    var params = {
      Value: raporParam
    };

    tool.http_post(this, "KesilecekSatisFaturasiList", params).then(
      function(response) {
        if (response.body && response.body.Status === true) {
          var data = response.body.data || [];

          // Endpoint başarılı fakat kayıt yoksa hazır olmayan PNR'ı fallback ile
          // zorla faturaya göndermiyoruz. Kullanıcıya doğru hata gösterilir.
          resolve(data);
          return;
        }

        reject(
          response.body &&
          response.body.ErrorList &&
          response.body.ErrorList.length
            ? response.body.ErrorList[0]
            : "Faturalanacak PNR listesi alınamadı."
        );
      }.bind(this),
      function() {
        var fallbackList = this.simpleInvoiceGetFallbackPnrList();

        if (fallbackList.length > 0) {
          resolve(fallbackList);
          return;
        }

        reject("Service Unavailable - KesilecekSatisFaturasiList");
      }.bind(this)
    );
  }.bind(this));
},

simpleInvoiceGetFallbackPnrList() {
  var list = [];

  if (
    this.selectedReservation &&
    this.selectedReservation.childPnrList &&
    this.selectedReservation.childPnrList.length
  ) {
    this.selectedReservation.childPnrList.forEach(function(pnrNo) {
      if (!pnrNo) return;

      list.push({
        PNR_No: Number(pnrNo) || pnrNo
      });
    });
  }

  return list;
},

simpleInvoiceBuildContainerList(pnrList) {
  var chain = Promise.resolve([]);
  var self = this;

  pnrList.forEach(function(item) {
    chain = chain.then(function(list) {
      var pnrNo = self.simpleInvoiceGetPnrNoFromItem(item);

      if (!pnrNo || pnrNo == "0") {
        return list;
      }

      return self.simpleInvoiceGetVadeTarihi(pnrNo).then(function(dateInfo) {
        list.push({
          PNR_No: Number(pnrNo) || pnrNo,
          VadeTarihi: dateInfo.VadeTarihi,
          FaturaTarihi: dateInfo.FaturaTarihi
        });

        return list;
      });
    });
  });

  return chain;
},

simpleInvoiceGetPnrNoFromItem(item) {
  if (!item) return "";

  return (
    item.PNR_No ||
    item.pNR_No ||
    item.PnrNo ||
    item.PNRNO ||
    item.pnrNo ||
    item.pnr ||
    item.Pnr ||
    ""
  );
},

simpleInvoiceGetVadeTarihi(pnrNo) {
  return new Promise(function(resolve) {
    var today = this.simpleInvoiceToday();

    var params = {
      PNR_List: [Number(pnrNo) || pnrNo],
      FaturaTarihi: today
    };

    tool.http_post(this, "VadeTarihiHesapla", params).then(
      function(response) {
        if (
          response.body &&
          response.body.Status === true &&
          response.body.data &&
          response.body.data.length > 0
        ) {
          resolve({
            FaturaTarihi: response.body.data[0].FaturaTarihi || today,
            VadeTarihi: response.body.data[0].VadeTarihi || today
          });
          return;
        }

        resolve({
          FaturaTarihi: today,
          VadeTarihi: today
        });
      }.bind(this),
      function() {
        resolve({
          FaturaTarihi: today,
          VadeTarihi: today
        });
      }.bind(this)
    );
  }.bind(this));
},

simpleInvoiceToday() {
  var d = new Date();
  var month = String(d.getMonth() + 1);
  var day = String(d.getDate());

  if (month.length === 1) month = "0" + month;
  if (day.length === 1) day = "0" + day;

  return d.getFullYear() + "-" + month + "-" + day;
},

simpleInvoiceError(message) {
  this.text1 = message || "Fatura hazırlanamadı.";

  if (this.snackbar !== undefined) {
    this.snackbar = true;
  } else {
    alert(this.text1);
  }
},

    
    getTravelDatesFromLoadedReservation(rezData) {
  var dates = [];

  function addDate(val) {
    if (!val) return;

    var d = val.toString().substring(0, 10);

    if (!d || d === "0001-01-01") return;

    dates.push(d);
  }

  addDate(rezData.donem1);
  addDate(rezData.donem2);
  addDate(rezData.kayitTarihi);

  (rezData.kalemler || []).forEach(function(kalem) {
    addDate(kalem.donem1);
    addDate(kalem.donem2);

    if (kalem.kalemOtel) {
      addDate(kalem.kalemOtel.girisTarihi);
      addDate(kalem.kalemOtel.cikisTarihi);
    }

    if (kalem.kalemRentACar) {
      addDate(kalem.kalemRentACar.alisTarih);
      addDate(kalem.kalemRentACar.teslimTarih);
    }
  });

  dates = dates.sort();

  return {
    from: dates.length ? dates[0] : "",
    to: dates.length ? dates[dates.length - 1] : ""
  };
},
    backendBoardTypeToSimple(value) {
  if (value === null || value === undefined || value === "") return "";

  var v = value.toString();

  var map = {
    "0": "Only Bed",
    "1": "Bed & Breakfast",
    "2": "Half Board",
    "3": "Full Board",
    "4": "All Inclusive",
    "5": "Ultra All Inclusive"
  };

  return map[v] || value;
},
    backendKisiTipToSimple(value) {
  if (value === 1 || value === "1") return "Çocuk";
  if (value === 2 || value === "2") return "Bebek";
  return "Yetişkin";
},
    
  






saveSelectedReservationToBackend() {
  if (this.loadingvmodel) return;

  if (!this.selectedReservation) {
    this.text1 = "Kaydedilecek rezervasyon bulunamadı.";
    this.snackbar = true;
    return;
  }

  this.form.customerCode = this.selectedReservation.customerCode || "";
  this.form.customerName = this.selectedReservation.customer || "";
  this.form.customer = this.selectedReservation.customer || "";
  this.form.travelFrom = this.selectedReservation.travelFrom || "";
  this.form.travelTo = this.selectedReservation.travelTo || "";
  this.form.status = this.selectedReservation.status || "Open";
  this.form.payment = this.selectedReservation.payment || "Unpaid";
  this.form.total = this.reservationGrossTotal || 0;
  this.form.currency = getCredentialsCurrency();

  this.editingPnrCode =
  this.selectedReservation.takipNo && this.selectedReservation.takipNo != "0"
    ? this.selectedReservation.takipNo
    : null;

  this.isEditMode = !!this.editingPnrCode;

  this.loadingvmodel = true;

  this.saveMissingPassengersToAddressBook().then(
    function() {
      this.saveMice(
        null,
        function() {
          this.loadingvmodel = false;
        }.bind(this)
      );
    }.bind(this),
    function(errorText) {
      this.loadingvmodel = false;
      this.text1 = errorText || "Yolcular adres defterine kaydedilemedi.";
      this.snackbar = true;
    }.bind(this)
  );
},

    

    

    getServicePassengersSnapshot() {
      if (!this.selectedReservation || !this.selectedReservation.passengers) {
        return [];
      }

      return this.selectedReservation.passengers.map(function(p) {
        return {
          kisiTipi: p.kisiTipi || "",
          firstName: p.firstName || "",
          lastName: p.lastName || "",
          birthDate: p.birthDate || "",
          idNumber: p.idNumber || "",
          gender: p.gender || "",
          phone: p.phone || "",
          nationality: p.nationality || "",
          email: p.email || "",
          passportNumber: p.passportNumber || "",
          address: p.address || ""
        };
      });
    },


    displayBirthDateWithAge(date) {
      if (!date) return "-";

      var formattedDate = this.displayDateLong
        ? this.displayDateLong(date)
        : this.displayDate(date);

      var age = this.calculateAge(date);

      return age !== null ? formattedDate + " (" + age + ")" : formattedDate;
    },

    calculateAge(date) {
      if (!date) return null;

      var birth = new Date(date);
      if (isNaN(birth.getTime())) return null;

      var today = new Date();
      var age = today.getFullYear() - birth.getFullYear();

      var monthDiff = today.getMonth() - birth.getMonth();
      var dayDiff = today.getDate() - birth.getDate();

      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
      }

      return age;
    },

    getCurrentInfo(val) {
  if (!val) return;

  var customerCode =
    val.Code ||
    val.code ||
    val.Kod ||
    val.kod ||
    val.CariKod ||
    val.cariKod ||
    val.HesapKodu ||
    val.hesapKodu ||
    "";

  customerCode = customerCode ? customerCode.toString().trim() : "";

  var customerName =
    val.Title ||
    val.title ||
    val.Unvan ||
    val.unvan ||
    val.Isim ||
    val.isim ||
    val.CariUnvan ||
    val.cariUnvan ||
    "";

  customerName = customerName ? customerName.toString().trim() : "";

  if (!customerCode) return;

  this.form.customerCode = customerCode;
  this.form.customerName = customerName;
  this.form.customer = customerName;
},


  duplicateReservation(item) {
  if (!item) {
    alert("Kopyalanacak kayıt bulunamadı.");
    return;
  }

  if (item.isClosed) {
    alert("Kapalı PNR kopyalanamaz.");
    return;
  }

  var takipNo =
    item.takipNo ||
    item.TakipNo ||
    item.Takip_No ||
    item.takip_No ||
    "";

  if (!takipNo || takipNo == "0") {
    alert("Kopyalanacak kayıt için Takip No bulunamadı.");
    return;
  }

  this.loadingvmodel = true;

  var activeCurrency = getCredentialsCurrency();

  if (!activeCurrency) {
    this.loadingvmodel = false;
    this.text1 = "Kullanıcı para birimi bulunamadı.";
    this.snackbar = true;
    return;
  }

  var params = {
    TakipNo: Number(takipNo) || takipNo,
    hedefParaBirimi: activeCurrency
  };

  tool.http_post(this, "MiceLoad", params).then(
    function(response) {
      if (response.body.Status === true) {
        var loadedItem = this.mapLoadedMiceToSimple(response.body.data, item);
        var copyItem = this.prepareFullPnrCopy(loadedItem);

        copyItem.isCopiedMice = true;
        copyItem.copySourceTakipNo = takipNo ? takipNo.toString() : "";
        copyItem.copySourcePnr = item.pnr || item.sourcePnr || "";

        this.isEditMode = false;
        this.editingPnrCode = null;

        this.reservations.push(copyItem);
        this.selectedReservationIndex = this.reservations.length - 1;
        this.detailMode = true;

        if (this.openAllServiceSections) {
          this.openAllServiceSections();
        }

        // Full PNR kopyalama: temp satır bekletmeden direkt backend'e kaydet.
        this.saveCopiedReservationImmediately(item.pnr || takipNo);
      } else {
        this.loadingvmodel = false;

        this.text1 =
          response.body.ErrorList && response.body.ErrorList.length
            ? response.body.ErrorList[0]
            : "PNR kopyalanamadı.";
        this.snackbar = true;
      }
    }.bind(this),
    function() {
      this.loadingvmodel = false;
      this.text1 = "Service Unavailable - PNR kopyalanamadı.";
      this.snackbar = true;
    }.bind(this)
  );
},

saveCopiedReservationImmediately(sourcePnr) {
  if (!this.selectedReservation) {
    this.loadingvmodel = false;
    return;
  }

  var tempIndex = this.selectedReservationIndex;
  var copiedItem = this.selectedReservation;

  this.form.customerCode = copiedItem.customerCode || "";
  this.form.customerName = copiedItem.customer || "";
  this.form.customer = copiedItem.customer || "";
  this.form.travelFrom = copiedItem.travelFrom || "";
  this.form.travelTo = copiedItem.travelTo || "";
  this.form.status = copiedItem.status || "Open";
  this.form.payment = copiedItem.payment || "Unpaid";
  this.form.total = copiedItem.total || this.reservationGrossTotal || 0;
  this.form.currency = getCredentialsCurrency();

  // Kopya kayıtta eski takip no kesinlikle edit gibi gitmeyecek.
  this.editingPnrCode = null;
  this.isEditMode = false;

  // buildMiceReservationPayload içinde isCopiedMice true olduğu için takipNo: 0 gidecek.
  this.saveMice(
    function(savedItem, data) {
      savedItem = savedItem || {};

      if (savedItem.sourcePnr && !savedItem.pnr) {
        savedItem.pnr = savedItem.sourcePnr;
      }

      if (
        savedItem.childPnrList &&
        savedItem.childPnrList.length &&
        (!savedItem.pnr || savedItem.pnr === savedItem.takipNo)
      ) {
        savedItem.pnr = savedItem.childPnrList[0];
      }

      var savedKey =
        savedItem.pnr ||
        savedItem.sourcePnr ||
        savedItem.takipNo ||
        "";

      var savedIndex = savedKey ? this.findReservationIndex(savedKey) : -1;

      if (savedIndex > -1) {
        this.selectedReservationIndex = savedIndex;
      }

      this.detailMode = true;

      if (this.openAllServiceSections) {
        this.openAllServiceSections();
      }

      this.text1 =
        sourcePnr +
        " PNR kopyalandı ve yeni MICE kaydı oluşturuldu.";
      this.snackbar = true;
    }.bind(this),
    function(errorBody) {
      if (
        tempIndex > -1 &&
        this.reservations[tempIndex] &&
        this.reservations[tempIndex].isCopiedMice === true &&
        !this.reservations[tempIndex].takipNo &&
        !this.reservations[tempIndex].pnr
      ) {
        this.reservations.splice(tempIndex, 1);
      }

      this.selectedReservationIndex = -1;
      this.detailMode = false;
      this.getReservationList();
    }.bind(this)
  );
},

getServiceCollectionNames() {
  return [
    "flights",
    "hotels",
    "cars",
    "transfers",
    "dailyTours",
    "cruises",
    "others"
  ];
},

duplicateServiceItem(collectionName, index) {
  if (!this.selectedReservation) {
    alert("Rezervasyon bulunamadı.");
    return;
  }

  var list = this.selectedReservation[collectionName];

  if (!list || !list[index]) {
    alert("Kopyalanacak kalem bulunamadı.");
    return;
  }

  var sourceItem = list[index];
  var mainPassengers = this.selectedReservation.passengers || [];
  var servicePassengers = sourceItem.passengers || [];

  var copy = JSON.parse(JSON.stringify(sourceItem));

  copy = this.cleanCopiedServiceItem(copy);

  
  copy.passengers = this.mapCopiedServicePassengers(
    servicePassengers,
    mainPassengers,
    mainPassengers
  );

  copy._isCopiedServiceItem = true;

  list.push(copy);
  this.$set(this.selectedReservation, collectionName, list);

  this.recalculateReservationTotal();

  this.text1 = "Kalem kopyalandı. Save Reservation ile yeni child PNR oluşacak.";
  this.snackbar = true;
},

cleanCopiedServiceItem(item) {
  if (!item) return item;

  // Genel id/ref alanları
  delete item.id;
  delete item.ID;
  delete item.ref;
  delete item.Ref;

  // Child PNR alanları
  delete item.pnr;
  delete item.PNR;
  delete item.PNR_No;
  delete item.pNR_No;
  delete item.PnrNo;
  delete item.pnrNo;
  delete item.PNRNO;
  delete item.sourcePnr;
  delete item.childPnrList;

  // Takip no alanları
  delete item.takipNo;
  delete item.TakipNo;
  delete item.Takip_No;
  delete item.takip_No;

  // Update identity alanları
  delete item.islemRef;
  delete item.IslemRef;
  delete item.islemREF;
  delete item.guid;
  delete item.Guid;
  delete item.KaynakIslemRef;
  delete item.kaynakIslemRef;

  // Fatura / ödeme gibi eski kayda ait alanlar kopyaya taşınmasın
  delete item.FaturaBilgileri;
  delete item.faturaBilgileri;
  delete item.faturaNo;
  delete item.FaturaNo;
  delete item.invoiceNo;
  delete item.InvoiceNo;

  // Güvenli defaultlar
  item.pnr = "";
  item.PNR_No = 0;
  item.pNR_No = 0;
  item.pnrNo = "";
  item.guid = "";
  item.Guid = "";
  item.islemRef = 0;
  item.IslemRef = 0;
  item.KaynakIslemRef = 0;
  item.kaynakIslemRef = 0;

  return item;
},

prepareFullPnrCopy(source) {
  var copy = JSON.parse(JSON.stringify(source || {}));
  var serviceNames = this.getServiceCollectionNames();

  copy.guid = "";
  copy.Guid = "";

  // Yeni MICE kaydı oluşacak, eski takip no kesinlikle gitmemeli.
  copy.pnr = "";
  copy.takipNo = "";
  copy.sourcePnr = "";
  copy.childPnrList = [];

  copy.isCopiedMice = true;
  copy.copySourceTakipNo = source && source.takipNo ? source.takipNo : "";
  copy.copySourcePnr = source && source.pnr ? source.pnr : "";

  copy.status = "Open";
  copy.isClosed = false;
  copy.payment = "Unpaid";

  var sourcePassengers = source && source.passengers ? source.passengers : [];

  // Full PNR kopyasında yolcu bilgileri boş gelecek.
  copy.passengers = this.createBlankPassengersFromSource(sourcePassengers);

  serviceNames.forEach(function(collectionName) {
    copy[collectionName] = (copy[collectionName] || []).map(function(serviceItem) {
      var copiedService = JSON.parse(JSON.stringify(serviceItem || {}));

      copiedService = this.cleanCopiedServiceItem(copiedService);

      copiedService.passengers = this.mapCopiedServicePassengers(
        serviceItem.passengers || [],
        sourcePassengers,
        copy.passengers
      );

      copiedService._isCopiedServiceItem = true;

      return copiedService;
    }.bind(this));
  }.bind(this));

  return copy;
},

createBlankPassengersFromSource(passengers) {
  return (passengers || []).map(function(passenger, index) {
    return {
      _copyPassengerIndex: index,

      kisiTipi: passenger.kisiTipi || "Yetişkin",

      firstName: "",
      lastName: "",
      birthDate: null,
      phone: "",
      email: "",
      idNumber: "",

      gender: passenger.gender || "",
      cinsiyet: passenger.cinsiyet || "",

      address: "",
      passportNumber: "",
      nationality: passenger.nationality || ""
    };
  });
},

mapCopiedServicePassengers(servicePassengers, sourcePassengers, blankPassengers) {
  var result = [];

  if (!blankPassengers || !blankPassengers.length) {
    return result;
  }

  if (!servicePassengers || !servicePassengers.length) {
    return blankPassengers.slice(0);
  }

  servicePassengers.forEach(function(servicePassenger) {
    var index = this.findPassengerIndexForCopy(servicePassenger, sourcePassengers);

    if (index > -1 && blankPassengers[index] && result.indexOf(blankPassengers[index]) === -1) {
      result.push(blankPassengers[index]);
    }
  }.bind(this));

  return result.length ? result : blankPassengers.slice(0);
},

findPassengerIndexForCopy(passenger, sourcePassengers) {
  if (!passenger || !sourcePassengers) return -1;

  if (
    passenger._copyPassengerIndex !== undefined &&
    passenger._copyPassengerIndex !== null &&
    sourcePassengers[passenger._copyPassengerIndex]
  ) {
    return passenger._copyPassengerIndex;
  }

  for (var i = 0; i < sourcePassengers.length; i++) {
    var source = sourcePassengers[i];

    var sameId =
      passenger.idNumber &&
      source.idNumber &&
      passenger.idNumber === source.idNumber;

    var samePassport =
      passenger.passportNumber &&
      source.passportNumber &&
      passenger.passportNumber === source.passportNumber;

    var sameName =
      ((passenger.firstName || "").trim().toLowerCase() ===
        (source.firstName || "").trim().toLowerCase()) &&
      ((passenger.lastName || "").trim().toLowerCase() ===
        (source.lastName || "").trim().toLowerCase()) &&
      ((passenger.birthDate || "") === (source.birthDate || ""));

    if (sameId || samePassport || sameName) {
      return i;
    }
  }

  return -1;
},


getServicePassengerIndexes(servicePassengers) {
  var mainPassengers =
    this.selectedReservation && this.selectedReservation.passengers
      ? this.selectedReservation.passengers
      : [];

  var list =
    servicePassengers && servicePassengers.length
      ? servicePassengers
      : mainPassengers;

  var result = [];

  list.forEach(function(passenger, fallbackIndex) {
    var foundIndex = -1;

    if (
      passenger &&
      passenger._copyPassengerIndex !== undefined &&
      passenger._copyPassengerIndex !== null &&
      mainPassengers[passenger._copyPassengerIndex]
    ) {
      foundIndex = passenger._copyPassengerIndex;
    }

    if (foundIndex === -1) {
      foundIndex = mainPassengers.indexOf(passenger);
    }

    if (foundIndex === -1) {
      foundIndex = mainPassengers.findIndex(function(mainPassenger) {
        var sameId =
          passenger.idNumber &&
          mainPassenger.idNumber &&
          passenger.idNumber === mainPassenger.idNumber;

        var samePassport =
          passenger.passportNumber &&
          mainPassenger.passportNumber &&
          passenger.passportNumber === mainPassenger.passportNumber;

        var sameName =
          ((passenger.firstName || "").trim().toLowerCase() ===
            (mainPassenger.firstName || "").trim().toLowerCase()) &&
          ((passenger.lastName || "").trim().toLowerCase() ===
            (mainPassenger.lastName || "").trim().toLowerCase()) &&
          ((passenger.birthDate || "") === (mainPassenger.birthDate || ""));

        return sameId || samePassport || sameName;
      });
    }

    if (foundIndex === -1 && list === mainPassengers) {
      foundIndex = fallbackIndex;
    }

    if (foundIndex > -1 && result.indexOf(foundIndex) === -1) {
      result.push(foundIndex);
    }
  });

  return result;
},

    

    editSelectedPnr() {
  if (!this.selectedReservation) return;

  this.isEditMode = true;

  this.editingPnrCode =
    this.selectedReservation.takipNo ||
    this.selectedReservation.TakipNo ||
    this.selectedReservation.pnr ||
    null;

  this.form = Object.assign(
    {},
    this.getEmptyReservationForm(),
    {
      pnr: this.selectedReservation.pnr || "",
      customerCode: this.selectedReservation.customerCode || "",
      customerName: this.selectedReservation.customer || "",
      customer: this.selectedReservation.customer || "",
      travelFrom: this.selectedReservation.travelFrom || "",
      travelTo: this.selectedReservation.travelTo || "",
      status: this.selectedReservation.status || "Open",
      payment: this.selectedReservation.payment || "Unpaid",
      total: Number(this.selectedReservation.total) || 0,
      currency: getCredentialsCurrency()
    }
  );

  this.dialog = true;
},


getSelectedVoucherLanguage() {
  var locale = "";

  if (this.$i18n && this.$i18n.locale) {
    locale = this.$i18n.locale;
  }

  if (!locale) {
    try {
      locale = window.localStorage.getItem("lang") || "";
    } catch (error) {
      locale = "";
    }
  }

  locale = locale
    ? locale.toString().trim().toLowerCase().split(/[-_]/)[0]
    : "";

  var supportedLanguages = (this.serviceVoucherLangItems || []).map(
    function(item) {
      return item.value;
    }
  );

  return supportedLanguages.indexOf(locale) > -1 ? locale : "tr";
},

openServiceVoucherDialog(section) {
  if (!this.selectedReservation) {
    this.text1 = "Rezervasyon bilgisi bulunamadı.";
    this.snackbar = true;
    return;
  }

  if (
    !this.selectedReservation[section] ||
    !this.selectedReservation[section].length
  ) {
    this.text1 = "Bu kalem grubunda kayıt bulunamadı.";
    this.snackbar = true;
    return;
  }

  var realPnrNo = this.getRealPnrForServiceVoucher(section);

  if (!realPnrNo) {
    this.text1 = "Voucher PDF için gerçek PNR bulunamadı.";
    this.snackbar = true;
    return;
  }

  var endpointBase = this.getServiceVoucherEndpoint(section);

  if (!endpointBase) {
    this.text1 = "Voucher endpoint bulunamadı.";
    this.snackbar = true;
    return;
  }

  this.serviceVoucherSection = section;
  this.serviceVoucherShowPrice = true;
  this.serviceVoucherLang = this.getSelectedVoucherLanguage();

  this.serviceVoucherDialog = true;
},
downloadServiceVoucher() {
  if (!this.selectedReservation) {
    this.text1 = "Rezervasyon bilgisi bulunamadı.";
    this.snackbar = true;
    return;
  }

  var section = this.serviceVoucherSection;
  var realPnrNo = this.getRealPnrForServiceVoucher(section);
  var displayPnrNo = this.getDisplayPnrNoForUser();

  if (!realPnrNo) {
    this.text1 = "Voucher PDF için gerçek PNR bulunamadı.";
    this.snackbar = true;
    return;
  }

  var lang = this.serviceVoucherLang || this.getSelectedVoucherLanguage();
  var endpointBase = this.getServiceVoucherEndpoint(section);

  if (!endpointBase) {
    this.text1 = "Voucher endpoint bulunamadı.";
    this.snackbar = true;
    return;
  }

  this.serviceVoucherDialog = false;

  if (section === "flights") {
    this.flightVoucherLoading = true;
  } else {
    this.serviceVoucherLoading = true;
  }

  var endpoint =
    endpointBase +
    "?pnrNo=" + encodeURIComponent(realPnrNo) +
    "&lang=" + encodeURIComponent(lang) +
    "&showPrice=" + encodeURIComponent(this.serviceVoucherShowPrice ? "true" : "false");

  tool.api_post_FileDownload(this, endpoint, {}).then(
    response => {
      tool.CreateDownloadLink(
        response,
        "Voucher_" + displayPnrNo + "_" + section + ".pdf"
      );

      this.flightVoucherLoading = false;
      this.serviceVoucherLoading = false;
      this.serviceVoucherSection = null;
    },
    () => {
      this.flightVoucherLoading = false;
      this.serviceVoucherLoading = false;
      this.serviceVoucherSection = null;
      this.text1 = "Voucher PDF indirilemedi.";
      this.snackbar = true;
    }
  );
},




mapLoadedReservationToSimple(rezData) {
  var passengers = (rezData.adresler || []).map(function(adres) {
    return this.mapAdresToPassenger(adres);
  }.bind(this));

  var travelDates = this.getTravelDatesFromLoadedReservation(rezData);

  var pnrNo =
    rezData.pNR_No ||
    rezData.PNR_No ||
    rezData.pnrNo ||
    rezData.PnrNo ||
    rezData.PNRNO ||
    rezData.Pnr ||
    rezData.pnr ||
    rezData.PNR ||
    "";

  var pnrKey = pnrNo ? pnrNo.toString() : "";

  var deletedValue =
    rezData.Deleted !== undefined ? rezData.Deleted :
    rezData.deleted !== undefined ? rezData.deleted :
    rezData.IsDeleted !== undefined ? rezData.IsDeleted :
    rezData.isDeleted !== undefined ? rezData.isDeleted :
    false;

  var isBackendClosed =
    deletedValue === true ||
    deletedValue === 1 ||
    deletedValue === "1" ||
    deletedValue === "true" ||
    deletedValue === "True" ||
    deletedValue === "TRUE";

  var isLocallyClosed =
    this.closedPnrMap &&
    pnrKey &&
    this.closedPnrMap[pnrKey] === true;

  var isClosed = isBackendClosed || isLocallyClosed;

  var simpleItem = {
    guid: rezData.Guid || rezData.guid || "",
    pnr: pnrKey,
    customer: rezData.cariKod ? rezData.cariKod.isim : "",
    customerCode: rezData.cariKod ? rezData.cariKod.kod : "",

    travelFrom: travelDates.from,
    travelTo: travelDates.to,
    travelDate: this.formatTravelDate(travelDates.from, travelDates.to),

    status: isClosed ? "Closed" : "Open",
    payment: "Unpaid",
    total: rezData.toplamTL ? Number(rezData.toplamTL.netSatis) || 0 : 0,
    currency: getCredentialsCurrency(),
    isClosed: isClosed,

    passengers: passengers,
    flights: [],
    hotels: [],
    cars: [],
    transfers: [],
    dailyTours: [],
    cruises: [],
    others: []
  };

  (rezData.kalemler || []).forEach(function(kalem) {
    var mapped = this.mapLoadedKalemToService(kalem, passengers);
if (!mapped) return;

this.normalizeServiceMoneyFields(mapped);
      

    if (kalem.saticiTip == 8) simpleItem.flights.push(mapped);
    else if (kalem.saticiTip == 1) simpleItem.hotels.push(mapped);
    else if (kalem.saticiTip == 5) simpleItem.cars.push(mapped);
    else if (kalem.saticiTip == 2) simpleItem.transfers.push(mapped);
    else if (kalem.saticiTip == 4) simpleItem.dailyTours.push(mapped);
    else if (kalem.saticiTip == 9) simpleItem.cruises.push(mapped);
    else if (kalem.saticiTip == 10) simpleItem.others.push(mapped);
  }.bind(this));

  return simpleItem;
},



   

//genel voucher indirme
 openGeneralVoucherDialog() {
  if (!this.selectedReservation) {
    this.text1 = "Rezervasyon bilgisi bulunamadı.";
    this.snackbar = true;
    return;
  }

  var realPnrList = this.getRealPnrListForGeneralVoucher();

  if (!realPnrList || realPnrList.length === 0) {
    this.text1 = "General Voucher için gerçek PNR listesi bulunamadı.";
    this.snackbar = true;
    return;
  }

  this.generalVoucherLang = this.getSelectedVoucherLanguage();
  this.generalVoucherShowPrice = true;
  this.generalVoucherDialog = true;
},

downloadGeneralVoucher() {
  if (!this.selectedReservation) {
    this.text1 = "Rezervasyon bilgisi bulunamadı.";
    this.snackbar = true;
    return;
  }

  var realPnrList = this.getRealPnrListForGeneralVoucher();

  if (!realPnrList || realPnrList.length === 0) {
    this.text1 = "General voucher PDF için gerçek PNR listesi bulunamadı.";
    this.snackbar = true;
    return;
  }

  var displayPnrNo = this.getDisplayPnrNoForUser();
  var lang = this.generalVoucherLang || this.getSelectedVoucherLanguage();

  this.generalVoucherDialog = false;
  this.generalVoucherLoading = true;

  var params = {
    PnrList: realPnrList.map(function(x) {
      return Number(x) || x;
    }),
    Lang: lang,
    ShowPrice: this.generalVoucherShowPrice ? true : false,
    DisplayPnrNo: displayPnrNo
  };

  console.log("General Voucher PDF Request", params);

  tool.api_post_FileDownload(
    this,
    "Coper/SimpleGeneralVoucherPdfDownloadByPnrList",
    params
  ).then(
    response => {
      tool.CreateDownloadLink(
        response,
        "SimpleGeneralVoucher_" + displayPnrNo + ".pdf"
      );

      this.generalVoucherLoading = false;
    },
    response => {
      this.generalVoucherLoading = false;

      console.log("General Voucher PDF Error", response);

      this.text1 = "General voucher PDF indirilemedi.";
      this.snackbar = true;
    }
  );
},
    
    

//Yolcu tipini backend değerini değiştirmeden seçili dile göre gösterir.
getPassengerTypeText(value) {
  if (
    value === null ||
    value === undefined ||
    value.toString().trim() === ""
  ) {
    return "-";
  }

  var normalizedValue = value
    .toString()
    .trim()
    .toLowerCase();

  if (
    normalizedValue === "0" ||
    normalizedValue === "yetişkin" ||
    normalizedValue === "yetiskin" ||
    normalizedValue === "adult"
  ) {
    return this.$t("Adult");
  }

  if (
    normalizedValue === "1" ||
    normalizedValue === "çocuk" ||
    normalizedValue === "cocuk" ||
    normalizedValue === "child"
  ) {
    return this.$t("Child");
  }

  if (
    normalizedValue === "2" ||
    normalizedValue === "bebek" ||
    normalizedValue === "baby" ||
    normalizedValue === "infant"
  ) {
    return this.$t("Baby");
  }

  return value;
},

simpleKisiTipToBackend(value) {
  if (value === 0 || value === "0") return 0;
  if (value === 1 || value === "1") return 1;
  if (value === 2 || value === "2") return 2;

  var v = (value || "").toString().toLowerCase();

  if (v.indexOf("çocuk") > -1 || v.indexOf("cocuk") > -1 || v.indexOf("child") > -1) return 1;
  if (v.indexOf("bebek") > -1 || v.indexOf("infant") > -1 || v.indexOf("baby") > -1) return 2;

  return 0;
},

simpleGenderToBackend(value) {
  var v = (value || "").toString().toLowerCase();

  if (v === "e" || v === "erkek" || v === "male" || v === "m") return "E";
  if (v === "k" || v === "kadın" || v === "kadin" || v === "female" || v === "f") return "K";

  return value || "";
},

//pnr kaydetme metodu 
    savePnr(afterSuccess, afterError) {
  if (!this.form.customerCode) {
    alert("Customer zorunludur.");

    if (typeof afterError === "function") {
      afterError();
    }

    return;
  }

  if (!this.form.travelFrom || !this.form.travelTo) {
    alert("Travel From and Travel To zorunludur.");

    if (typeof afterError === "function") {
      afterError();
    }

    return;
  }

  var travelFrom = this.normalizeDateValue(this.form.travelFrom);
  var travelTo = this.normalizeDateValue(this.form.travelTo);

  if (!travelFrom || !travelTo) {
    alert("Seyahat tarihleri zorunludur ve dd.mm.yyyy formatında olmalıdır.");

    if (typeof afterError === "function") {
      afterError();
    }

    return;
  }

  if (travelFrom > travelTo) {
    alert("Travel From tarihi Travel To tarihinden büyük olamaz.");

    if (typeof afterError === "function") {
      afterError();
    }

    return;
  }

  this.form.travelFrom = travelFrom;
  this.form.travelTo = travelTo;

  this.loadingvmodel = true;

  var rezervasyon = rez.Rezervasyon();

  rezervasyon.cariKod.kod = this.form.customerCode || "";
  rezervasyon.cariKod.isim = this.form.customerName || this.form.customer || "";
  rezervasyon.kayitTarihi = new Date();
  rezervasyon.Status = this.form.status || "Open";

  // Flight ekranındaki opsiyon bilgileri rezervasyon ana modelinde tutulur.
  var reservationFlight =
    this.selectedReservation &&
    this.selectedReservation.flights &&
    this.selectedReservation.flights.length
      ? this.selectedReservation.flights[0]
      : null;

  rezervasyon.opsiyonluMusteri =
    reservationFlight && reservationFlight.opsiyonluMusteri === true;

  rezervasyon.opsiyonTarihi = rezervasyon.opsiyonluMusteri
    ? reservationFlight.opsiyonTarihi || null
    : null;

  rezervasyon.opsiyonSaati = rezervasyon.opsiyonluMusteri
    ? this.simpleTimeToBackend(reservationFlight.opsiyonSaati)
    : "0001-01-01T00:00:00";

  rezervasyon.donem1 = this.form.travelFrom;
  rezervasyon.donem2 = this.form.travelTo;

  var mevcutPassengers = [];

  if (this.selectedReservation && this.selectedReservation.passengers) {
    mevcutPassengers = this.selectedReservation.passengers;
  }

  rezervasyon.adresler = mevcutPassengers.map(
    function(passenger, index) {
      return this.mapPassengerToAdres(passenger, index);
    }.bind(this)
  );

  rezervasyon.kalemler = [];

  if (this.selectedReservation && this.selectedReservation.flights) {
    rezervasyon.kalemler = rezervasyon.kalemler.concat(
      this.selectedReservation.flights.map(
        function(flight, index) {
          return this.mapFlightToKalem(flight, index);
        }.bind(this)
      )
    );
  }

  if (this.selectedReservation && this.selectedReservation.hotels) {
    rezervasyon.kalemler = rezervasyon.kalemler.concat(
      this.selectedReservation.hotels.map(
        function(hotel, index) {
          return this.mapHotelToKalem(hotel, index);
        }.bind(this)
      )
    );
  }

  if (this.selectedReservation && this.selectedReservation.cars) {
    rezervasyon.kalemler = rezervasyon.kalemler.concat(
      this.selectedReservation.cars.map(
        function(car, index) {
          return this.mapCarToKalem(car, index);
        }.bind(this)
      )
    );
  }

  if (this.selectedReservation && this.selectedReservation.transfers) {
    rezervasyon.kalemler = rezervasyon.kalemler.concat(
      this.selectedReservation.transfers.map(
        function(transfer, index) {
          return this.mapTransferToKalem(transfer, index);
        }.bind(this)
      )
    );
  }

  if (this.selectedReservation && this.selectedReservation.dailyTours) {
    rezervasyon.kalemler = rezervasyon.kalemler.concat(
      this.selectedReservation.dailyTours.map(
        function(tour, index) {
          return this.mapDailyTourToKalem(tour, index);
        }.bind(this)
      )
    );
  }

  if (this.selectedReservation && this.selectedReservation.cruises) {
    rezervasyon.kalemler = rezervasyon.kalemler.concat(
      this.selectedReservation.cruises.map(
        function(cruise, index) {
          return this.mapCruiseToKalem(cruise, index);
        }.bind(this)
      )
    );
  }

  if (this.selectedReservation && this.selectedReservation.others) {
    rezervasyon.kalemler = rezervasyon.kalemler.concat(
      this.selectedReservation.others.map(
        function(other, index) {
          return this.mapOtherToKalem(other, index);
        }.bind(this)
      )
    );
  }

  if (this.isEditMode && this.editingPnrCode) {
    rezervasyon.pNR_No = Number(this.editingPnrCode) || 0;

    var currentSelected = this.selectedReservation || {};

    rezervasyon.Guid =
      currentSelected.Guid ||
      currentSelected.guid ||
      null;
  }

  var params = {
    Rezervasyon: rezervasyon
  };

  tool.http_post(this, "RezervasyonKaydet", params).then(
    response => {
      this.loadingvmodel = false;

      if (response.body.Status === true) {
        var data = response.body.data || {};
        var oldItem = this.selectedReservation || {};

        var savedPnr =
          data.pNR_No ||
          data.PNR_No ||
          data.pnrNo ||
          data.PnrNo ||
          data.pnr ||
          "";

        savedPnr = savedPnr ? String(savedPnr) : "";

        var calculatedTotal = 0;

        if (this.selectedReservation) {
          calculatedTotal = Number(this.reservationGrossTotal) || 0;
        }

        var simpleItem = {
          guid: data.Guid || data.guid || "",
          Guid: data.Guid || data.guid || "",

          pnr: savedPnr,

          customer: data.cariKod
            ? data.cariKod.isim
            : this.form.customerName || this.form.customer || "",

          customerCode: data.cariKod
            ? data.cariKod.kod
            : this.form.customerCode || "",

          travelFrom: this.form.travelFrom,
          travelTo: this.form.travelTo,
          travelDate: this.formatTravelDate(this.form.travelFrom, this.form.travelTo),

          status: this.form.status || "Open",
          payment: this.form.payment || "Unpaid",

          total: Number(this.form.total) || calculatedTotal || 0,
          currency: getCredentialsCurrency(),

          isClosed: false,

          flights: oldItem.flights || [],
          hotels: oldItem.hotels || [],
          cars: oldItem.cars || [],
          transfers: oldItem.transfers || [],
          dailyTours: oldItem.dailyTours || [],
          cruises: oldItem.cruises || [],
          others: oldItem.others || [],
          passengers: oldItem.passengers || []
        };

        var currentIndex = -1;

        if (this.selectedReservationIndex > -1) {
          currentIndex = this.selectedReservationIndex;
        } else if (oldItem && oldItem.pnr) {
          currentIndex = this.findReservationIndex(oldItem.pnr);
        } else if (this.editingPnrCode) {
          currentIndex = this.findReservationIndex(this.editingPnrCode);
        }

        if (currentIndex > -1) {
          this.$set(this.reservations, currentIndex, simpleItem);
          this.selectedReservationIndex = currentIndex;
        } else {
          this.reservations.push(simpleItem);
          this.selectedReservationIndex = this.reservations.length - 1;
        }

        this.editingPnrCode = simpleItem.pnr;
        this.isEditMode = true;

        if (typeof afterSuccess === "function") {
          afterSuccess(simpleItem, data);
        }

        this.closeDialog();
      } else {
        alert(
          response.body.ErrorList && response.body.ErrorList.length
            ? response.body.ErrorList[0]
            : "Rezervasyon kaydedilemedi."
        );

        if (typeof afterError === "function") {
          afterError(response.body);
        }
      }
    },
    response => {
      this.loadingvmodel = false;
      alert("Service Unavailable - Rezervasyon Kaydedilemedi");

      if (typeof afterError === "function") {
        afterError(response);
      }
    }
  );
},

saveMice(afterSuccess, afterError) {
  if (!this.form.customerCode) {
    alert("Customer zorunludur.");

    if (typeof afterError === "function") {
      afterError();
    }

    return;
  }

  if (!this.form.travelFrom || !this.form.travelTo) {
    alert("Travel From and Travel To zorunludur.");

    if (typeof afterError === "function") {
      afterError();
    }

    return;
  }

  var travelFrom = this.normalizeDateValue(this.form.travelFrom);
  var travelTo = this.normalizeDateValue(this.form.travelTo);

  if (!travelFrom || !travelTo) {
    alert("Seyahat tarihleri zorunludur ve dd.mm.yyyy formatında olmalıdır.");

    if (typeof afterError === "function") {
      afterError();
    }

    return;
  }

  if (travelFrom > travelTo) {
    alert("Travel From tarihi Travel To tarihinden büyük olamaz.");

    if (typeof afterError === "function") {
      afterError();
    }

    return;
  }

  this.form.travelFrom = travelFrom;
  this.form.travelTo = travelTo;

  this.loadingvmodel = true;

  var rezervasyonMice = this.buildMiceReservationPayload();

  if (!rezervasyonMice.kalemler || rezervasyonMice.kalemler.length === 0) {
    this.loadingvmodel = false;
    alert("En az bir kalem eklemelisiniz.");

    if (typeof afterError === "function") {
      afterError();
    }

    return;
  }

  var activeCurrency = getCredentialsCurrency();

  if (!activeCurrency) {
    this.loadingvmodel = false;
    this.text1 = "Kullanıcı para birimi bulunamadı.";
    this.snackbar = true;

    if (typeof afterError === "function") {
      afterError();
    }

    return;
  }

  var params = {
    Rezervasyon: rezervasyonMice,
    hedefParaBirimi: activeCurrency
  };
  
  

// DEBUG - TESTTEN SONRA SİL
window.__miceSaveParams = JSON.parse(JSON.stringify(params));

window.__miceSaveOzet = window.__miceSaveParams.Rezervasyon.kalemler.map(function(k, i) {
  return {
    index: i,
    saticiTip: k.saticiTip,

    flightKontenjan: k.kalemCharter && k.kalemCharter.Kontenjan,
    flightCharterKod: k.kalemCharter && k.kalemCharter.CharterKod,
    flightBookingType: k.kalemCharter && k.kalemCharter.BookingType,
    flightClassType: k.kalemCharter && k.kalemCharter.ClassType,
    flightFlightType: k.kalemCharter && k.kalemCharter.FlightType,

    hotelCountry: k.kalemOtel && k.kalemOtel.Country,
    hotelBoardType: k.kalemOtel && k.kalemOtel.BoardType,
    hotelPansiyon: k.kalemOtel && k.kalemOtel.pansiyon,

    transferPlate: k.kalemArac && (k.kalemArac.PlateNumber || k.kalemArac.plaka),
    transferDriver: k.kalemArac && (k.kalemArac.DriverName || k.kalemArac.soforAdi),
    transferGsm: k.kalemArac && (k.kalemArac.DriverGsm || k.kalemArac.soforGsm || k.kalemArac.GSM),

    cruiseGemi: k.kalemGemi && k.kalemGemi.Gemi,
    cruiseCountry: k.kalemGemi && k.kalemGemi.Country,
    cruiseCabinType: k.kalemGemi && k.kalemGemi.CabinType
  };
});

console.warn("MICE SAVE PARAMS", window.__miceSaveParams);
console.table(window.__miceSaveOzet);


  tool.http_post(this, "MiceSave", params).then(
    response => {
      this.loadingvmodel = false;

      if (response.body.Status === true) {
        var data = response.body.data || {};
        var oldItem = this.selectedReservation || {};

        var simpleItem = this.mapLoadedMiceToSimple(data, oldItem);

        simpleItem.status = this.form.status || "Open";
        simpleItem.payment = this.form.payment || "Unpaid";
        simpleItem.currency = getCredentialsCurrency();
        simpleItem.isClosed = false;

        if (!simpleItem.total) {
          simpleItem.total = Number(this.reservationGrossTotal) || Number(this.form.total) || 0;
        }

        var currentIndex = -1;

        if (this.selectedReservationIndex > -1) {
          currentIndex = this.selectedReservationIndex;
        } else if (oldItem && oldItem.pnr) {
          currentIndex = this.findReservationIndex(oldItem.pnr);
        } else if (oldItem && oldItem.takipNo) {
          currentIndex = this.findReservationIndex(oldItem.takipNo);
        } else if (this.editingPnrCode) {
          currentIndex = this.findReservationIndex(this.editingPnrCode);
        }

        if (currentIndex > -1) {
          this.$set(this.reservations, currentIndex, simpleItem);
          this.selectedReservationIndex = currentIndex;
        } else {
          this.reservations.push(simpleItem);
          this.selectedReservationIndex = this.reservations.length - 1;
        }

        this.editingPnrCode = simpleItem.takipNo || simpleItem.pnr;
        this.isEditMode = true;

        if (typeof afterSuccess === "function") {
          afterSuccess(simpleItem, data);
        }

        this.closeDialog();
      } else {
        alert(
          response.body.ErrorList && response.body.ErrorList.length
            ? response.body.ErrorList[0]
            : "MICE rezervasyon kaydedilemedi."
        );

        if (typeof afterError === "function") {
          afterError(response.body);
        }
      }
    },
    response => {
      this.loadingvmodel = false;
      alert("Service Unavailable - MICE Rezervasyon Kaydedilemedi");

      if (typeof afterError === "function") {
        afterError(response);
      }
    }
  );
},

buildMiceReservationPayload() {
  var currentSelected = this.selectedReservation || {};
  var header = currentSelected.miceHeader || {};

  var optionFlight =
    currentSelected.flights && currentSelected.flights.length
      ? currentSelected.flights[0]
      : null;

  var isCopiedMice = currentSelected.isCopiedMice === true;

var takipNo = 0;

if (!isCopiedMice) {
  takipNo =
    currentSelected.takipNo ||
    this.editingPnrCode ||
    0;
}

  var rezervasyonMice = {
    takipNo: Number(takipNo) || 0,

    opsiyonluMusteri:
      optionFlight && optionFlight.opsiyonluMusteri === true,

    opsiyonTarihi:
      optionFlight && optionFlight.opsiyonluMusteri
        ? optionFlight.opsiyonTarihi || null
        : null,

    opsiyonSaati:
      optionFlight && optionFlight.opsiyonluMusteri
        ? this.simpleTimeToBackend(optionFlight.opsiyonSaati)
        : "0001-01-01T00:00:00",

    kayitTarihi: header.kayitTarihi || new Date(),

    // MICE header alanları
    rezVeren: header.rezVeren || "",
    masrafMerkezi: header.masrafMerkezi || this.emptyTableSimple(),
    anaTip: header.anaTip || 0,
    ulke: header.ulke || "",
    karsiRezKod: header.karsiRezKod || "",
    turKod: header.turKod || "",
    acenteDepartman: header.acenteDepartman || this.emptyTableSimple(),
    hizmetNo: header.hizmetNo || "",
    referansKod: header.referansKod || "",
    HedefKur: header.HedefKur || null,
    acente: header.acente || this.emptySaticiTable(),

    // Güvenli dursun diye header cari de koyuyoruz.
    // Asıl önemli olan her kalemin kendi cariKod alanı.
    cariKod: this.buildMiceCariKod(null),

    adresler: [],
    kalemler: []
  };

  var mevcutPassengers = [];

  if (currentSelected && currentSelected.passengers) {
    mevcutPassengers = currentSelected.passengers;
  }

  rezervasyonMice.adresler = mevcutPassengers.map(
    function(passenger, index) {
      return this.mapPassengerToAdres(passenger, index);
    }.bind(this)
  );

  this.appendMiceKalemList(
    rezervasyonMice.kalemler,
    currentSelected.flights,
    "mapFlightToKalem",
    8
  );

  this.appendMiceKalemList(
    rezervasyonMice.kalemler,
    currentSelected.hotels,
    "mapHotelToKalem",
    1
  );

  this.appendMiceKalemList(
    rezervasyonMice.kalemler,
    currentSelected.cars,
    "mapCarToKalem",
    5
  );

  this.appendMiceKalemList(
    rezervasyonMice.kalemler,
    currentSelected.transfers,
    "mapTransferToKalem",
    2
  );

  this.appendMiceKalemList(
    rezervasyonMice.kalemler,
    currentSelected.dailyTours,
    "mapDailyTourToKalem",
    4
  );

  this.appendMiceKalemList(
    rezervasyonMice.kalemler,
    currentSelected.cruises,
    "mapCruiseToKalem",
    9
  );

  this.appendMiceKalemList(
    rezervasyonMice.kalemler,
    currentSelected.others,
    "mapOtherToKalem",
    10
  );

  return rezervasyonMice;
},

appendMiceKalemList(targetList, sourceList, mapperName, saticiTip) {
  if (!targetList) return;
  if (!sourceList || !sourceList.length) return;
  if (typeof this[mapperName] !== "function") return;

  sourceList.forEach(
    function(serviceItem, index) {
      var kalem = this[mapperName](serviceItem, index);

      kalem = this.applyMiceKalemIdentity(kalem, serviceItem, saticiTip);

      targetList.push(kalem);
    }.bind(this)
  );
},

applyMiceKalemIdentity(kalem, serviceItem, saticiTip) {
  kalem = kalem || {};
  serviceItem = serviceItem || {};

  var pnrNo =
    serviceItem.PNR_No ||
    serviceItem.pNR_No ||
    serviceItem.pnrNo ||
    serviceItem.pnr ||
    0;

  kalem.PNR_No = Number(pnrNo) || 0;

  kalem.Guid =
    serviceItem.Guid ||
    serviceItem.guid ||
    "";

  kalem.islemRef =
    Number(
      serviceItem.islemRef ||
      serviceItem.IslemRef ||
      kalem.islemRef ||
      kalem.IslemRef ||
      0
    ) || 0;

  kalem.KaynakIslemRef =
    Number(
      serviceItem.KaynakIslemRef ||
      serviceItem.kaynakIslemRef ||
      kalem.KaynakIslemRef ||
      kalem.kaynakIslemRef ||
      0
    ) || 0;

  kalem.cariKod = this.buildMiceCariKod(serviceItem);

  kalem.saticiTip = saticiTip || kalem.saticiTip || 0;

  if (!kalem.kisiSira || !kalem.kisiSira.length) {
    kalem.kisiSira = this.getServicePassengerIndexes(serviceItem.passengers || []);
  }

  if (!kalem.kisiSira || !kalem.kisiSira.length) {
    kalem.kisiSira = [0];
  }

  // MICE tarafında kişi sayıları önemli.
  // Eski mapper doğru set ettiyse bozmayalım; boşsa basit güvenli default verelim.
  if (!kalem.yet_KisiSayisi && !kalem.co1_KisiSayisi && !kalem.co2_KisiSayisi) {
    kalem.yet_KisiSayisi = kalem.kisiSira.length || 1;
    kalem.co1_KisiSayisi = 0;
    kalem.co2_KisiSayisi = 0;
    kalem.co3_KisiSayisi = 0;
    kalem.co4_KisiSayisi = 0;
    kalem.ekY_KisiSayisi = 0;
  }

  return kalem;
},

buildMiceCariKod(serviceItem) {
  serviceItem = serviceItem || {};

  var serviceCari =
    serviceItem.cariKod ||
    serviceItem.CariKod ||
    null;

  if (serviceCari && (serviceCari.kod || serviceCari.Kod)) {
    return serviceCari;
  }

  var selected = this.selectedReservation || {};

  return {
    Unvan2: "",
    Adres1: "",
    Adres2: null,
    VergiDairesi: "",
    VergiNo: "",
    TCKimlikNo: "",
    Ilce_Il: "",
    EfaturaKayitli: 0,
    PerFirstName: "",
    PerFamilyName: "",
    EMail: "",
    GonderimSekli: 0,

    id: "0",
    kod: this.form.customerCode || selected.customerCode || "",
    isim: this.form.customerName || this.form.customer || selected.customer || "",
    tip: 0,
    intField: null,
    tumSirketler: false,
    sayfaAdi: null
  };
},

emptyTableSimple() {
  return {
    id: "0",
    kod: null,
    isim: null,
    tip: 0,
    intField: null,
    tumSirketler: false,
    sayfaAdi: null
  };
},

emptySaticiTable() {
  return {
    YurtIci_YurtDisi: 0,
    CariKod: null,
    KDV: 0,
    Yer: null,
    Ulke: null,
    Sehir: null,
    SaticiKonumu: null,
    Web: null,
    Tel1: null,
    Tel2: null,
    Fax: null,
    Teleks: null,
    EMail: null,
    GSM: null,
    Adres: null,

    id: "0",
    kod: null,
    isim: null,
    tip: 0,
    intField: null,
    tumSirketler: false,
    sayfaAdi: null
  };
},

//flight kalemler
mapFlightToKalem(flight, index) {
  var kalem = rez.Kalem();

  kalem.aciklama = flight.notes || "";

  kalem.saticiTip = 8;
  kalem.kisiSira = [];

  kalem.kisiSira = this.getServicePassengerIndexes(flight.passengers);

  kalem.satici = flight.satici || {
    id: null,
    kod: "",
    isim: "",
    tip: 8
  };

  kalem.donem1 = flight.departureDate || null;
  kalem.donem2 = flight.arrivalDate || flight.departureDate || null;

  kalem.yet_Satis = Number(flight.grossPrice) || 0;
  kalem.yet_Alis = Number(flight.supplierCost) || 0;
  kalem.komisyonTutar = Number(flight.commissionAmount) || 0;
  kalem.yet_KisiSayisi = flight.passengers ? flight.passengers.length : 1;

  if (kalem.satis) {
  kalem.satis.KDVOran = Number(flight.vatRate) || 0;
  kalem.satis.KDVTutar = Number(flight.vatAmount) || 0;
}

if (kalem.alis) {
  kalem.alis.KDVOran = Number(flight.vatRate) || 0;
}

if (kalem.komisyon) {
  kalem.komisyon.KDVOranSatis = Number(flight.vatRate) || 0;
}

  kalem.satisPara.paraBirimi = getCredentialsCurrency();
  kalem.alisPara.paraBirimi = getCredentialsCurrency();
  kalem.komisyonPara.paraBirimi = getCredentialsCurrency();

  var charter = {
  UcusNo: flight.flightNumber || "",
  Saat: this.combineDateAndTime(flight.departureDate, flight.departureTime),
  VarisSaati: this.combineDateAndTime(
    flight.arrivalDate || flight.departureDate,
    flight.arrivalTime
  ),
  Nerden: flight.from || "",
  Nereye: flight.to || "",
  Kontenjan: flight.airlinePnr || "",
  BiletNo: flight.ticketNumber || 0,
  BiletNo2: 0,
  HYKodu: flight.satici ? flight.satici.kod || "" : "",
  HYKodu2: "",
  AcenteKod: "",
  CharterKod: flight.airlinePnr || "",
  AcenteCari: "",
  CharterCari: "",
  OperatorCari: flight.tourOperator ? flight.tourOperator.kod || "" : "",
  BookingType: flight.bookingType || "Reservation",
ClassType: flight.classType || "Economy",
FlightType: flight.flightType || "International",
  AcenteTarih: null,
  CharterTarih: null,
  OperatorTarih: null,
  AcenteNo: 0,
  CharterNo: 0,
  OperatorNo: 0,
  AcenteCariOnay: 0,
  CharterCariOnay: 0,
  OperatorCariOnay: 0,
  YetiskinSticker: 0,
  YetiskinHizmet: 0,
  YetiskinTax:
  Number(flight.taxAmount) ||
  Number(flight.fuelPriceDifference) ||
  0,
  CocukSticker: 0,
  CocukHizmet: 0,
  CocukTax: 0,
  BebekSticker: 0,
  BebekHizmet: 0,
  BebekTax: 0,
  CharterPTA: 0,
  DeadLine: 0,
  PaketDisi: 0,
  Tip: "",
  tumSirketler: false,
  sayfaAdi: null,
  OpsiyonluMusteri: flight.opsiyonluMusteri === true,
OpsiyonTarihi: flight.opsiyonluMusteri ? flight.opsiyonTarihi || null : null,
OpsiyonSaati: flight.opsiyonluMusteri ? this.simpleTimeToBackend(flight.opsiyonSaati) : null,
};

kalem.kalemCharter = charter;
kalem.baseKalem = charter;

  return kalem;
},


//hotels kalemler
mapHotelToKalem(hotel, index) {
  var kalem = rez.Kalem();

  kalem.saticiTip = 1;
  kalem.kisiSira = [];

  kalem.kisiSira = this.getServicePassengerIndexes(hotel.passengers);

  kalem.satici = hotel.satici || {
    id: null,
    kod: "",
    isim: "",
    tip: 1
  };

  kalem.turOperatoru = hotel.tourOperator || {
    id: null,
    kod: null,
    isim: null,
    isimAra: null
  };

  kalem.donem1 = hotel.checkIn || null;
  kalem.donem2 = hotel.checkOut || hotel.checkIn || null;

  kalem.yet_Satis = Number(hotel.grossPrice) || 0;
  kalem.yet_Alis = Number(hotel.supplierCost) || 0;
  kalem.komisyonTutar = Number(hotel.commissionAmount) || 0;
  kalem.yet_KisiSayisi = hotel.passengers ? hotel.passengers.length : 1;

  if (kalem.satis) {
    kalem.satis.KDVOran = Number(hotel.vatRate) || 0;
    kalem.satis.KDVTutar = Number(hotel.vatAmount) || 0;
  }

  if (kalem.alis) {
    kalem.alis.KDVOran = Number(hotel.vatRate) || 0;
  }

  if (kalem.komisyon) {
    kalem.komisyon.KDVOranSatis = Number(hotel.vatRate) || 0;
  }

  kalem.satisPara.paraBirimi = getCredentialsCurrency();
  kalem.alisPara.paraBirimi = getCredentialsCurrency();
  kalem.komisyonPara.paraBirimi = getCredentialsCurrency();

  kalem.aciklama = hotel.notes || "";
  kalem.tedarikciAciklama = hotel.confirmationNo || "";

  // HOTEL
  var roomTypeCode = hotel.roomType || hotel.roomTypeName || "SGL";
  var roomTypeName = this.getHotelRoomTypeName(roomTypeCode) || roomTypeCode;

  kalem.kalemOtel = {
    odaTipi: {
      id: "0",
      kod: roomTypeCode,
      isim: roomTypeName,
      tip: 0
    },

    odaTipiIsim: roomTypeName,
    OdaTipiIsim: roomTypeName,

    pansiyon: this.simpleBoardTypeToBackend
      ? this.simpleBoardTypeToBackend(hotel.boardType)
      : hotel.boardType || "",

    BoardType: hotel.boardType || "",

    konum: hotel.city || "",
    Country: hotel.country || "",

    RP: "T",
    odaSayi: Number(hotel.rooms) || 1,
    kontenjan: false,
    freeKisi: 0,

    fiyatKodu: {
      id: "0",
      kod: null,
      isim: null,
      tip: 0
    },

    girisSaati: null
  };

  kalem.baseKalem = kalem.kalemOtel;

  kalem.aciklama = hotel.notes || "";
  kalem.aciklama2 = hotel.country || "";
  kalem.tedarikciAciklama = hotel.confirmationNo || "";
  kalem.baseKalem = kalem.kalemOtel;

  return kalem;
},

// car kalemler
mapCarToKalem(car, index) {
  var kalem = rez.Kalem();

  kalem.saticiTip = 5;
  kalem.kisiSira = [];

  kalem.kisiSira = this.getServicePassengerIndexes(car.passengers);

  kalem.satici = car.satici || {
    id: null,
    kod: "",
    isim: "",
    tip: 5
  };

  kalem.turOperatoru = car.tourOperator || {
    id: null,
    kod: null,
    isim: null,
    isimAra: null
  };

  kalem.donem1 = car.pickupDate || null;
  kalem.donem2 = car.dropoffDate || car.pickupDate || null;

  var carVatRate = Number(car.vatRate) || 0;
  var carNetPrice = Number(car.netPrice) || 0;
  var carVatAmount = Number(car.vatAmount) || 0;

  if (!carVatAmount && carVatRate > 0 && carNetPrice > 0) {
    carVatAmount = Number(((carNetPrice * carVatRate) / 100).toFixed(2));
  }

  var carGrossPrice =
    Number(car.grossPrice) ||
    (carNetPrice + carVatAmount) ||
    0;

  kalem.yet_Satis = carGrossPrice;
  kalem.yet_Alis = Number(car.supplierCost) || 0;
  kalem.komisyonTutar = Number(car.commissionAmount) || 0;
  kalem.yet_KisiSayisi =
  kalem.kisiSira && kalem.kisiSira.length
    ? kalem.kisiSira.length
    : 1;

  if (kalem.satis) {
    kalem.satis.KDVOran = carVatRate;
    kalem.satis.KDVTutar = carVatAmount;
  }

  if (kalem.alis) {
    kalem.alis.KDVOran = carVatRate;
    kalem.alis.KDVTutar = 0;
  }

  if (kalem.komisyon) {
    kalem.komisyon.KDVOranSatis = carVatRate;
    kalem.komisyon.KDVTutar = 0;
  }

  kalem.satisPara.paraBirimi = getCredentialsCurrency();
  kalem.alisPara.paraBirimi = getCredentialsCurrency();
  kalem.komisyonPara.paraBirimi = getCredentialsCurrency();

  kalem.aciklama = car.notes || "";
  kalem.tedarikciAciklama = car.confirmationNo || "";

  // RENT A CAR
  kalem.kalemRentACar = {
    firma: car.satici ? car.satici.kod || "" : "",
    arac: car.carType || "",
    kategori: car.category || "",

    alisYeri: car.pickupLocation || "",
    teslimYeri: car.dropoffLocation || car.pickupLocation || "",

    alisTarih: car.pickupDate || null,
    teslimTarih: car.dropoffDate || null,

    // Mevcut tablo alanları
    alisSaat: this.combineDateAndTime
      ? this.combineDateAndTime(car.pickupDate, car.pickupTime)
      : this.simpleTimeToBackend(car.pickupTime),

    teslimSaat: this.combineDateAndTime
      ? this.combineDateAndTime(car.dropoffDate || car.pickupDate, car.dropoffTime)
      : this.simpleTimeToBackend(car.dropoffTime),

    // Eski numeric alan boş kalsın
    RCRNo: 0,

    // Yeni text alan
    ConfirmationNo: car.confirmationNo || "",

    turOperatoru: car.tourOperator ? car.tourOperator.kod || "" : "",

    tumSirketler: false,
    sayfaAdi: null
  };

  kalem.baseKalem = kalem.kalemRentACar;

 

  return kalem;
},

// transfer kalemler
mapTransferToKalem(transfer, index) {
  var kalem = rez.Kalem();

  kalem.saticiTip = 2;
  kalem.kisiSira = [];

  kalem.kisiSira = this.getServicePassengerIndexes(
    transfer.passengers
  );

  kalem.satici = transfer.satici || {
    id: null,
    kod: "",
    isim: "",
    tip: 2
  };

  kalem.turOperatoru = transfer.tourOperator || {
    id: null,
    kod: null,
    isim: null,
    isimAra: null
  };

  kalem.donem1 = transfer.date || null;
  kalem.donem2 = transfer.date || null;

  var transferVatRate =
    Number(transfer.vatRate) || 0;

  var transferNetPrice =
    Number(transfer.netPrice) || 0;

  var transferVatAmount =
    Number(transfer.vatAmount) || 0;

  if (
    !transferVatAmount &&
    transferVatRate > 0 &&
    transferNetPrice > 0
  ) {
    transferVatAmount = Number(
      (
        (transferNetPrice * transferVatRate) /
        100
      ).toFixed(2)
    );
  }

  var transferGrossPrice =
    Number(transfer.grossPrice) ||
    transferNetPrice + transferVatAmount ||
    0;

  var transferPassengerCount =
    Number(transfer.passengerCount) ||
    (
      transfer.passengers &&
      transfer.passengers.length
        ? transfer.passengers.length
        : 0
    ) ||
    1;

  kalem.yet_Satis = transferGrossPrice;
  kalem.yet_Alis =
    Number(transfer.supplierCost) || 0;

  kalem.komisyonTutar =
    Number(transfer.commissionAmount) || 0;

  kalem.yet_KisiSayisi =
    transferPassengerCount;

  if (kalem.satis) {
    kalem.satis.KDVOran =
      transferVatRate;

    kalem.satis.KDVTutar =
      transferVatAmount;
  }

  if (kalem.alis) {
    kalem.alis.KDVOran =
      transferVatRate;

    kalem.alis.KDVTutar = 0;
  }

  if (kalem.komisyon) {
    kalem.komisyon.KDVOranSatis =
      transferVatRate;

    kalem.komisyon.KDVTutar = 0;
  }

  kalem.satisPara.paraBirimi =
    getCredentialsCurrency();

  kalem.alisPara.paraBirimi =
    getCredentialsCurrency();

  kalem.komisyonPara.paraBirimi =
    getCredentialsCurrency();

  kalem.aciklama = transfer.notes || "";

  kalem.tedarikciAciklama =
    transfer.confirmationNo || "";

  var transferDateTime = this.combineDateAndTime
    ? this.combineDateAndTime(
        transfer.date,
        transfer.time
      )
    : this.simpleTimeToBackend(
        transfer.time
      );

  var flightDateTime = this.combineDateAndTime
    ? this.combineDateAndTime(
        transfer.date,
        transfer.flightTime
      )
    : this.simpleTimeToBackend(
        transfer.flightTime
      );

  var extraHours = [];
  var extraHourAmounts = [];

  if (Array.isArray(transfer.extraHours)) {
    for (
      var extraIndex = 0;
      extraIndex < transfer.extraHours.length &&
      extraIndex < (this.maxTransferExtraHourCount || 3);
      extraIndex++
    ) {
      var extraHour = transfer.extraHours[extraIndex];

      if (!extraHour || extraHour === "00:00") {
        continue;
      }

      var extraAmount = Array.isArray(transfer.extraHourAmounts)
        ? Number(transfer.extraHourAmounts[extraIndex]) || 0
        : 0;

      extraHours.push(extraHour);
      extraHourAmounts.push(extraAmount);
    }
  }

  // TRANSFER
  kalem.kalemArac = {
    tip: transfer.type || "",
    tasimaTipi: transfer.type || "",

    // Transfer / Tahsis
    HizmetSekli:
      transfer.serviceType || "Transfer",

    // En fazla üç ek saat kaydı
    EkSaat1: extraHours[0] || "",
    EkSaat2: extraHours[1] || "",
    EkSaat3: extraHours[2] || "",

    EkSaatTutar1: extraHourAmounts[0] || 0,
    EkSaatTutar2: extraHourAmounts[1] || 0,
    EkSaatTutar3: extraHourAmounts[2] || 0,

    arac: transfer.vehicleType || "",
    aracAdet: 1,

    nerden: transfer.from || "",
    nereye: transfer.to || "",

    // Transfer hareket saati
    saat: transferDateTime,
    Saat: transferDateTime,

    // Uçuş bilgileri
    ucusNo: transfer.flightNumber || "",
    UcusNo: transfer.flightNumber || "",

    ucusSaat: flightDateTime,
    UcusSaat: flightDateTime,

    // Eski alanlar
    plaka: transfer.plateNumber || "",
    soforAdi: transfer.driverName || "",
    soforGsm: transfer.driverPhone || "",
    GSM: transfer.driverPhone || "",
    rezervasyonNo:
      transfer.confirmationNo || "",

    // Backend model alanları
    PlateNumber:
      transfer.plateNumber || "",

    DriverName:
      transfer.driverName || "",

    DriverGsm:
      transfer.driverPhone || "",

    ConfirmationNo:
      transfer.confirmationNo || "",

    // Eski mapper uyumluluğu
    plateNumber:
      transfer.plateNumber || "",

    driverName:
      transfer.driverName || "",

    driverGsm:
      transfer.driverPhone || "",

    confirmationNo:
      transfer.confirmationNo || "",

    rehberDili: "",
    rehberAdet: 0,
    bolge: "",
    seferNo: null,
    seferId: null,
    ADT: "",
    pinCode: "",
    odaNo: "",
    transferDurumu: 0,

    tumSirketler: false,
    sayfaAdi: null
  };

  kalem.baseKalem = kalem.kalemArac;

  return kalem;
},

// daily tour kalemler
mapDailyTourToKalem(tour, index) {
  var kalem = rez.Kalem();

  kalem.saticiTip = 4;
  kalem.kisiSira = [];

  kalem.kisiSira = this.getServicePassengerIndexes(tour.passengers);

  kalem.satici = tour.satici || {
    id: null,
    kod: "",
    isim: "",
    tip: 4
  };

  kalem.turOperatoru = tour.tourOperator || {
    id: null,
    kod: null,
    isim: null,
    isimAra: null
  };

  kalem.donem1 = tour.date || null;
  kalem.donem2 = tour.date || null;

  var dailyTourVatRate = Number(tour.vatRate) || 0;
  var dailyTourNetPrice = Number(tour.netPrice) || 0;
  var dailyTourVatAmount = Number(tour.vatAmount) || 0;

  if (!dailyTourVatAmount && dailyTourVatRate > 0 && dailyTourNetPrice > 0) {
    dailyTourVatAmount = Number(
      ((dailyTourNetPrice * dailyTourVatRate) / 100).toFixed(2)
    );
  }

  var dailyTourGrossPrice =
    Number(tour.grossPrice) ||
    (dailyTourNetPrice + dailyTourVatAmount) ||
    0;

  kalem.yet_Satis = dailyTourGrossPrice;
  kalem.yet_Alis = Number(tour.supplierCost) || 0;
  kalem.komisyonTutar = Number(tour.commissionAmount) || 0;
  kalem.yet_KisiSayisi =
    tour.passengers && tour.passengers.length
      ? tour.passengers.length
      : 1;

  if (kalem.satis) {
    kalem.satis.KDVOran = dailyTourVatRate;
    kalem.satis.KDVTutar = dailyTourVatAmount;
  }

  if (kalem.alis) {
    kalem.alis.KDVOran = dailyTourVatRate;
    kalem.alis.KDVTutar = 0;
  }

  if (kalem.komisyon) {
    kalem.komisyon.KDVOranSatis = dailyTourVatRate;
    kalem.komisyon.KDVTutar = 0;
  }

  kalem.satisPara.paraBirimi = getCredentialsCurrency();
  kalem.alisPara.paraBirimi = getCredentialsCurrency();
  kalem.komisyonPara.paraBirimi = getCredentialsCurrency();

  kalem.aciklama = tour.notes || "";
  kalem.tedarikciAciklama = tour.confirmationNo || "";

  kalem.kalemAcente = {
    Acente: tour.satici ? tour.satici.kod || "" : "",
    AcenteKod: tour.satici ? tour.satici.kod || "" : "",
    AcenteCari: tour.satici ? tour.satici.kod || "" : "",
    AcenteRezTar: tour.date || null,

    Saat: this.combineDateAndTime
      ? this.combineDateAndTime(tour.date, tour.time)
      : this.simpleTimeToBackend(tour.time),

    // Eski alan kalsın
    Tip: tour.tourCode || "",

    // Yeni alan
    TourName: tour.tourName || "",

    TurKodu: tour.tourCode || "",
    Program: tour.program || tour.description || tour.tourName || "",

    BulusmaYeri: tour.meetingPoint || tour.pickupLocation || "",
    BulusmaTarihi: tour.date || null,

    OperKod: tour.tourOperator ? tour.tourOperator.kod || "" : "",
    OperCari: tour.tourOperator ? tour.tourOperator.kod || "" : "",
    OperRezTar: tour.date || null,

    PaketDisi: 0,
    tumSirketler: false,
    sayfaAdi: null
  };

  kalem.baseKalem = kalem.kalemAcente;

  

  return kalem;
},

// cruises kalemler
mapCruiseToKalem(cruise, index) {
  var kalem = rez.Kalem();

  kalem.saticiTip = 9;
  kalem.kisiSira = [];

  kalem.kisiSira = this.getServicePassengerIndexes(cruise.passengers);

  kalem.satici = cruise.satici || {
    id: null,
    kod: "",
    isim: "",
    tip: 9
  };

  kalem.turOperatoru = cruise.tourOperator || {
    id: null,
    kod: null,
    isim: null,
    isimAra: null
  };

  kalem.donem1 = cruise.checkIn || null;
  kalem.donem2 = cruise.checkOut || cruise.checkIn || null;

  var vatRate = Number(cruise.vatRate) || 0;
  var netPrice = Number(cruise.netPrice) || 0;
  var vatAmount = Number(cruise.vatAmount) || 0;

  if (!vatAmount && vatRate > 0 && netPrice > 0) {
    vatAmount = Number(((netPrice * vatRate) / 100).toFixed(2));
  }

  var grossPrice =
    Number(cruise.grossPrice) ||
    (netPrice + vatAmount) ||
    0;

  var guestCount =
    Number(cruise.guests) ||
    (cruise.passengers ? cruise.passengers.length : 0) ||
    1;

  var cabinType =
  typeof cruise.roomType === "object"
    ? cruise.roomType.kod || cruise.roomType.isim || ""
    : cruise.roomType ||
      cruise.cabinType ||
      "";

  kalem.yet_Satis = grossPrice;
  kalem.yet_Alis = Number(cruise.supplierCost) || 0;
  kalem.komisyonTutar = Number(cruise.commissionAmount) || 0;
  kalem.yet_KisiSayisi = guestCount;

  if (kalem.satis) {
    kalem.satis.KDVOran = vatRate;
    kalem.satis.KDVTutar = vatAmount;
  }

  if (kalem.alis) {
    kalem.alis.KDVOran = vatRate;
    kalem.alis.KDVTutar = 0;
  }

  if (kalem.komisyon) {
    kalem.komisyon.KDVOranSatis = vatRate;
    kalem.komisyon.KDVTutar = 0;
  }

  kalem.satisPara.paraBirimi = getCredentialsCurrency();
  kalem.alisPara.paraBirimi = getCredentialsCurrency();
  kalem.komisyonPara.paraBirimi = getCredentialsCurrency();

  kalem.aciklama = cruise.notes || "";
  kalem.tedarikciAciklama = cruise.confirmationNo || "";

  kalem.kalemGemi = {
    GemiKod: cruise.satici ? cruise.satici.kod || "" : "",
    Gemi: cruise.hotelName || "",
    GemiCari: cruise.satici ? cruise.satici.kod || "" : "",
    GemiRezTar: cruise.checkIn || null,

    Acente: cruise.tourOperator ? cruise.tourOperator.kod || "" : "",
    AcenteCari: cruise.tourOperator ? cruise.tourOperator.kod || "" : "",
    AcenteRezTar: cruise.checkIn || null,

    Konum: cruise.city || "",
    Country: cruise.country || "",
    ConfirmationNo: cruise.confirmationNo || "",
    CabinType: cabinType,

    KabinSayisi: Number(cruise.rooms) || 1,

    // backend bunu kullanmasa bile dursun, asıl kişi sayısı yukarıdaki yet_KisiSayisi
    KisiSayisi: guestCount,

    tumSirketler: false,
    sayfaAdi: null
  };

  kalem.baseKalem = kalem.kalemGemi;

  

  return kalem;
},

//others kalemler
mapOtherToKalem(other, index) {
  var kalem = rez.Kalem();

  kalem.saticiTip = 10;
  kalem.kisiSira = [];

  kalem.kisiSira = this.getServicePassengerIndexes(other.passengers);

  kalem.satici = other.satici || {
    id: null,
    kod: "",
    isim: "",
    tip: 10
  };

  kalem.turOperatoru = other.tourOperator || {
    id: null,
    kod: null,
    isim: null,
    isimAra: null
  };

  kalem.donem1 = other.startDate || null;
  kalem.donem2 = other.endDate || other.startDate || null;

  var otherVatRate = Number(other.vatRate) || 0;
  var otherNetPrice = Number(other.netPrice) || 0;
  var otherVatAmount = Number(other.vatAmount) || 0;

  if (!otherVatAmount && otherVatRate > 0 && otherNetPrice > 0) {
    otherVatAmount = Number(
      ((otherNetPrice * otherVatRate) / 100).toFixed(2)
    );
  }

  var otherGrossPrice =
    Number(other.grossPrice) ||
    (otherNetPrice + otherVatAmount) ||
    0;

  kalem.yet_Satis = otherGrossPrice;
  kalem.yet_Alis = Number(other.supplierCost) || 0;
  kalem.komisyonTutar = Number(other.commissionAmount) || 0;

  kalem.yet_KisiSayisi =
    other.passengers && other.passengers.length
      ? other.passengers.length
      : 1;

  if (kalem.satis) {
    kalem.satis.KDVOran = otherVatRate;
    kalem.satis.KDVTutar = otherVatAmount;
  }

  if (kalem.alis) {
    kalem.alis.KDVOran = otherVatRate;
    kalem.alis.KDVTutar = 0;
  }

  if (kalem.komisyon) {
    kalem.komisyon.KDVOranSatis = otherVatRate;
    kalem.komisyon.KDVTutar = 0;
  }

  kalem.satisPara.paraBirimi = getCredentialsCurrency();
  kalem.alisPara.paraBirimi = getCredentialsCurrency();
  kalem.komisyonPara.paraBirimi = getCredentialsCurrency();

  kalem.aciklama = other.notes || "";
  kalem.tedarikciAciklama = other.confirmationNo || other.description || "";

  // OTHERS
  kalem.kalemDiger = {
    isAciklama: other.description || "",
    IsKodu: other.title || "",

    Satici: other.satici ? other.satici.kod || "" : "",

    Bolge: "",
    Saat: "",
    DeadLine: 0,
    PaketDisi: 0,
    PaketId: 0,
    PaketAltGrupId: 0,
    PaketFiyatGrubuId: 0,

    tumSirketler: false,
    sayfaAdi: null
  };

  kalem.baseKalem = kalem.kalemDiger;

  

  return kalem;
},

    resetForm() {
  this.form = this.getEmptyReservationForm();
  this.statecari = [];
},


    openMainPassengerDialog() {
      this.editingPassengerIndex = null;
      this.resetPassengerForm();
      this.passengerBirthDateText = "";
      this.passengerDialog = true;
    },

    editMainPassenger(index) {
      if (!this.selectedReservation || !this.selectedReservation.passengers) {
        return;
      }

      this.editingPassengerIndex = index;

      this.passengerForm = Object.assign(
        this.getEmptyPassengerForm(),
        this.selectedReservation.passengers[index]
      );

      this.passengerBirthDateText = this.displayDate(
        this.passengerForm.birthDate
      );

      this.passengerDialog = true;
    },

   removeMainPassenger(index) {
  if (!this.selectedReservation || !this.selectedReservation.passengers) {
    return;
  }

  var passenger = this.selectedReservation.passengers[index];

  var passengerName = passenger
    ? ((passenger.firstName || "") + " " + (passenger.lastName || "")).trim()
    : "";

  var message = passengerName
    ? passengerName + " isimli kişiyi silmek istediğinize emin misiniz?"
    : "Bu kişiyi silmek istediğinize emin misiniz?";

  this.openDeleteConfirm(message, "passenger", "", index);
},

    closePassengerDialog() {
      this.passengerDialog = false;
      this.editingPassengerIndex = null;
      this.passengerBirthDateText = "";
      this.resetPassengerForm();
    },

    savePassengerDetails() {
  if (!this.selectedReservation) return;

  var firstName = (this.passengerForm.firstName || "").trim();
  var lastName = (this.passengerForm.lastName || "").trim();
  var birthDateText = (this.passengerBirthDateText || "").trim();

  if (!firstName) {
    alert("Ad zorunludur.");
    return;
  }

  if (!lastName) {
    alert("Soyad zorunludur.");
    return;
  }

  if (!birthDateText) {
    alert("Doğum tarihi zorunludur.");
    return;
  }

  var match = birthDateText.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);

  if (!match) {
    alert("Doğum tarihi dd.mm.yyyy formatında olmalıdır.");
    return;
  }

  var day = match[1];
  var month = match[2];
  var year = match[3];

  if (!this.isValidBirthDate(day, month, year)) {
    alert("Geçerli bir doğum tarihi giriniz.");
    return;
  }

  this.passengerForm.birthDate = year + "-" + month + "-" + day;

  if (!this.selectedReservation.passengers) {
    this.$set(this.selectedReservation, "passengers", []);
  }

  var payload = Object.assign({}, this.passengerForm);

  payload.firstName = firstName;
  payload.lastName = lastName;
  payload.birthDate = this.passengerForm.birthDate;
  payload.gender = this.passengerForm.gender || "";
  payload.cinsiyet = this.simpleGenderToBackend(this.passengerForm.gender);

  payload.fromAddressBook = payload.fromAddressBook === true;
payload.addressBookId = payload.addressBookId || null;
payload.addressBookCode = payload.addressBookCode || "";
payload.addressBookSaved = payload.fromAddressBook ? true : false;

  if (this.editingPassengerIndex !== null) {
    var oldPassenger =
      this.selectedReservation.passengers[this.editingPassengerIndex] || {};

    if (
      oldPassenger._copyPassengerIndex !== undefined &&
      oldPassenger._copyPassengerIndex !== null
    ) {
      payload._copyPassengerIndex = oldPassenger._copyPassengerIndex;
    }

    this.$set(
      this.selectedReservation.passengers,
      this.editingPassengerIndex,
      payload
    );

    this.syncPassengerToServiceItems(this.editingPassengerIndex, payload);
  } else {
    payload._copyPassengerIndex = this.selectedReservation.passengers.length;
    this.selectedReservation.passengers.push(payload);
  }

  this.closePassengerDialog();
},


syncPassengerToServiceItems(passengerIndex, passengerPayload) {
  if (!this.selectedReservation) return;

  var serviceNames = this.getServiceCollectionNames();

  serviceNames.forEach(function(collectionName) {
    var list = this.selectedReservation[collectionName] || [];

    list.forEach(function(serviceItem) {
      if (!serviceItem.passengers || !serviceItem.passengers.length) return;

      serviceItem.passengers.forEach(function(servicePassenger, index) {
        if (
          servicePassenger &&
          servicePassenger._copyPassengerIndex !== undefined &&
          servicePassenger._copyPassengerIndex === passengerIndex
        ) {
          this.$set(serviceItem.passengers, index, passengerPayload);
        }
      }.bind(this));
    }.bind(this));
  }.bind(this));
},

    resetPassengerForm() {
      this.passengerForm = this.getEmptyPassengerForm();
    },

    openFlightDialog(item) {
      this.selectedReservationIndex = this.findReservationIndex(item.pnr);
      this.editingFlightIndex = null;
      this.resetFlightForm();
      this.flightDialog = true;
    },

    openHotelDialog(item) {
      this.selectedReservationIndex = this.findReservationIndex(item.pnr);
      this.editingHotelIndex = null;
      this.resetHotelForm();
      this.hotelDialog = true;
    },

    openCarDialog(item) {
      this.selectedReservationIndex = this.findReservationIndex(item.pnr);
      this.editingCarIndex = null;
      this.resetCarForm();
      this.carDialog = true;
    },

    openTransferDialog(item) {
      this.selectedReservationIndex = this.findReservationIndex(item.pnr);
      this.editingTransferIndex = null;
      this.resetTransferForm();
      this.transferDialog = true;
    },

    openDailyTourDialog(item) {
      this.selectedReservationIndex = this.findReservationIndex(item.pnr);
      this.editingDailyTourIndex = null;
      this.resetDailyTourForm();
      this.dailyTourDialog = true;
    },

    openCruiseDialog(item) {
      this.selectedReservationIndex = this.findReservationIndex(item.pnr);
      this.editingCruiseIndex = null;
      this.resetCruiseForm();
      this.cruiseDialog = true;
    },

    openOtherDialog(item) {
      this.selectedReservationIndex = this.findReservationIndex(item.pnr);
      this.editingOtherIndex = null;
      this.resetOtherForm();
      this.otherDialog = true;
    },

    editFlight(index) {
      if (!this.selectedReservation) return;
      this.editingFlightIndex = index;
      this.flightForm = Object.assign(
        this.getEmptyFlightForm(),
        this.selectedReservation.flights[index]
      );
      this.flightDialog = true;
    },

    editHotel(index) {
      if (!this.selectedReservation) return;
      this.editingHotelIndex = index;
      this.hotelForm = Object.assign(
        this.getEmptyHotelForm(),
        this.selectedReservation.hotels[index]
      );
      this.hotelDialog = true;
    },

    editCruise(index) {
      if (!this.selectedReservation) return;
      this.editingCruiseIndex = index;
      this.cruiseForm = Object.assign(
        this.getEmptyCruiseForm(),
        this.selectedReservation.cruises[index]
      );
      this.cruiseDialog = true;
    },

    editCar(index) {
      if (!this.selectedReservation) return;
      this.editingCarIndex = index;
      this.carForm = Object.assign(
        this.getEmptyCarForm(),
        this.selectedReservation.cars[index]
      );
      this.carDialog = true;
    },

    editTransfer(index) {
  if (!this.selectedReservation) return;

  this.editingTransferIndex = index;

  this.transferForm = Object.assign(
    this.getEmptyTransferForm(),
    this.selectedReservation.transfers[index]
  );

  if (!Array.isArray(this.transferForm.extraHours)) {
  this.$set(this.transferForm, "extraHours", []);
}

if (!Array.isArray(this.transferForm.extraHourAmounts)) {
  this.$set(this.transferForm, "extraHourAmounts", []);
}

this.transferForm.extraHours =
  this.transferForm.extraHours.slice(
    0,
    this.maxTransferExtraHourCount
  );

this.transferForm.extraHourAmounts =
  this.transferForm.extraHourAmounts.slice(
    0,
    this.maxTransferExtraHourCount
  );

while (
  this.transferForm.extraHourAmounts.length <
  this.transferForm.extraHours.length
) {
  this.transferForm.extraHourAmounts.push(0);
}

this.transferForm.hasExtraHour =
  this.transferForm.extraHours.length > 0;

  this.transferDialog = true;
},

    editDailyTour(index) {
      if (!this.selectedReservation) return;
      this.editingDailyTourIndex = index;
      this.dailyTourForm = Object.assign(
        this.getEmptyDailyTourForm(),
        this.selectedReservation.dailyTours[index]
      );
      this.dailyTourDialog = true;
    },

    editOther(index) {
      if (!this.selectedReservation) return;
      this.editingOtherIndex = index;
      this.otherForm = Object.assign(
        this.getEmptyOtherForm(),
        this.selectedReservation.others[index]
      );
      this.otherDialog = true;
    },

    closeFlightDialog() {
      this.flightDialog = false;
      this.editingFlightIndex = null;
      this.resetFlightForm();
    },

    closeHotelDialog() {
      this.hotelDialog = false;
      this.editingHotelIndex = null;
      this.resetHotelForm();
    },

    closeCarDialog() {
      this.carDialog = false;
      this.editingCarIndex = null;
      this.resetCarForm();
    },

    closeTransferDialog() {
      this.transferDialog = false;
      this.editingTransferIndex = null;
      this.resetTransferForm();
    },

    closeDailyTourDialog() {
      this.dailyTourDialog = false;
      this.editingDailyTourIndex = null;
      this.resetDailyTourForm();
    },

    closeCruiseDialog() {
      this.cruiseDialog = false;
      this.editingCruiseIndex = null;
      this.resetCruiseForm();
    },

    closeOtherDialog() {
      this.otherDialog = false;
      this.editingOtherIndex = null;
      this.resetOtherForm();
    },

    saveFlight() {
  if (this.selectedReservationIndex < 0) return;

  if (
    !this.flightForm.satici ||
    !this.flightForm.from ||
    !this.flightForm.to ||
    !this.flightForm.departureDate
  ) {
    alert("Please fill in the required flight fields.");
    return;
  }

  var payload = {
    satici: this.flightForm.satici,
    flightNumber: this.flightForm.flightNumber,
    airlinePnr: this.flightForm.airlinePnr,
    classType: this.flightForm.classType,
    from: this.flightForm.from,
    to: this.flightForm.to,
    departureDate: this.flightForm.departureDate,
    departureTime: this.flightForm.departureTime,
    arrivalDate: this.flightForm.arrivalDate,
    arrivalTime: this.flightForm.arrivalTime,
    passengers: this.getServicePassengersSnapshot(),
    bookingType: this.flightForm.bookingType,
    tourOperator: this.flightForm.tourOperator,
    ticketNumber: this.flightForm.ticketNumber,
    opsiyonluMusteri: this.flightForm.opsiyonluMusteri === true,
    opsiyonTarihi: this.flightForm.opsiyonluMusteri
      ? this.flightForm.opsiyonTarihi || null
      : null,
    opsiyonSaati: this.flightForm.opsiyonluMusteri
      ? this.flightForm.opsiyonSaati || ""
      : "",
    notes: this.flightForm.notes || "",

    netPrice: Number(this.flightForm.netPrice) || 0,

    vatRate:
      this.flightForm.flightType === "International"
        ? Number(this.flightForm.vatRate) || 0
        : 0,

    vatAmount:
      this.flightForm.flightType === "International"
        ? this.flightVatAmount
        : 0,

    taxAmount: Number(this.flightForm.taxAmount) || 0,

    grossPrice: this.flightGrossAmount,
    commissionAmount: Number(this.flightForm.commissionAmount) || 0,
    supplierCost: Number(this.flightForm.supplierCost) || 0,

    flightType: this.flightForm.flightType,

    fuelPriceDifference: Number(this.flightForm.taxAmount) || 0,

    airportTax: Number(this.flightForm.airportTax) || 0
  };

  this.saveServicePayload("flights", this.editingFlightIndex, payload);
  this.closeFlightDialog();
},

    saveHotel() {
      if (this.selectedReservationIndex < 0) return;

      if (
        !this.hotelForm.satici ||
        !this.hotelForm.city ||
        !this.hotelForm.checkIn ||
        !this.hotelForm.checkOut
      ) {
        alert("Please fill in the required hotel fields.");
        return;
      }

      var payload = {
        satici: this.hotelForm.satici,
        city: this.hotelForm.city,
        country: this.hotelForm.country,
        checkIn: this.hotelForm.checkIn,
        checkOut: this.hotelForm.checkOut,
        rooms: Number(this.hotelForm.rooms) || 1,
        guests: Number(this.hotelForm.guests) || 1,
        roomType: this.hotelForm.roomType,
        boardType: this.hotelForm.boardType,
        confirmationNo: this.hotelForm.confirmationNo,
        passengers: this.getServicePassengersSnapshot(),
        netPrice: Number(this.hotelForm.netPrice) || 0,
  vatRate: Number(this.hotelForm.vatRate) || 0,
  vatAmount: Number(this.hotelVatAmount) || 0,
  grossPrice: Number(this.hotelGrossAmount) || 0,
        commissionAmount: Number(this.hotelForm.commissionAmount) || 0,
        supplierCost: Number(this.hotelForm.supplierCost) || 0,
        tourOperator: this.hotelForm.tourOperator,
        notes: this.hotelForm.notes || ""
      };

      this.saveServicePayload("hotels", this.editingHotelIndex, payload);
      this.closeHotelDialog();
    },

    saveCar() {
      if (this.selectedReservationIndex < 0) return;

      if (
        !this.carForm.satici ||
        !this.carForm.pickupLocation ||
        !this.carForm.pickupDate ||
        !this.carForm.dropoffDate
      ) {
        alert("Please fill in the required car rental fields.");
        return;
      }

      var payload = {
        satici: this.carForm.satici,
        carType: this.carForm.carType,
        category: this.carForm.category,
        pickupLocation: this.carForm.pickupLocation,
        dropoffLocation: this.carForm.dropoffLocation,
        pickupDate: this.carForm.pickupDate,
        pickupTime: this.carForm.pickupTime,
        dropoffDate: this.carForm.dropoffDate,
        dropoffTime: this.carForm.dropoffTime,
        confirmationNo: this.carForm.confirmationNo,
        passengers: this.getServicePassengersSnapshot(),
        netPrice: Number(this.carForm.netPrice) || 0,
        vatRate: Number(this.carForm.vatRate) || 0,
        vatAmount: this.carVatAmount,
        grossPrice: this.carGrossAmount,
        commissionAmount: Number(this.carForm.commissionAmount) || 0,
        supplierCost: Number(this.carForm.supplierCost) || 0,
        tourOperator: this.carForm.tourOperator,
        notes: this.carForm.notes || ""
      };

      this.saveServicePayload("cars", this.editingCarIndex, payload);
      this.closeCarDialog();
    },

    saveTransfer() {
      if (this.selectedReservationIndex < 0) return;

      if (
        !this.transferForm.satici ||
        !this.transferForm.from ||
        !this.transferForm.to ||
        !this.transferForm.date
      ) {
        alert("Please fill in the required transfer fields.");
        return;
      }

      var validExtraHours = [];
      var validExtraHourAmounts = [];

      if (
        this.transferForm.hasExtraHour &&
        Array.isArray(this.transferForm.extraHours)
      ) {
        for (
          var extraIndex = 0;
          extraIndex < this.transferForm.extraHours.length &&
          extraIndex < this.maxTransferExtraHourCount;
          extraIndex++
        ) {
          var extraHour = this.transferForm.extraHours[extraIndex];

          if (!extraHour || extraHour === "00:00") {
            continue;
          }

          var extraAmount = Array.isArray(this.transferForm.extraHourAmounts)
            ? Number(this.transferForm.extraHourAmounts[extraIndex]) || 0
            : 0;

          validExtraHours.push(extraHour);
          validExtraHourAmounts.push(extraAmount);
        }
      }

      var payload = {
        satici: this.transferForm.satici,
        tourOperator: this.transferForm.tourOperator,
        type: this.transferForm.type,
        serviceType: this.transferForm.serviceType || "Transfer",
        hasExtraHour: validExtraHours.length > 0,
        extraHours: validExtraHours,
        extraHourAmounts: validExtraHourAmounts,

        vehicleType: this.transferForm.vehicleType,
        plateNumber: this.transferForm.plateNumber,
        driverName: this.transferForm.driverName,
        driverPhone: this.transferForm.driverPhone,
        from: this.transferForm.from,
        to: this.transferForm.to,
        date: this.transferForm.date,
        time: this.transferForm.time,
        flightNumber: this.transferForm.flightNumber,
        flightTime: this.transferForm.flightTime,
        passengerCount: Number(this.transferForm.passengerCount) || 1,
        confirmationNo: this.transferForm.confirmationNo,
        passengers: this.getServicePassengersSnapshot(),
        netPrice: Number(this.transferForm.netPrice) || 0,
        vatRate: Number(this.transferForm.vatRate) || 0,
        vatAmount: this.transferVatAmount,
        grossPrice: this.transferGrossAmount,
        commissionAmount: Number(this.transferForm.commissionAmount) || 0,
        supplierCost: Number(this.transferForm.supplierCost) || 0,
        notes: this.transferForm.notes || ""
      };

      this.saveServicePayload("transfers", this.editingTransferIndex, payload);
      this.closeTransferDialog();
    },

    saveDailyTour() {
      if (this.selectedReservationIndex < 0) return;

      if (
        !this.dailyTourForm.satici ||
        !this.dailyTourForm.tourCode ||
        !this.dailyTourForm.tourName ||
        !this.dailyTourForm.date
      ) {
        alert("Please fill in the required daily tour fields.");
        return;
      }

      var payload = {
        satici: this.dailyTourForm.satici,
        tourCode: this.dailyTourForm.tourCode,
        tourName: this.dailyTourForm.tourName,
        date: this.dailyTourForm.date,
        time: this.dailyTourForm.time,
        meetingPoint: this.dailyTourForm.meetingPoint,
        program: this.dailyTourForm.program,
        passengers: this.getServicePassengersSnapshot(),
        netPrice: Number(this.dailyTourForm.netPrice) || 0,
        vatRate: Number(this.dailyTourForm.vatRate) || 0,
        vatAmount: this.dailyTourVatAmount,
        grossPrice: this.dailyTourGrossAmount,
        commissionAmount: Number(this.dailyTourForm.commissionAmount) || 0,
        supplierCost: Number(this.dailyTourForm.supplierCost) || 0,
        tourOperator: this.dailyTourForm.tourOperator,
        notes: this.dailyTourForm.notes || ""
      };

      this.saveServicePayload(
        "dailyTours",
        this.editingDailyTourIndex,
        payload
      );
      this.closeDailyTourDialog();
    },

    saveCruise() {
      if (this.selectedReservationIndex < 0) return;

      if (
        !this.cruiseForm.satici ||
        !this.cruiseForm.checkIn ||
        !this.cruiseForm.checkOut
      ) {
        alert("Please fill in the required cruise fields.");
        return;
      }

      var payload = {
        satici: this.cruiseForm.satici,
        tourOperator: this.cruiseForm.tourOperator,
        hotelName: this.cruiseForm.hotelName,
        city: this.cruiseForm.city,
        country: this.cruiseForm.country,
        checkIn: this.cruiseForm.checkIn,
        checkOut: this.cruiseForm.checkOut,
        rooms: Number(this.cruiseForm.rooms) || 1,
        guests: Number(this.cruiseForm.guests) || 1,
        roomType: this.cruiseForm.roomType,
        cabinType: this.cruiseForm.roomType,
        boardType: this.cruiseForm.boardType,
        confirmationNo: this.cruiseForm.confirmationNo,
        passengers: this.getServicePassengersSnapshot(),
        netPrice: Number(this.cruiseForm.netPrice) || 0,
        vatRate: Number(this.cruiseForm.vatRate) || 0,
        vatAmount: this.cruiseVatAmount,
        grossPrice: this.cruiseGrossAmount,
        commissionAmount: Number(this.cruiseForm.commissionAmount) || 0,
        supplierCost: Number(this.cruiseForm.supplierCost) || 0,
        notes: this.cruiseForm.notes || ""
      };

      this.saveServicePayload("cruises", this.editingCruiseIndex, payload);
      this.closeCruiseDialog();
    },

    saveOther() {
      if (this.selectedReservationIndex < 0) return;

      if (
        !this.otherForm.satici ||
        !this.otherForm.startDate ||
        !this.otherForm.endDate
      ) {
        alert("Please fill in the required other service fields.");
        return;
      }

      var payload = {
        satici: this.otherForm.satici,
        tourOperator: this.otherForm.tourOperator,
        startDate: this.otherForm.startDate,
        endDate: this.otherForm.endDate,
        description: this.otherForm.description,
        title: this.otherForm.title,
        passengers: this.getServicePassengersSnapshot(),
        netPrice: Number(this.otherForm.netPrice) || 0,
        vatRate: Number(this.otherForm.vatRate) || 0,
        vatAmount: this.otherVatAmount,
        grossPrice: this.otherGrossAmount,
        commissionAmount: Number(this.otherForm.commissionAmount) || 0,
        supplierCost: Number(this.otherForm.supplierCost) || 0,
        notes: this.otherForm.notes || ""
      };

      this.saveServicePayload("others", this.editingOtherIndex, payload);
      this.closeOtherDialog();
    },

    saveServicePayload(collectionName, editingIndex, payload) {
  if (!this.reservations[this.selectedReservationIndex][collectionName]) {
    this.$set(
      this.reservations[this.selectedReservationIndex],
      collectionName,
      []
    );
  }

  if (editingIndex !== null && editingIndex !== undefined) {
    var oldItem =
      this.reservations[this.selectedReservationIndex][collectionName][editingIndex] || {};

    payload = this.keepMiceServiceIdentity(oldItem, payload);

    this.$set(
      this.reservations[this.selectedReservationIndex][collectionName],
      editingIndex,
      payload
    );
  } else {
    this.reservations[this.selectedReservationIndex][collectionName].push(
      payload
    );
  }

  this.recalculateReservationTotal();
},
keepMiceServiceIdentity(oldItem, payload) {
  oldItem = oldItem || {};
  payload = payload || {};

  // MICE child PNR kimliği
  payload.pnrNo =
    oldItem.pnrNo ||
    oldItem.PNR_No ||
    oldItem.pNR_No ||
    oldItem.pnr ||
    payload.pnrNo ||
    payload.PNR_No ||
    "";

  payload.PNR_No =
    oldItem.PNR_No ||
    oldItem.pNR_No ||
    oldItem.pnrNo ||
    oldItem.pnr ||
    payload.PNR_No ||
    payload.pNR_No ||
    0;

  payload.pNR_No =
    oldItem.pNR_No ||
    oldItem.PNR_No ||
    oldItem.pnrNo ||
    oldItem.pnr ||
    payload.pNR_No ||
    payload.PNR_No ||
    0;

  // Concurrency / update için Guid
  payload.guid =
    oldItem.guid ||
    oldItem.Guid ||
    payload.guid ||
    payload.Guid ||
    "";

  payload.Guid =
    oldItem.Guid ||
    oldItem.guid ||
    payload.Guid ||
    payload.guid ||
    "";

  // Kalem update için IslemRef
  payload.islemRef =
    Number(
      oldItem.islemRef ||
      oldItem.IslemRef ||
      payload.islemRef ||
      payload.IslemRef ||
      0
    ) || 0;

  payload.IslemRef =
    Number(
      oldItem.IslemRef ||
      oldItem.islemRef ||
      payload.IslemRef ||
      payload.islemRef ||
      0
    ) || 0;

  payload.KaynakIslemRef =
    Number(
      oldItem.KaynakIslemRef ||
      oldItem.kaynakIslemRef ||
      payload.KaynakIslemRef ||
      payload.kaynakIslemRef ||
      0
    ) || 0;

  payload.kaynakIslemRef = payload.KaynakIslemRef;

  payload.cariKod =
    oldItem.cariKod ||
    oldItem.CariKod ||
    payload.cariKod ||
    payload.CariKod ||
    null;

  payload.CariKod = payload.cariKod;

  payload.FaturaBilgileri =
    oldItem.FaturaBilgileri ||
    oldItem.faturaBilgileri ||
    payload.FaturaBilgileri ||
    payload.faturaBilgileri ||
    null;

  payload.faturaBilgileri = payload.FaturaBilgileri;

  payload.toplamTL =
    oldItem.toplamTL ||
    oldItem.ToplamTL ||
    payload.toplamTL ||
    payload.ToplamTL ||
    null;

  payload.ToplamTL = payload.toplamTL;

  return payload;
},

    removeFlight(index) {
      this.removeServiceItem("flights", index);
    },

    removeHotel(index) {
      this.removeServiceItem("hotels", index);
    },

    removeCar(index) {
      this.removeServiceItem("cars", index);
    },

    removeTransfer(index) {
      this.removeServiceItem("transfers", index);
    },

    removeDailyTour(index) {
      this.removeServiceItem("dailyTours", index);
    },

    removeCruise(index) {
      this.removeServiceItem("cruises", index);
    },

    removeOther(index) {
      this.removeServiceItem("others", index);
    },

    removeServiceItem(collectionName, index) {
  if (!this.selectedReservation) return;
  if (!this.selectedReservation[collectionName]) return;

  var serviceNameMap = {
    flights: "Uçak kalemini",
    hotels: "Otel kalemini",
    cruises: "Cruise kalemini",
    cars: "Araç kiralama kalemini",
    transfers: "Transfer kalemini",
    dailyTours: "Daily tour kalemini",
    others: "Other kalemini"
  };

  var serviceName = serviceNameMap[collectionName] || "Bu kalemi";

  this.openDeleteConfirm(
    serviceName + " silmek istediğinize emin misiniz?",
    "service",
    collectionName,
    index
  );
},

    recalculateReservationTotal() {
      if (!this.selectedReservation) return;

      this.selectedReservation.total = this.sumServiceField(
        this.selectedReservation,
        "grossPrice"
      );
    },

    sumServiceField(reservation, field) {
      var total = 0;
      var collections = [
        reservation.flights || [],
        reservation.hotels || [],
        reservation.cars || [],
        reservation.transfers || [],
        reservation.dailyTours || [],
        reservation.cruises || [],
        reservation.others || []
      ];

      collections.forEach(function(list) {
        list.forEach(function(item) {
          total += Number(item[field]) || 0;
        });
      });

      return total;
    },

    resetFlightForm() {
      this.flightForm = this.getEmptyFlightForm();
    },

    resetHotelForm() {
      this.hotelForm = this.getEmptyHotelForm();
    },

    resetCarForm() {
      this.carForm = this.getEmptyCarForm();
      this.carDropoffAutoFill = true;
    },

    resetTransferForm() {
      this.transferForm = this.getEmptyTransferForm();
    },

    resetDailyTourForm() {
      this.dailyTourForm = this.getEmptyDailyTourForm();
    },

    resetCruiseForm() {
      this.cruiseForm = this.getEmptyCruiseForm();
    },

    resetOtherForm() {
      this.otherForm = this.getEmptyOtherForm();
    },

  }
};
</script>

<style scoped>
.service-form-main {
  padding-right: 18px;
}

.service-passenger-side {
  border-left: 1px solid #e6edf5;
  padding-left: 18px;
}

.side-passenger-panel {
  background: #f3f6fa;
  border-radius: 6px;
  padding: 14px;
  min-height: 100%;
}

.side-passenger-title {
  font-size: 13px;
  font-weight: 700;
  color: #4b6380;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
}

.side-passenger-item {
  background: #fff;
  border: 1px solid #e1e8f0;
  border-radius: 5px;
  padding: 10px 12px;
  margin-bottom: 8px;
}

.side-passenger-name {
  font-size: 14px;
  font-weight: 600;
  color: #263445;
}

.side-passenger-type {
  font-size: 12px;
  color: #718096;
  margin-top: 2px;
}

.side-passenger-empty {
  font-size: 13px;
  color: #718096;
}
.seller-inline-add .v-btn {
  background: transparent !important;
  box-shadow: none !important;
}
.seller-inline {
  display: flex;
  align-items: flex-end;
  width: 100%;
}

.seller-inline-input {
  flex: 1;
  min-width: 0;
}

.seller-inline-add {
  width: 40px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding-bottom: 2px;
}

.reservation-page {
  padding: 0 16px 16px;
  background: #f4f6f8;
  min-height: 100vh;
}

/* =========================
   LIST PAGE
========================= */
.reservation-toolbar {
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.14);
  border-radius: 10px;
}

.add-pnr-btn {
  border-radius: 10px;
  text-transform: none;
  font-weight: 600;
  box-shadow: none !important;
  letter-spacing: 0.2px;
}

.reservation-card {
  margin-top: 16px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #e7ebf0;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(15, 35, 66, 0.04);
}

.filter-wrapper {
  padding: 18px 18px 10px;
  border-bottom: 1px solid #edf1f5;
}

.search-field,
.status-field {
  margin-bottom: 12px;
}

.search-field /deep/ .v-input__slot,
.status-field /deep/ .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #d9e2ec;
  border-radius: 10px;
  background: #fff;
  min-height: 46px !important;
}

.status-field {
  padding-left: 12px;
}

.reservation-table /deep/ table {
  width: 100%;
}

.reservation-table /deep/ thead th {
  font-size: 12px;
  font-weight: 700;
  color: #6b778c;
  background: #fafbfd;
  border-bottom: 1px solid #ebeff3 !important;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.reservation-table /deep/ tbody td {
  font-size: 14px;
  color: #2c3e50;
  border-bottom: 1px solid #f0f3f6 !important;
  height: 72px;
  vertical-align: middle;
}

.pnr-link {
  color: #1976d2;
  font-weight: 700;
  text-decoration: none;
}

.price-cell {
  font-weight: 700;
  color: #1f2d3d;
}

/* =========================
   DIALOG / FORM SYSTEM
========================= */
.dialog-card {
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 14px 34px rgba(15, 35, 66, 0.12) !important;
  border: 1px solid #e8edf3;
  background: #fff;
}

.dialog-title {
  font-size: 28px;
  font-weight: 700;
  padding: 24px 28px 10px;
  color: #1f2937;
  line-height: 1.2;
}

.service-dialog-title {
  font-size: 24px;
  font-weight: 700;
  padding: 22px 24px 10px;
  color: #1f2937;
  line-height: 1.2;
  border-bottom: 1px solid #eef2f6;
  min-height: 72px;
  display: flex;
  align-items: center;
}

.dialog-card /deep/ .v-card__text {
  padding: 22px 24px 10px !important;
  background: #fff;
}

.dialog-actions {
  padding: 14px 24px 22px !important;
  border-top: 1px solid #eef2f6;
  background: #fcfdff;
}

.dialog-actions .v-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 10px;
  box-shadow: none !important;
  min-width: 108px;
}

.dialog-actions .v-btn:not(.primary):not(.info):not(.success):not(.warning):not(.error) {
  color: #475569;
}

/* Tüm form alanları için dikey ritim */
.dialog-card /deep/ .v-input {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.dialog-card /deep/ .v-input__control {
  min-height: 72px;
}

.dialog-card /deep/ .v-text-field,
.dialog-card /deep/ .v-select,
.dialog-card /deep/ .v-autocomplete,
.dialog-card /deep/ .v-textarea {
  width: 100%;
}

/* Normal text/select alanları */
.dialog-card /deep/ .v-text-field .v-input__slot,
.dialog-card /deep/ .v-select .v-input__slot,
.dialog-card /deep/ .v-autocomplete .v-input__slot {
  min-height: 50px !important;
  box-shadow: none !important;
  border-bottom: 1px solid #cfd8e3 !important;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.dialog-card /deep/ .v-text-field:hover .v-input__slot,
.dialog-card /deep/ .v-select:hover .v-input__slot,
.dialog-card /deep/ .v-autocomplete:hover .v-input__slot {
  border-bottom-color: #94a3b8 !important;
}

.dialog-card /deep/ .v-text-field.v-input--is-focused .v-input__slot,
.dialog-card /deep/ .v-select.v-input--is-focused .v-input__slot,
.dialog-card /deep/ .v-autocomplete.v-input--is-focused .v-input__slot {
  border-bottom: 2px solid #1976d2 !important;
}

.dialog-card /deep/ .v-label {
  color: #6b7280 !important;
  font-weight: 500;
}

.dialog-card /deep/ input,
.dialog-card /deep/ textarea {
  color: #1f2937 !important;
  font-size: 15px;
}

.dialog-card /deep/ .v-select__selection,
.dialog-card /deep/ .v-input input::placeholder,
.dialog-card /deep/ textarea::placeholder {
  color: #374151 !important;
}

/* Textarea daha düzenli */
.dialog-card /deep/ .v-textarea .v-input__slot {
  padding-top: 8px !important;
}

.dialog-card /deep/ .v-textarea textarea {
  line-height: 1.5;
}

/* Özel label */
.field-label-custom {
  font-size: 13px;
  font-weight: 700;
  color: #60738c;
  margin-bottom: 8px;
  line-height: 1.2;
  letter-spacing: 0.2px;
}

/* Date box */
.date-box-field {
  margin-top: 0;
}

.date-box-field /deep/ .v-input__slot {
  border: 1px solid #d9e2ec !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  min-height: 50px !important;
  background: #fff !important;
  padding: 0 14px !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.date-box-field /deep/ .v-input__slot:hover {
  border-color: #aab7c6 !important;
}

.date-box-field.v-input--is-focused /deep/ .v-input__slot,
.date-box-field /deep/ .v-input--is-focused .v-input__slot {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.08) !important;
}

.date-box-field /deep/ input {
  font-size: 15px;
  color: #1f2937 !important;
}

/* Pricing */
.pricing-title {
  margin-top: 10px;
  margin-bottom: 6px;
  padding-top: 24px;
  border-top: 1px solid #e9eef4;
  font-size: 22px;
  font-weight: 700;
  color: #445b78;
  line-height: 1.2;
}

/* artı butonu vs */
.passenger-plus-wrap {
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.passenger-add-btn {
  min-width: 48px;
  height: 48px;
  border-radius: 10px;
  box-shadow: none !important;
}

/* =========================
   PNR DIALOG CUSTOM LAYOUT
========================= */

.pnr-form-layout {
  max-width: 100%;
}

.pnr-row-single {
  margin-bottom: 8px;
}



/* PNR üst alanı biraz daha güçlü */
.pnr-row-single /deep/ .v-text-field .v-input__slot {
  min-height: 52px !important;
}











/* Tarihler pnr/customer altında düzenli dursun */
.pnr-form-layout > .pr-sm-2,
.pnr-form-layout > .pl-sm-2,
.pnr-form-layout > .pr-sm-3,
.pnr-form-layout > .pl-sm-3 {
  margin-bottom: 4px;
}

/* Date kutuları PNR dialog içinde biraz daha dengeli */
.pnr-form-layout .date-box-field /deep/ .v-input__slot {
  min-height: 48px !important;
}

/* Finans alanlarını gizlemek için yardımcı class */
.hidden-finance-row {
  display: none !important;
}

/* =========================
   DETAIL PAGE
========================= */
.detail-page {
  padding: 24px 8px 8px;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 24px;
}

.detail-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.back-btn {
  margin-top: 6px;
}

.detail-pnr-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.detail-pnr-code {
  font-size: 28px;
  font-weight: 700;
  color: #0f2342;
}

.detail-customer {
  margin-top: 10px;
  font-size: 18px;
  color: #64748b;
}

.detail-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.top-action-btn {
  text-transform: none;
  border-radius: 10px;
  box-shadow: none !important;
  font-weight: 600;
}

/* =========================
   SUMMARY
========================= */
.summary-cards {
  margin-bottom: 24px;
}

.summary-col {
  padding: 8px;
}

.summary-card {
  border: 1px solid #e1e7ef;
  border-radius: 16px;
  padding: 22px;
  min-height: 120px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(15, 35, 66, 0.04);
}

.grouped-summary-card {
  min-height: auto;
}

.group-card-title {
  font-size: 15px;
  font-weight: 700;
  color: #334155;
  margin-bottom: 16px;
}

.summary-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.summary-grid-5 {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
}

.summary-card--financial {
  padding: 16px;
}

.summary-card--financial .group-card-title {
  margin-bottom: 10px;
}

.summary-card--financial .summary-mini-box {
  padding: 12px 14px;
}

.summary-card--financial .summary-label {
  margin-bottom: 8px;
}

.summary-card--financial .summary-value {
  font-size: 18px;
}

.summary-payment-status {
  display: flex;
  align-items: center;
  min-height: 28px;
}

.summary-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

@media (max-width: 1400px) and (min-width: 961px) {
  .summary-grid-5 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.summary-mini-box {
  border: 1px solid #e8edf3;
  border-radius: 14px;
  padding: 18px;
  background: #fafcff;
}

.summary-label {
  font-size: 13px;
  letter-spacing: 1px;
  color: #64748b;
  margin-bottom: 14px;
}

.summary-value {
  font-size: 22px;
  font-weight: 700;
  color: #0f2342;
}

.gross-green {
  color: #10b981;
}

.summary-date {
  font-size: 18px;
  font-weight: 600;
  color: #0f2342;
}

/* =========================
   SERVICE BLOCKS
========================= */
.service-block {
  border: 1px solid #e1e7ef;
  border-radius: 18px;
  overflow: hidden;
  background: #fff;
  margin: 0 8px 20px;
  box-shadow: 0 4px 14px rgba(15, 35, 66, 0.04);
}

.service-block-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #edf1f5;
}

.service-block-title-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}

.service-block-icon {
  color: #7387a3;
  font-size: 20px;
}

.service-block-title {
  font-size: 18px;
  font-weight: 700;
  color: #0f2342;
}

.service-count {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #eef2f7;
  color: #7387a3;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.service-add-btn {
  text-transform: none;
  border-radius: 10px;
  box-shadow: none !important;
  font-weight: 600;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
}

.detail-table thead th {
  padding: 18px 22px;
  text-align: left;
  font-size: 12px;
  letter-spacing: 1px;
  color: #64748b;
  background: #fafbfd;
}

.detail-table tbody td {
  padding: 20px 22px;
  border-top: 1px solid #edf1f5;
  font-size: 14px;
  color: #1e293b;
}

.detail-action-cell {
  white-space: nowrap;
}

.sub-info-text {
  margin-top: 4px;
  font-size: 12px;
  color: #64748b;
}

.service-empty {
  text-align: center;
  color: #94a3b8;
  padding: 42px 16px;
  font-size: 16px;
}

/* =========================
   CHIPS
========================= */
.chip-open {
  background: #e7f7ef !important;
  color: #1f8b5f !important;
  border: 1px solid #bfe5cf;
}

.chip-closed {
  background: #eef2f7 !important;
  color: #5f6b7a !important;
  border: 1px solid #d9e0e7;
}

.chip-unpaid {
  background: #fff1f1 !important;
  color: #d9534f !important;
  border: 1px solid #f2caca;
}

.chip-partial {
  background: #fff8e8 !important;
  color: #b9811f !important;
  border: 1px solid #ecd59c;
}

.chip-paid {
  background: #e7f7ef !important;
  color: #1f8b5f !important;
  border: 1px solid #bfe5cf;
}
.money-cell {
  text-align: center !important;
  white-space: nowrap;
  vertical-align: middle !important;
}

.gross-header,
.gross-cell {
  width: 135px !important;
  min-width: 135px !important;
  max-width: 135px !important;
  text-align: center !important;
  padding-left: 6px !important;
  padding-right: 6px !important;
}

.detail-table th.gross-header {
  text-align: center !important;
}

.detail-table td.gross-cell {
  text-align: center !important;
}

.money-chip {
  margin: 0 !important;
  height: 26px !important;
  min-width: 96px;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: #e8f5e9 !important;
  color: #1b5e20 !important;
  border: 1px solid #a5d6a7 !important;
  border-radius: 14px !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  letter-spacing: 0.2px;
  box-shadow: 0 2px 8px rgba(46, 125, 50, 0.16);
}

.money-chip /deep/ .v-chip__content {
  height: 26px !important;
  padding: 0 10px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* =========================
   RESPONSIVE
========================= */
@media (max-width: 960px) {
  .detail-header {
    flex-direction: column;
  }

  .detail-actions {
    width: 100%;
  }

  .summary-grid-3,
  .summary-grid-5,
  .summary-grid-2 {
    grid-template-columns: 1fr;
  }

  .dialog-card /deep/ .v-card__text {
    padding: 20px 18px 8px !important;
  }

  .dialog-title {
    padding: 20px 20px 10px;
    font-size: 24px;
  }

  .service-dialog-title {
    padding: 18px 18px 10px;
    font-size: 22px;
    min-height: 64px;
  }

  .dialog-actions {
    padding: 12px 18px 18px !important;
  }

  .customer-row {
    margin-bottom: 14px;
  }
}

@media (max-width: 600px) {
  .status-field {
    padding-left: 0;
  }

  .add-pnr-btn {
    min-width: auto;
    padding: 0 12px;
  }

  .dialog-title {
    font-size: 22px;
  }

  .service-dialog-title {
    font-size: 20px;
  }

  .detail-pnr-code {
    font-size: 24px;
  }

  .summary-card {
    min-height: auto;
  }

  .detail-table thead {
    display: none;
  }

  .detail-table tbody td {
    display: block;
    width: 100%;
    padding: 10px 16px;
    border-top: none;
  }

  .detail-table tbody tr {
    display: block;
    border-top: 1px solid #edf1f5;
    padding: 10px 0;
  }

  .dialog-actions .v-btn {
    min-width: 92px;
  }

  .pnr-row-single {
    margin-bottom: 6px;
  }

  
}

/* Seller add button clean */
.seller-inline-add /deep/ .v-btn {
  background: transparent !important;
  box-shadow: none !important;
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
  margin: 0 0 8px 6px !important;
}

.seller-inline-add /deep/ .v-btn::before {
  display: none !important;
}

.seller-inline-add /deep/ .v-icon {
  color: #1976d2 !important;
  font-size: 24px !important;
}

/* Table hover premium */
.detail-table tbody tr:hover {
  background: #f8fafc;
}

/* Safe long object/json text kırılması */
.detail-table td {
  vertical-align: middle;
  word-break: normal;
}

/* Customer cari dropdown kaybolmasın */
.cari-clean-row,
.cari-clean-row * {
  overflow: visible !important;
}

.cari-clean-row {
  position: relative;
  z-index: 20;
}
.service-passenger-line {
  font-size: 13px;
  line-height: 1.4;
  color: #263445;
}
.closed-reservation-row {
  opacity: 0.55;
  background: #f3f5f7 !important;
}

.closed-reservation-row .pnr-link {
  color: #8a94a3 !important;
  pointer-events: none;
  text-decoration: line-through;
}
.service-block {
  position: relative;
}

.service-block-colored::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 4px;
  width: 100%;
  border-radius: 18px 18px 0 0;
  z-index: 2;
}

.service-block--passengers::before {
  background: linear-gradient(90deg, #6366f1, #818cf8);
}

.service-block--flights::before {
  background: linear-gradient(90deg, #2563eb, #38bdf8);
}

.service-block--hotels::before {
  background: linear-gradient(90deg, #10b981, #34d399);
}

.service-block--cruises::before {
  background: linear-gradient(90deg, #8b5cf6, #c084fc);
}

.service-block--cars::before {
  background: linear-gradient(90deg, #f59e0b, #fbbf24);
}

.service-block--transfers::before {
  background: linear-gradient(90deg, #06b6d4, #22d3ee);
}

.service-block--dailyTours::before {
  background: linear-gradient(90deg, #ef4444, #fb7185);
}

.service-block--others::before {
  background: linear-gradient(90deg, #64748b, #94a3b8);
}
.reservation-count-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

.reservation-count-chip {
  margin: 0 !important;
  height: 28px !important;
  background: #eef6ff !important;
  color: #1976d2 !important;
  border: 1px solid #bbdefb !important;
  font-weight: 700 !important;
  border-radius: 14px !important;
}

.reservation-count-chip /deep/ .v-chip__content {
  height: 28px !important;
  padding: 0 12px !important;
}
.detail-hero {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 22px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding: 24px;
  border-radius: 22px;
  background:
    radial-gradient(circle at top left, rgba(59, 130, 246, 0.22), transparent 32%),
    linear-gradient(135deg, #ffffff 0%, #f8fbff 48%, #eef6ff 100%);
  border: 1px solid #dfe8f5;
  box-shadow: 0 12px 32px rgba(15, 35, 66, 0.08);
  overflow: hidden;
}

.detail-hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 5px;
  width: 100%;
  background: linear-gradient(90deg, #2563eb, #38bdf8, #22c55e);
}

.detail-hero-left {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  min-width: 360px;
  flex: 1;
}

.detail-hero-back {
  width: 42px !important;
  height: 42px !important;
  margin: 2px 0 0 0 !important;
  background: #ffffff !important;
  border: 1px solid #dbe6f3;
  box-shadow: 0 6px 16px rgba(15, 35, 66, 0.08);
}

.detail-hero-back .v-icon {
  color: #64748b !important;
}

.detail-hero-main {
  flex: 1;
  min-width: 0;
}

.detail-hero-eyebrow {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  margin-bottom: 8px;
  border-radius: 999px;
  background: #eaf3ff;
  color: #1976d2;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.detail-hero-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.detail-hero-pnr {
  font-size: 34px;
  line-height: 1.1;
  font-weight: 900;
  color: #0f2342;
  letter-spacing: -0.8px;
}

.detail-hero-chip {
  margin: 0 !important;
  height: 26px !important;
}

.detail-hero-customer {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 10px;
  color: #475569;
  font-size: 17px;
  font-weight: 600;
}

.detail-hero-customer .v-icon {
  color: #64748b;
}

.detail-hero-info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 18px;
}

.detail-hero-info-box {
  min-width: 150px;
  padding: 12px 14px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid #e2eaf5;
}

.detail-hero-info-label {
  margin-bottom: 6px;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.7px;
}

.detail-hero-info-value {
  color: #0f2342;
  font-size: 14px;
  font-weight: 800;
}

.detail-hero-money {
  color: #10b981;
  font-size: 16px;
}

.detail-hero-actions {
  display: flex;
  align-content: flex-start;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
  max-width: 780px;
}

.detail-hero-action-btn {
  height: 38px !important;
  margin: 0 !important;
  border-radius: 11px !important;
  text-transform: none !important;
  font-weight: 800 !important;
  letter-spacing: 0 !important;
  box-shadow: none !important;
}

.detail-hero-action-btn.v-btn--outline {
  background: #ffffff !important;
  border-color: #cbd5e1 !important;
  color: #0f2342 !important;
}

.detail-hero-more-btn {
  width: 40px !important;
  height: 38px !important;
  min-width: 40px !important;
  margin: 0 !important;
  border-radius: 11px !important;
  background: #ffffff !important;
  border-color: #cbd5e1 !important;
  color: #0f2342 !important;
}

.detail-hero-menu-list {
  min-width: 245px;
  padding: 6px 0;
}

.detail-hero-menu-list .v-list__tile {
  min-height: 44px;
}

.detail-hero-menu-list .v-list__tile__action {
  min-width: 38px;
}
.summary-card {
  position: relative;
  overflow: hidden;
}

.summary-card-colored::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 4px;
  width: 100%;
  border-radius: 16px 16px 0 0;
  z-index: 2;
}

.summary-card--financial::before {
  background: linear-gradient(90deg, #2563eb, #6366f1, #8b5cf6);
}

.summary-card--travel::before {
  background: linear-gradient(90deg, #06b6d4, #22c55e);
}
.pnr-code-cell {
  vertical-align: middle;
}

.pnr-with-service-icon {
  display: flex;
  align-items: center;
  gap: 9px;
}

.service-type-icon {
  width: 30px;
  height: 30px;
  min-width: 30px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eef5ff;
  border: 1px solid #d7e8ff;
}

.service-type-icon .v-icon {
  color: inherit;
}

.service-type-icon--flight {
  color: #1e88e5;
  background: #eaf4ff;
  border-color: #cfe6ff;
}

.service-type-icon--hotel {
  color: #ef5350;
  background: #fff0f0;
  border-color: #ffd6d6;
}

.service-type-icon--transfer {
  color: #fb8c00;
  background: #fff5e6;
  border-color: #ffe1b8;
}

.service-type-icon--tour {
  color: #8e24aa;
  background: #f8edff;
  border-color: #ead0ff;
}

.service-type-icon--car {
  color: #43a047;
  background: #edfff1;
  border-color: #ccefd4;
}

.service-type-icon--cruise {
  color: #00acc1;
  background: #e7fbff;
  border-color: #c9f3fa;
}

.service-type-icon--other {
  color: #607d8b;
  background: #eef3f5;
  border-color: #d8e2e6;
}

.takip-no-cell {
  vertical-align: middle;
}

.takip-no-badge {
  color: #5e60ce;
  background: #f1f1ff;
  border: 1px solid #dcdcfe;
  border-radius: 999px;
  padding: 4px 10px;
  font-weight: 700;
  display: inline-block;
}

.service-block-colored::before {
  display: none !important;
}

.summary-card--travel::before {
  display: none !important;
}

.summary-card--financial::before {
  display: block !important;
  height: 5px !important;
  background: linear-gradient(90deg, #10b981, #06b6d4, #2563eb) !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.35);
}

.summary-card--financial {
  border-color: #b7f1d5 !important;
  box-shadow: 0 10px 28px rgba(16, 185, 129, 0.14) !important;
}

.summary-card--financial .group-card-title,
.summary-card--financial .group-card-title .v-icon {
  color: #047857 !important;
}

.summary-card--financial .summary-mini-box {
  background: linear-gradient(180deg, #ffffff 0%, #f0fdf4 100%) !important;
  border-color: #d1fae5 !important;
}
.invoice-status-chip {
  background: #e8f5e9 !important;
  color: #1b5e20 !important;
  border: 1px solid #a5d6a7 !important;
  font-weight: 600;
}
.transfer-extra-hour-section {
  margin-top: 8px;
  margin-bottom: 10px;
  padding: 12px 14px;
  border: 1px solid #e3e9f0;
  border-radius: 8px;
  background: #f8fafc;
}

.transfer-extra-hour-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.transfer-extra-hour-switch {
  margin: 0;
  padding: 0;
}

.transfer-extra-hour-add {
  margin: 0;
}

.transfer-extra-hour-content {
  margin-top: 14px;
}

.transfer-extra-hour-row {
  margin-bottom: 10px;
}
.pnr-list-cell-wrap {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.list-invoice-icon {
  font-size: 16px !important;
  color: #2e7d32 !important;
  opacity: 0.85;
  cursor: default;
}

.list-invoice-icon:hover {
  opacity: 1;
}
</style>
